webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(331);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularResource = __webpack_require__(409);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularCookies = __webpack_require__(411);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	__webpack_require__(413);
	
	var _common = __webpack_require__(415);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(638);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(676);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(681);
	
	__webpack_require__(682);
	
	__webpack_require__(689);
	
	var _ngFileUpload = __webpack_require__(691);
	
	var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);
	
	__webpack_require__(693);
	
	__webpack_require__(695);
	
	__webpack_require__(698);
	
	__webpack_require__(699);
	
	var _angularDynamicNumber = __webpack_require__(700);
	
	var _angularDynamicNumber2 = _interopRequireDefault(_angularDynamicNumber);
	
	var _angularMaterial = __webpack_require__(701);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularDynamicNumber2.default, _angularMaterial2.default, _angularUiRouter2.default, _angularResource2.default, _ngFileUpload2.default, 'ui.bootstrap', 'vcRecaptcha', 'rzModule', 'BotDetectCaptcha', _common2.default, _components2.default, _angularCookies2.default]).config(["$cookiesProvider", "$httpProvider", "$locationProvider", "captchaSettingsProvider", function ($cookiesProvider, $httpProvider, $locationProvider, captchaSettingsProvider) {
	  "ngInject";
	
	  $cookiesProvider.defaults.secure = true;
	  $cookiesProvider.defaults.samesite = 'none';
	  $httpProvider.defaults.withCredentials = true;
	  $locationProvider.html5Mode(true).hashPrefix('!');
	  captchaSettingsProvider.setSettings({ captchaEndpoint: '/captcha/simple-captcha-endpoint' });
	}]).component('app', _app2.default);

/***/ }),
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(416);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _infoWidget = __webpack_require__(445);
	
	var _infoWidget2 = _interopRequireDefault(_infoWidget);
	
	var _errorWidget = __webpack_require__(453);
	
	var _errorWidget2 = _interopRequireDefault(_errorWidget);
	
	var _pageNavigation = __webpack_require__(463);
	
	var _pageNavigation2 = _interopRequireDefault(_pageNavigation);
	
	var _modelView = __webpack_require__(469);
	
	var _modelView2 = _interopRequireDefault(_modelView);
	
	var _fileUpload = __webpack_require__(559);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _menuElements = __webpack_require__(596);
	
	var _menuElements2 = _interopRequireDefault(_menuElements);
	
	var _loadedModel = __webpack_require__(566);
	
	var _loadedModel2 = _interopRequireDefault(_loadedModel);
	
	var _setThicknessDirective = __webpack_require__(597);
	
	var _setThicknessDirective2 = _interopRequireDefault(_setThicknessDirective);
	
	var _radioControl = __webpack_require__(598);
	
	var _radioControl2 = _interopRequireDefault(_radioControl);
	
	var _selectControl = __webpack_require__(604);
	
	var _selectControl2 = _interopRequireDefault(_selectControl);
	
	var _solverProgress = __webpack_require__(610);
	
	var _solverProgress2 = _interopRequireDefault(_solverProgress);
	
	var _snapshotWidget = __webpack_require__(616);
	
	var _snapshotWidget2 = _interopRequireDefault(_snapshotWidget);
	
	var _sessionNotification = __webpack_require__(622);
	
	var _sessionNotification2 = _interopRequireDefault(_sessionNotification);
	
	var _captchaWithFallback = __webpack_require__(630);
	
	var _captchaWithFallback2 = _interopRequireDefault(_captchaWithFallback);
	
	__webpack_require__(636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_navbar2.default, _infoWidget2.default, _errorWidget2.default, _pageNavigation2.default, _modelView2.default, _fileUpload2.default, _loadedModel2.default, _setThicknessDirective2.default, _menuElements2.default, _radioControl2.default, _selectControl2.default, _solverProgress2.default, _snapshotWidget2.default, _sessionNotification2.default, _captchaWithFallback2.default]).name;
	
	exports.default = commonModule;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(417);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = navbarModule;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(418);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(419);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-wrapper\">\n  <nav class=\"main-navigation\">\n  <a class=\"item item-session\"\n     ng-class=\"{ active: $ctrl.isStateActive(element.state),\n                disabled: $ctrl.isDisabled(element) && element.isValid()\n               }\"\n      ui-sref=\"{{ element.state }}\"\n      ng-repeat=\"element in $ctrl.getMenuElements()\">\n      <div class=\"text-container\">\n      <span class=\"icon easyblank-icon\">{{ element.letter }}</span>\n      <span class=\"text\">\n          <div class=\"text-label\">\n            {{ element.name }}\n          </div>\n      </span>\n      </div>\n      <div ng-class=\"{report: element.state === 'report'}\"  class=\"triangle\"></div>\n      <div ng-class=\"{report: element.state === 'report'}\" class=\"triangle-border\"></div>\n  </a>\n  <div ng-class=\"{'report': element.state === 'report'}\" class=\"item button-container\">\n    <div class=\"button-container-wrapper\">\n      <button ng-if=\"$ctrl.model.hasMesh()\" type=\"button\"\n              ng-click=\"$ctrl.clearSession()\" class=\"btn btn-default help-button\">\n        Clear Session\n      </button>\n      <info-widget\n        topic=\"nav\">\n      </info-widget>\n    </div>\n  </div>\n  </nav>\n</div>\n<div class=\"main-navigation-border\"></div>\n\n"

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	    function NavbarController($state, $scope, LoadedModel, $rootScope, MenuElements) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, NavbarController);
	
	        this._$state = $state;
	        this.model = LoadedModel;
	        this._$scope = $scope;
	        this._$rootScope = $rootScope;
	        this._menuClass = MenuElements;
	        this._menuElements = MenuElements.get();
	
	        $scope.$on('thicknessChanged', function (event, data) {
	            //this._menuClass.updateActiveStates(data.step);
	            setTimeout(function () {
	                $scope.$apply();
	            });
	        });
	
	        ['solverFinished', 'updateSteps'].forEach(function (eventName) {
	            $scope.$on(eventName, function (event, data) {
	                if (!data.error) {
	                    _this._menuClass.updateActiveStates(data.step);
	                    setTimeout(function () {
	                        $scope.$apply();
	                    });
	                }
	            });
	        });
	    }
	
	    (0, _createClass3.default)(NavbarController, [{
	        key: 'getMenuElements',
	        value: function getMenuElements() {
	            return this._menuElements;
	        }
	    }, {
	        key: 'isStateActive',
	        value: function isStateActive(stateName) {
	            return this._$state.$current.name === stateName;
	        }
	    }, {
	        key: 'isDisabled',
	        value: function isDisabled(el) {
	            var activeState = el.activeState;
	            if (!activeState) {
	                return false;
	            } else {
	                return this._menuClass.activeStates.indexOf(activeState) === -1;
	            }
	        }
	    }, {
	        key: 'clearSession',
	        value: function clearSession() {
	            this.model.clearSession();
	            this._menuClass.resetStates();
	        }
	    }]);
	    return NavbarController;
	}();
	
	NavbarController.$inject = ['$state', '$scope', 'LoadedModel', '$rootScope', 'MenuElements'];
	
	exports.default = NavbarController;

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(442);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".menu-wrapper{text-align:center;display:inline-block;background-color:silver;width:100%}.main-navigation{width:1500px;border-bottom:1px;border-color:#000;display:inline-block}.main-navigation .button-container-wrapper{padding-top:8px;color:#111}.main-navigation .button-container-wrapper button,.main-navigation .button-container-wrapper button:hover{background-color:#b9b9b9;border-color:#111;color:#111}.main-navigation .item-session{width:14.666%}.main-navigation .item-session .triangle{margin-left:34px!important}.main-navigation .item-session .triangle-border{margin-left:35px!important}.main-navigation .item-nosession{width:20%}.main-navigation .item{color:#606060;display:inline-block;height:50px;background-color:silver;text-decoration:none!important}.main-navigation .item .triangle{border-color:transparent transparent transparent silver;margin-left:75px;z-index:1}.main-navigation .item .triangle,.main-navigation .item .triangle-border{height:0;border-style:solid;border-width:25px 0 25px 15px;display:inline-block;position:absolute}.main-navigation .item .triangle-border{border-color:transparent transparent transparent #000;margin-left:76px}.main-navigation .item .triangle-border.report,.main-navigation .item .triangle.report{display:none}.main-navigation .item .text-container{display:inline-block}.main-navigation .item.button-container{position:absolute;width:12%;border-left:1px solid #000}.main-navigation .item.clear-session{height:auto}.main-navigation .item.report{border-left:1px solid #000}.main-navigation .item:hover{color:#606060}.main-navigation .active{background-color:#406494;color:#fff}.main-navigation .active:hover{color:#fff}.main-navigation .active .triangle{border-color:transparent transparent transparent #406494}.main-navigation .active .triangle-border{border-color:transparent transparent transparent #000}.main-navigation .disabled .triangle,.main-navigation .disabled .triangle-border{display:none}.main-navigation .disabled{color:#b6b6b6;background-color:#d4d3d3;pointer-events:none}.main-navigation .icon{font-size:30px;padding-top:8px;padding-right:24px}.main-navigation .text{font-size:18px;width:70px;margin-right:33px;display:inline-block}.main-navigation .text .text-label{position:absolute;top:11px}.main-navigation-border{width:100%;height:1px;background-color:#000}", ""]);
	
	// exports


/***/ }),
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _infoWidget = __webpack_require__(446);
	
	var _infoWidget2 = _interopRequireDefault(_infoWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var infoWidgetModule = _angular2.default.module('info-widget', [_angularUiRouter2.default]).component('infoWidget', _infoWidget2.default).name;
	
	exports.default = infoWidgetModule;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _infoWidget = __webpack_require__(447);
	
	var _infoWidget2 = _interopRequireDefault(_infoWidget);
	
	var _infoWidget3 = __webpack_require__(448);
	
	var _infoWidget4 = _interopRequireDefault(_infoWidget3);
	
	__webpack_require__(451);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var infoWidgetComponent = {
	    restrict: 'E',
	    bindings: {
	        topic: '@',
	        label: '@',
	        link: '@'
	    },
	    template: _infoWidget2.default,
	    controller: _infoWidget4.default
	};
	
	exports.default = infoWidgetComponent;

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "<button ng-if=\"!$ctrl.link\" type=\"button\" ng-click=\"$ctrl.openHelpWindow()\" class=\"btn btn-default help-button\">\n    <span class=\"easyblank-icon\">H</span>\n\n    <span ng-if=\"$ctrl.label\" class=\"button-label-container\">\n      <span class=\"button-label\">Help</span>\n    </span>\n</button>\n<a ng-click=\"$ctrl.openHelpWindow()\" ng-if=\"$ctrl.link\">{{ $ctrl.link }} </a>\n\n\n"

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _helpModal = __webpack_require__(449);
	
	var _helpModal2 = _interopRequireDefault(_helpModal);
	
	var _helpModal3 = __webpack_require__(450);
	
	var _helpModal4 = _interopRequireDefault(_helpModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfoWidgetController = function () {
	    function InfoWidgetController($uibModal) {
	        (0, _classCallCheck3.default)(this, InfoWidgetController);
	
	        this._$uibModal = $uibModal;
	    }
	
	    (0, _createClass3.default)(InfoWidgetController, [{
	        key: 'openHelpWindow',
	        value: function openHelpWindow() {
	            var _this = this;
	
	            this._$uibModal.open({
	                animation: false,
	                template: _helpModal4.default,
	                controllerAs: '$ctrl',
	                size: 'lg',
	                resolve: {
	                    type: function type() {
	                        return _this.topic;
	                    }
	                },
	                controller: _helpModal2.default
	            });
	        }
	    }]);
	    return InfoWidgetController;
	}();
	
	InfoWidgetController.$inject = ['$uibModal'];
	
	exports.default = InfoWidgetController;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpModalController = function () {
	    function HelpModalController($uibModalInstance, type) {
	        (0, _classCallCheck3.default)(this, HelpModalController);
	
	        this.type = type;
	        this._$uibModalInstance = $uibModalInstance;
	    }
	
	    (0, _createClass3.default)(HelpModalController, [{
	        key: 'cancel',
	        value: function cancel() {
	            this._$uibModalInstance.close();
	        }
	    }, {
	        key: 'next',
	        value: function next() {}
	    }]);
	    return HelpModalController;
	}();
	
	HelpModalController.$inject = ['$uibModalInstance', 'type'];
	
	exports.default = HelpModalController;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content help-modal\">\n  <form name=\"form\" novalidate class=\"css-form\">\n  </form>\n</div>\n\n<div class=\"modal-content help-modal\">\n<div class=\"css-form\">\n<div class=\"modal-body\" id=\"modal-body\">\n  <div ng-if=\"$ctrl.type === 'part'\">\n\n    <p>\n      <strong>Part</strong>\n      <strong></strong>\n    </p>\n    <p>\n      <strong>Material</strong>\n      <br/>\n      The selected material defines the parameters for the Ludwik model. The\n      displayed material name is combined with corresponding value for Tensile\n      Strength.\n    </p>\n    <p>\n      <strong>Geometry</strong>\n    </p>\n    <p>\n      The geometry to be unfolded may be a surface or a solid.\n      <br/>\n      There are three options to define which surface of the part is described by\n      the imported geometry:\n      <br/>\n      <strong><em>Lower surface of part</em></strong>\n      <br/>\n      The material gauge thickness is added in z-direction.\n      <br/>\n      <strong><em>Mid surface of part</em></strong>\n      <br/>\n      The geometry defines the middle layer.\n      <br/>\n      <strong><em>Upper surface of part</em></strong>\n      <br/>\n      The material gauge thickness is added in the negative z-direction.    <strong></strong>\n    </p>\n    <p>\n      The yellow ring of the marker gives an indication in which direction\n      related to the surface (circular area of the marker) the middle layer of\n      the sheet should be expected.\n    </p>\n    <p>\n      <strong>Thickness</strong>\n      <br/>\n      Material gauge thickness\n    </p>\n  </div>\n  <div ng-if=\"$ctrl.type === 'feasibility'\">\n    <p>\n      <strong>Feasibility</strong>\n    </p>\n    <table border=\"0\" cellspacing=\"0\" cellpadding=\"0\" width=\"0\">\n      <tbody>\n      <tr>\n        <td>\n          <p>\n            Choose the forming process that matches the intended\n            process best:\n            <br/>\n            <strong><em>Crash Form</em></strong>\n            <br/>\n            No restraining force is applied during forming process.\n            <br/>\n            <strong><em>Deep Draw</em></strong>\n            <br/>\n            Some restraining force between crash forming and stretch\n            forming is applied.\n            <br/>\n            <strong><em>Stretch Form</em></strong>\n            <br/>\n            The outer boundary is completely fixed by the binder during\n            forming process.\n          </p>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n  <div ng-if=\"$ctrl.type === 'blank'\">\n    <p>\n      <strong>\n        Blank\n      </strong>\n    </p>\n    <p>\n      <p>\n        Once the blank outline corresponding to the input geometry is computed,\n        additional material might be desired (e.g. to take the addendum into\n        account) before the coil layout optimization is computed\n      </p>\n    </p>\n  </div>\n  <div ng-if=\"$ctrl.type === 'nest'\">\n    <p><strong>Nest</strong></p>\n    <p><strong>Coil</strong> <strong>definition</strong></p>\n    <p>These input parameters are related to the coil:</p>\n    <p><strong>Material Price</strong><br /> This parameter is needed to compute the material cost per part/blank.</p>\n    <p><strong>Coil Edge</strong><br /> defines the extra material that might be required along the coil on both sides.</p>\n    <p>Note: internally two parameters are fixed:</p>\n    <p>Max. Pitch is set to 5000mm.</p>\n    <p>Max. Width is set to 2000mm.</p>\n    <p><strong>Bridge span</strong><strong><br /> </strong>defines the distance between two neighboring shapes. If negative values are entered, overlapping is the result.</p>\n    <p>&nbsp;</p>\n    <p><strong>Nest conditions</strong></p>\n    <p>For <strong>nesting</strong> the options are:</p>\n    <ul>\n      <li><strong> one up</strong> (all shapes have same position and orientation on the coil)</li>\n      <li><strong> two up</strong> (pairs of two shapes are optimized)</li>\n      <li><strong> up/down</strong> (pairs of two shapes are optimized whereas one of them is mirrored)</li>\n    </ul>\n    <p><strong>Orientation</strong><br /> &bull; Free: allows the optimizer to take any rotation &nbsp;&nbsp;angle<br /> &bull; Angle: a defined orientation angle can be set in &nbsp;&nbsp;the range of 0&deg;...360&deg;.</p>\n    <p><strong>Result values<br /> <strong>Material Cost<br /> </strong></strong>These costs are calculated depending on the cost input in the coil-editor.<strong><br /> Utilization</strong><br /> The utilization is the ratio of the shape area compared to the area of one blank considering the original area of one blank as computed in the previous step. This value can be greater than 100% if the edited shape area is smaller than the computed blank. Holes are ignored and do not affect the shape area.</p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n  </div>\n  <div ng-if=\"$ctrl.type === 'nav'\">\n    <p>\n      <strong>\n        Main navigation\n      </strong>\n    </p>\n    <p>\n      Welcome to EasyBlank.\n      <br />\n      The purpose of this software is to calculate blank shapes from 3D geometry files of sheet metal stamped parts. The calculated blank shape is then nested and optimized into a coil layout, estimating material costs for your sheet metal tooling project. To use this service you need to upload a geometry file in .igs or .stl format using the\n      <em>\n        Part\n      </em>\n      option or just drag &amp; drop the file into the viewer area.\n      <br />\n      There is one example file provided to download from\n      <u>\n        <a href=\"https://www.autoform.com/en/download/igs/easyblank_example_01.igs\">\n          https://www.autoform.com/en/download/igs/easyblank_example_01.igs\n        </a>\n      </u>\n      .\n      <br />\n      If the material gauge thickness was taken into account in your CAD model to build a solid, one surface is extracted automatically. The overall size of the part shouldn't be less than 10mm in order to generate accurate results. The part is automatically tipped into press position. Independent of any further rotation, the part is analyzed in the tipped position.\n    </p>\n    <p>\n      To get a quick idea of the blank shape and the corresponding layout, it is possible to proceed after the upload without inputting additional information, by simply following these basic steps:\n      <br />\n      &bull; 'Feasibility' to compute the thinning and formability\n      <br />\n      &bull; 'Blank' to view the calculated blank\n      <br />\n      &bull; 'Nest' to view the corresponding coil layout\n      <br />\n      To receive the calculated blank shape as an .igs CAD file and a formal report in .xls format containing images and all results, it is necessary to go to the 'Report' page and request a report.\n      <br />\n      The blank outline comes in tipped orientation.\n    </p>\n    <p>\n      <b>Note:</b> Only one browser session at a time is allowed. The session will be closed automatically after 20 minutes if there hasn’t been any activity. It isn’t possible to run more than 3 sessions in parallel with the same network ID. For the time between two reports and between two times loading a part at least one minute is necessary.\n    </p>\n    <p>\n      Mouse control in 3D view: Rotate &ndash; left mouse button, Move (pan) &ndash; right mouse button, Zoom - wheel\n    </p>\n    <p><strong>Contact</strong></p>\n    <p>Please share your thoughts, insights and suggestions for improvements - they are extremely valuable and appreciated!</p>\n    <p>Just drop us a line at <br /> <a href=\"mailto:easyblank.feedback@autoform.com\">easyblank.feedback@autoform.com</a></p>\n    <info-widget\n      topic=\"terms\"\n      link=\"Terms and conditions\">\n      link=\"Terms and conditions\">\n    </info-widget>\n    <!--<a ng-click=\"$ctrl.openTermsConditions()\">Terms And Conditions</a>-->\n  </div>\n  <div ng-if=\"$ctrl.type === 'report'\">\n    <p><strong>Report</strong></p>\n    <p><strong>Select pictures for report</strong><br /> The report contains up to four pictures which can be defined by the user using the snapshot button on every page. If there are more than four pictures available please select pictures using the check box.</p>\n    <p>Three default pictures are created automatically.</p>\n    <p>&nbsp;</p>\n    <p>Before the reports can be requested, the additional input fields must be filled in:</p>\n    <p><strong><em>Number of parts</em></strong><br /> is used for computation of total costs.<br /> <strong><em>Scrap value</em></strong> is used for calculation of material costs. The scrap is the difference between the coil segment and the original size of the part and holes are not considered as scrap.</p>\n    <p>&nbsp;</p>\n  </div>\n  <div ng-if=\"$ctrl.type === 'userAgreemnt'\">\n    <p align=\"center\" class=\"Stil2\">LICENSE AGREEMENT </p>\n    <p class=\"Stil2\">1.       License Grant</p>\n    <p class=\"Stil1\">Subject to the terms of this Agreement, AutoForm Engineering GmbH (hereinafter AutoForm) herewith grants Customer for internal tests to setup und perform simulations and view the respective results on screen the following rights:</p>\n    <p class=\"Stil1\"> a)  a  revocable, non-exclusive, non-transferable, royalty&ndash;free and worldwide license to use the object code of EasyBlank software (&ldquo;EasyBlank Software&rdquo;) including updates, patches and related graphics and documentation and including identified third-party software but excluding the software module EasyBlank native CAD file import (&ldquo;EasyBlank Native CAD File Import License&rdquo;)  during a period of minimum one (1) day to maximum six (6) months, depending on the exact date of each individual download. After expiry of each license term, EasyBlank Software needs to be downloaded again.    </p>\n    <p class=\"Stil1\">b) In addition to the license granted in Section a) above and subject to receipt of Customer&rsquo;s respective order and Customer&rsquo;s payment of the respective license fee AutoForm grants Customer a non-exclusive, non-transferable, royalty-bearing, worldwide, node-locked license to use the EasyBlank Native CAD File Import during the license term and for the license fee agreed upon in the respective order on the single computer hardware as identified in the respective order. Agreed-upon license term starts at the date of Customer&rsquo;s receipt of the respective license key and may at Customer&rsquo;s option and as indicated in Customer&rsquo;s respective order vary from one (1) month up to one (1) year. After expiry of the respective license term, EasyBlank Native CAD File Import needs to be ordered and licensed again.    </p>\n    <p class=\"Stil1\">The EasyBlank Software and the EasyBlank Native CAD File Import (hereinafter collectively referred to as the &ldquo;Software&rdquo;) are licensed, not sold, and AutoForm reserves all rights not specifically granted to Customer hereunder, including ownership of all AutoForm copyrights, trade secrets or other intellectual property rights in the Software and any accompanying information.  AutoForm furthermore reserves the right to discontinue the internet-based services related to a) the EasyBlank Software at any time and b) the EasyBlank Native CAD File Import at the end of Customer&rsquo;s respective license term and waives any obligation to support the Software or issue updates to it.      </p>\n    <p class=\"Stil2\">2.       Customer Representations and Warranties   </p>\n    <p class=\"Stil1\">2.1 Customer confirms to use the Software for internal testing purposes only and not to use it in full or in part for any materials distributed internally or externally.   </p>\n    <p class=\"Stil1\">2.2 Customer confirms that unless explicitly permitted by applicable law despite this limitation Customer will not work around the technical limitations in the Software, nor reverse engineer, decompile or disassemble the Software nor otherwise attempt to discover the source code of the Software which is a valuable AutoForm trade secret.   </p>\n    <p class=\"Stil1\">2.3 Customer confirms not to sell, rent, sub-license, lease or lend or otherwise distribute or make available the Software in whole or in part to others without AutoForm's prior written approval.   </p>\n    <p class=\"Stil1\">2.4 Customer confirms not to disclose the results of any benchmark tests of the Software to others without AutoForm's prior written approval.   </p>\n    <p class=\"Stil1\">2.5 Customer confirms that unless allowed by applicable law despite this limitation, Customer will only make one copy of the Software for back-up purposes and will reproduce AutoForm's and if applicable a third-party&rsquo;s copyright notice on all copies.     </p>\n    <p class=\"Stil1\">2.6 Customer acknowledges that this Agreement does not create any relationship of agency, partnership, or joint venture between AutoForm and Customer and Customer will not state or imply that any of Customer&rsquo;s products or services provided are directly or indirectly endorsed by AutoForm or its employees. This Agreement does not confer any right to use any name, trade name, trademark or other designation of AutoForm in advertising, publications or promotional activities without AutoForm&rsquo;s express written approval.       </p>\n    <p class=\"Stil2\">3.       Term of License/Termination   </p>\n    <p class=\"Stil1\">The License is effective upon start of the installation of the Software (&ldquo;Installation Date&rdquo;) and shall continue up to the expiration date as stated in Section 1 a) or b) unless automatically terminated without notice in case of Customer&rsquo;s failure to comply with any of the license terms. Upon termination, Customer shall immediately discontinue all use of the Software provided hereunder, and immediately destroy the original and all copies of all the Software. All of Customer&rsquo;s obligations under this Agreement which by their nature survive termination shall survive.        </p>\n    <p class=\"Stil2\">4.       Data Privacy, Data Security   </p>\n    <p class=\"Stil1\">Customer&rsquo;s personal data provided in connection with the download of the Software will be handled in full accordance with AutoForm&rsquo;s EasyBlank Data Privacy Policy (see <a href=\"http://www.EasyStamping.com\">www.EasyStamping.com</a>).       </p>\n    <p class=\"Stil2\">5.       Warranty Disclaimer   </p>\n    <p class=\"Stil1\">CUSTOMER ACKNOWLEDGES THAT THE LICENSED SOFTWARE USES STATE-OF-THE-ART MATHEMATICAL AND PHYSICAL ALGORITHMS THAT ARE NOT NECESSARILY PROVEN ACCURATE OR VALID. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE  SOFTWARE IS PROVIDED &rdquo;AS IS&rdquo;, WITHOUT EXPRESS OR IMPLIED WARRANTY OF ANY KIND, INCLUDING BUT NOT LIMITED TO WARRANTIES OF TITLE, NON-INFRINGEMENT OF INTELLECTUAL PROPERTY OR OTHER VIOLATION OF RIGHTS, CORRECTNESS, ACCURACY, RELIABILITY, MERCHANTABILITY OR FITNESS FOR CUSTOMER&rsquo;S PARTICULAR PURPOSE. AUTOFORM MAKES NO WARRANTY THAT THE SOFTWARE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. CUSTOMER IS SOLELY RESPONSIBLE FOR THE SELECTION OF THE SOFTWARE FOR ITS PLANNED USE AND ASSUMES THE ENTIRE RISK ARISING FROM OR RELATED TO SUCH USE.      </p>\n    <p class=\"Stil2\">6.       Limitation of Liability   </p>\n    <p class=\"Stil1\">TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEITHER AUTOFORM NOR ITS RELATED COMPANIES NOR THEIR EMPLOYEES SHALL BE LIABLE TO CUSTOMER FOR ANY DIRECT OR INDIRECT DAMAGES ARISING IN TORT, CONTRACT, STRICT LIABILITY OR OTHERWISE, INCLUDING, BUT NOT LIMITED TO SPECIAL, CONSEQUENTIAL OR INCIDENTAL DAMAGES, LOSS OF REVENUE OR PROFIT, LOST OR DAMAGED DATA OR OTHER COMMERCIAL OR ECONOMIC LOSS, ARISING OUT OF THE USE OF, OR INABILITY TO USE ANY WEBSITE AND/OR THE SOFTWARE EVEN IF AUTOFORM HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.         </p>\n    <p class=\"Stil2\">7.       Indemnification   </p>\n    <p class=\"Stil1\">Customer agrees to indemnify, defend and hold AutoForm or any of its related companies, their employees, partners, principals, agents and representatives harmless from and against all claims, liabilities, losses, expenses, damages and costs, including reasonable attorneys&rsquo; fees, in connection with or arising out of (a) any violation of this Agreement, or (b) the use of the Software by or on behalf of Customer or Customer&rsquo;s employees or third parties, or (c) the design, manufacture, distribution or use of products or processes developed in connection with or arising out of the Software.        </p>\n    <p class=\"Stil2\">8.       Export Controls   </p>\n    <p class=\"Stil1\">Customer agrees to fully comply with all applicable domestic or international export laws and regulations.        </p>\n    <p class=\"Stil2\">9.       Entire Agreement   </p>\n    <p class=\"Stil1\">This Agreement contains the entire agreement between the parties with respect to the subject matter hereof. If any part of this Agreement is found void or unenforceable, the rest of the Agreement shall remain valid and enforceable according to its terms.       </p>\n    <p class=\"Stil2\">10.   Notices   </p>\n    <p class=\"Stil1\">Any questions regarding the Agreement may be sent by writing to AutoForm Engineering GmbH, Legal Department, Technoparkstrasse 1, CH-8005 Z&uuml;rich, Switzerland.       </p>\n    <p class=\"Stil2\">11.   Applicable Law, Place of Jurisdiction   </p>\n    <p class=\"Stil1\">This Agreement is governed by <strong>Swiss</strong> law, place of jurisdiction is <strong>Zurich</strong> without regard to conflict of laws rules and principles and without regard to the United Nations Convention of Contracts for the International Sales of Goods. </p>\n  </div>\n  <div ng-if=\"$ctrl.type === 'terms'\">\n    <p>\n      <strong>Easyblank Services Use Terms and Conditions</strong>\n    </p>\n    <p>\n      This <strong>Agreement </strong>is entered into between AutoForm\n      Engineering GmbH, with its registered office at Fälmisstrasse 2, 8832 Wilen\n      b. Wollerau / Switzerland (\"Company\") and the user of the Services. It will\n      be effective as of the date of acceptance of these terms by user (    <strong>“Effective Date”</strong>).\n    </p>\n    <p>\n      <strong>1. </strong>\n      <strong>Definitions</strong>\n    </p>\n    <p>\n      <strong>a) </strong>\n      “<strong>Portal</strong>” means the Company’s website or mobile app\n      including the Technology.\n    </p>\n    <p>\n      <strong>b) </strong>\n      “<strong>Proprietary Rights</strong>” means any and all registered or\n      unregistered rights, in and with respect to patents, copyrights,\n      confidential information, know-how, trade secrets, moral rights, contract\n      or licensing rights, confidential and proprietary information protected\n      under contract or otherwise under law, trade names, domain names, trade\n      dress, logos, animated characters, trademarks, service marks, and other\n      similar rights or interests in intellectual or industrial property.\n    </p>\n    <p>\n      <strong>c) </strong>\n      “<strong>Services</strong>” means the specific proprietary\n      software-as-a-service products developed by Company and selected by You and\n      any updates or upgrades to such services that may be generally released by\n      the Company from time to time.\n    </p>\n    <p>\n      <strong>d) </strong>\n      <strong>“Session Term”</strong>\n      means the term of one session during which You use the Service, starting\n      with Your acceptance of this Agreement and ending with Your closing of Your\n      respective session.\n    </p>\n    <p>\n      <strong>e) </strong>\n      „<strong> Sign-Up Forms</strong>“ means Company‘s electronic online\n      sign-ups incorporating the terms of this Agreement, by which You select and\n      commence the Services\n    </p>\n    <p>\n      <strong>f) </strong>\n      “<strong>Technology</strong>” means the computer hardware, software, and\n      other tangible equipment and intangible computer code necessary to deploy\n      and serve the Services via the Portal.\n    </p>\n    <p>\n      <strong>g) </strong>\n      “<strong>You</strong>” collectively means you and/or your employees and/or\n      third parties who use the Services with your authorization and under your\n      full responsibility.\n    </p>\n    <p>\n      <strong>h) </strong>\n      “<strong>Your Data</strong>” means content (such as geometry, text, images\n      or videos) and other data processed, stored, or transmitted by, in, or\n      through the Services, including, but not limited to, personal information\n      and third party content.\n    </p>\n    <p>\n      <strong>2. Subscription for Services / Termination</strong>\n    </p>\n    <p>\n      <strong>a) Registration Procedure. </strong>\n      The Company will permit access to the Services only over the Internet using\n      account information assigned by the Company. You will need to register in\n      the Sign-Up Forms in order to access the Portal and/or the Services.\n      Sign-Up Forms information must be accurate, current and complete, and will\n      be governed by Company’s Privacy Policy (currently available at\n      <a href=\"https://www.autoform.com/en/legal/%20#x-02\">\n        https://www.autoform.com/en/legal/ #x-02\n      </a>\n      ). You agree to keep this information up-to-date so that Company may send\n      You notices, statements and other information by email. You will be\n      responsible for any and all actions taken using Your account.\n    </p>\n    <p>\n      <strong>b) </strong>\n      <strong>Session Fee</strong>\n      <strong>. </strong>\n      Unless otherwise agreed in a bi-lateral agreement between the Parties, the\n      Services provided by the Company under this Agreement shall be    <strong>free of charge</strong> during the Session Term.\n    </p>\n    <p>\n      <strong>c) </strong>\n      <strong>Termination of Services</strong>\n      <strong>.</strong>\n      <strong>aa)</strong>\n      <strong>For convenience:</strong>\n      Company may at its own discretion decide at any point in time to no longer\n      provide the Services for any reason whatsoever. In such case, Company shall\n      terminate any access to the Services for all users without prior notice.    <strong>bb)</strong> <strong>For breach</strong>: If You do not fully\n      comply with all terms and provisions of this Agreement, Company may may\n      terminate this Agreement immediately and without prior notice to You.    <strong>cc)</strong> <strong>Effect of Termination:</strong> Upon\n      termination of this Agreement with or without cause, You will immediately\n      be denied access to the Portal and the Services.\n    </p>\n    <p>\n      <strong>3. </strong>\n      <strong>Handling of Your Data.</strong>\n    </p>\n    <p>\n      <strong>a)</strong>\n      As part of the Services, the Company shall implement reasonable security\n      procedures consistent with the prevailing industry standard to protect Your\n      Data from unauthorized access (the “Security Standard”). The Company will\n      not, under any circumstances, be held responsible or liable for situations\n      (i) where data or transmissions are accessed by third parties through\n      illegal or illicit means, or (ii) where the data or transmissions are\n      accessed through the exploitation of security gaps, weaknesses, or flaws\n      unknown to the Company at the time. The Company will report to You any\n      unauthorized access to Your Data promptly upon discovery by the Company and\n      the Company shall use diligent efforts to promptly remedy any breach of\n      security that permitted such unauthorized access.\n    </p>\n    <p>\n      <strong>b)</strong>\n      <strong>Content Ownership</strong>\n      . The Parties acknowledge that all Your Data used with the Services and all\n      the data derived from Your Data is and will remain Your property. You may\n      delete any part geometry and results data at Your discretion any time\n      during the Session Term and at the end of the Session Term, Company will\n      automatically delete all such data and You will have no further access to\n      it.\n    </p>\n    <p>\n      <strong>c)</strong>\n      <strong>Use of Your Data</strong>\n      is at Your Risk. The Company shall have no responsibility for the accuracy,\n      quality, integrity, legality, reliability, or appropriateness of Your Data.\n      You acknowledge that use of any of Your Data generated, obtained, or\n      acquired through the use of the Services is at Your sole risk and\n      discretion. The Company is not liable or responsible for any results\n      generated using Your Data. YOU UNDERSTAND AND AGREE THAT YOU ARE USING THE\n      SERVICES/PORTAL AT YOUR OWN AND YOU UNDERSTAND THAT YOUR DATA IS STORED AT\n      YOUR OWN RISK.\n    </p>\n    <p>\n      <strong>d) Aggregate/Anonymous Data.</strong>\n      Company may generate and collect learnings, logs and data regarding use of\n      the Portal and Services (<strong>“Aggregate/Anonymous Data”</strong>). You\n      agree that Company in accordance with Company’s Privacy Policy may use\n      Aggregate/Anonymous Data for any business purpose during or after the term\n      of this Agreement, including without limitation to develop and improve\n      other products and services, so long as the Aggregate/Anonymous Data does\n      not personally identify You.\n    </p>\n    <p>\n      <strong>4. </strong>\n      <strong>Use Restrictions.</strong>\n    </p>\n    <p>\n      <strong>a) </strong>\n      You herewith agree and confirm that Your use of the Services will be in a\n      manner consistent with this Agreement and with all applicable laws and\n      regulations, including trade secret, copyright, trademark, and export\n      control laws. Without limiting the generality of the foregoing, You shall\n      not, nor shall You permit or assist others, (i) to abuse or fraudulently\n      use the Services; (ii) to process or permit to be processed the data of any\n      third party that is not expressly authorized herein to access and use such\n      Services; and (iii) to attempt to copy, reverse engineer, decompile,\n      disassemble, create a derivative work from, or otherwise attempt to derive\n      the source code of any part of the Technology; or (iv) to access, alter, or\n      destroy any information of any customer of the Company by fraudulent means\n      or device, or attempt to do so.\n    </p>\n    <p>\n      <strong>b)</strong>\n      You herewith confirm and agree that You will not use the Services for\n      competitive analysis purposes. Your use of the Services for competitive\n      analysis is a breach of this Agreement and will result in automatic,\n      immediate termination of the Services.\n    </p>\n    <p>\n      <strong>4. </strong>\n      <strong>Technical Requirements for Services.</strong>\n    </p>\n    <p>\n      <strong>a) </strong>\n      <strong>Capacities</strong>\n      <strong>. </strong>\n      The Services will be rendered in a manner that will support Your\n      requirements.\n    </p>\n    <p>\n      <strong>b) </strong>\n      <strong>Internet Data Centers</strong>\n      <strong>. </strong>\n      The Services will be provided through Internet Data Centers that are\n      configured consistent with the prevailing industry standards with respect\n      to a) fireproofing, power and backup generation, structural integrity and\n      resistance to natural and/or man-made disruptions and b) measurements taken\n      to secure facility against physical and electronic intrusion. Company may\n      outsource its Internet Data Center operations to subcontractors; provided,\n      however, that the Company shall be responsible for the performance of such\n      subcontractors, and the Company shall be liable for any action or inaction\n      by such subcontractors as if performed by the Company.\n    </p>\n    <p>\n      <strong>5. </strong>\n      <strong>Confidential Information.</strong>\n      For purposes of this Agreement, “Confidential Information” means Your Data\n      and non-public aspects of Your technology, and business and technical\n      information.\n    </p>\n    <p>\n      <strong>a) </strong>\n      <strong>Restrictions on Use and Disclosure. </strong>\n      Company may use Your Confidential Information only for the purposes of this\n      Agreement and shall protect such Confidential Information from disclosure\n      to others, using the same degree of care used to protect its own\n      proprietary information, but, in any case, using a reasonable degree of\n      care.\n    </p>\n    <p>\n      <strong>b) </strong>\n      <strong>Exclusions.</strong>\n      The restrictions of this Agreement on use and disclosure of Confidential\n      Information will not apply to information that: (i) is in the possession or\n      control of the Company at the time of its disclosure hereunder; (ii) is, or\n      becomes, publicly known, through no wrongful act of the Company; (iii) is\n      received by the Company by a third party free to disclose it without\n      obligation to You; (iv) is independently developed by a party as evidenced\n      by its written and dated records and without any breach of this Agreement;\n      or (v) is the subject of a written permission to disclose provided by You.\n      The Company may disclose Your Confidential Information pursuant to the\n      requirements of a governmental agency or by operation of law, provided that\n      the Company gives the Organization written notice thereof as soon as\n      practicable and reasonably cooperates with Organization to contest such\n      disclosure.\n    </p>\n    <p>\n      <strong>6. </strong>\n      <strong>Proprietary Rights Ownership. </strong>\n      Ownership of the Proprietary Rights embodied in the Portal, Services, and\n      the Technology will remain exclusively vested in and be the sole and\n      exclusive property of the Company and its licensors. The AutoForm domain\n      name, product names, and logos associated with the Services are trademarks\n      of the Company or third parties, and no right or license is granted to use\n      them.\n    </p>\n    <p>\n      The Company welcomes Your feedback with regard to the Portal and the\n      Services („<strong>Suggestions</strong>“). If You submit any Suggestions,\n      the Suggestions will automatically become the property of the Company. None\n      of the Suggestions will be subject to any obligation of confidentiality and\n      the Company shall not be liable for its disclosure or use. The Company will\n      have exclusive ownership of all now known or later discovered rights to the\n      Suggestions and will be entitled to unrestricted use of the Suggestions for\n      any purpose whatsoever, commercial or otherwise, without compensation to\n      You.\n    </p>\n    <p>\n      <strong>7. </strong>\n      <strong>Your Representations and Warranties. </strong>\n      You represent and warrant that a) You are not located in a country that is\n      subject to a U.S. Government embargo, and it is not listed on any U.S.\n      Government list of prohibited or restricted parties; and b) the performance\n      of Your obligations and Your use of the Services will not violate any\n      applicable laws or regulations including, but not limited to, any and all\n      laws and regulations regarding the transfer to personal information of\n      residents of the European Union outside the European Union and c) You shall\n      use commercially reasonable efforts to ensure that the information You\n      transmit thereby complies with all applicable laws and regulations, whether\n      now in existence or hereafter enacted and in force.\n    </p>\n    <p>\n      In the event of Your breach of any of the foregoing representations or\n      warranties, in addition to any other remedies available at law or in\n      equity, the Company will have the right to suspend immediately any\n      Services. .\n    </p>\n    <p>\n      <strong>8. </strong>\n      <strong>Company Representations and Warranties. </strong>\n      The Company represents and warrants that a) it has the legal right to enter\n      into this Agreement and perform its obligations under this Agreement, and\n      b) the performance of its obligations and delivery of the Services will not\n      violate any applicable laws or regulations or cause a breach of any\n      agreements between the Company and any third parties. In the event of a\n      breach by the Company of the foregoing warranties, Your sole remedy is\n      termination of this Agreement upon written notice to the Company.\n    </p>\n    <p>\n      <strong>9. COMPANY WARRANTY DISCLAIMERS. </strong>\n      THE COMPANY DOES NOT MAKE ANY WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,\n      STATUTORY OR OTHERWISE, AND IT SPECIFICALLY DISCLAIMS THE IMPLIED\n      WARRANTIES OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A\n      PARTICULAR PURPOSE, SYSTEM INTEGRATION, AND DATA ACCURACY. YOU ACKNOWLEDGE\n      THAT ACCESS TO AND CONTENT OF THE SERVICES ARE PROVIDED ON AN “AS IS” AND\n      “AS AVAILABLE” BASIS WITHOUT ANY WARRANTY, SUPPORT, MAINTENANCE, STORAGE,\n      SERVICE LEVEL AGREEMENT OR OTHER OBLIGATIONS OF ANY KIND. COMPANY\n      EXPLICITLY DISCLAIMS ANY WARRANTY THAT SERVICES ARE PROVIDED UNINTERRUPTED\n      OR ERROR-FREE AND IT DISCLAIMS ALL LIABILITY RESULTING FROM OR RELATED TO\n      THE PERFORMANCE OR NON-PERFORMANCE OF INTERNET SERVICES, SOFTWARE\n      COMPONENTS, OR OPERATING SYSTEMS PROVIDED OR CONTROLLED BY THIRD PARTIES .\n    </p>\n    <p>\n      COMPANY WILL NOT BE RESPONSIBLE OR LIABLE IN ANY MANNER FOR YOUR USE OF THE\n      PORTAL AND THE SERVICES OR FOR DECISIONS OR ACTIONS TAKEN BY YOU BASED UPON\n      THE SERVICES. THE DISCLAIMERS IN THIS SECTION SHALL APPLY TO THE MAXIMUM\n      EXTENT PERMITTED BY APPLICABLE LAW. YOU MAY HAVE OTHER STATUTORY RIGHTS.\n      HOWEVER, ANY STATUTORILY REQUIRED WARRANTIES UNDER APPLICABLE LAW, IF ANY,\n      SHALL BE LIMITED TO THE SHORTEST PERIOD AND MAXIMUM EXTENT PERMITTED BY\n      LAW.\n    </p>\n    <p>\n      <strong>10. COMPANY LIMITATIONS OF LIABILITY.</strong>\n      GIVEN THE FREE OF CHARGE NATURE OF THE SERVICES, LIABILITY OF COMPANY OR\n      ITS SUPPLIERS IS LIMITED TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW\n      FOR ANY LOSS OF USE, LOST OR INACCURATE DATA, FAILURE OF SECURITY\n      MECHANISMS, INTERRUPTION OF BUSINESS, LOST PROFITS, COSTS OF DELAY,\n      REPUTATIONAL HARM, OR ANY INDIRECT, SPECIAL, INCIDENTAL, COVER, RELIANCE OR\n      CONSEQUENTIAL DAMAGES OF ANY KIND, HOWEVER CAUSED, EVEN IF INFORMED IN\n      ADVANCE OF THE POSSIBILITY OF SUCH DAMAGES.\n    </p>\n    <p>\n      <strong>11. Miscellaneous</strong>\n    </p>\n    <p>\n      <strong>a) Severability. </strong>\n      If any part of this Agreement is held to be unenforceable for any reason,\n      the remainder of this Agreement will continue in full force and effect. If\n      any provision of this Agreement is deemed invalid or unenforceable by any\n      court of competent jurisdiction, and if limiting such provisions would make\n      the provision valid, then such provision will be deemed to be construed as\n      so limited.\n    </p>\n    <p>\n      <strong>b) Entire Agreement. </strong>\n      This Agreement constitutes the entire agreement regarding its subject\n      matter between the Parties and supersedes any prior understanding or\n      representation of any kind preceding the date of this Agreement.\n    </p>\n    <p>\n      <strong>c) Modifications</strong>\n      . This Agreement may be modified by Company from time to time without\n      specific notice.\n    </p>\n    <p>\n      <strong>d) No </strong>\n      <strong>Assignment. </strong>\n      You shall not assign this Agreement or any right or interest under it, nor\n      delegate any work or obligation to be performed hereunder, without the\n      Company’s prior written consent. Any attempted assignment or delegation in\n      contravention of this Section will be void and ineffective.\n    </p>\n    <p>\n      <strong>e) Survival</strong>\n      . Any provisions of this Agreement which by their nature impose an\n      obligation after termination are deemed to survive termination of this\n      Agreement. <strong></strong>\n    </p>\n    <p>\n      <strong>12. Governing Law / Place of Jurisdiction. </strong>\n      This Agreement and the rights and obligations of the Parties under it are\n      governed by and interpreted in accordance with <strong>Swiss</strong> laws.\n      Place of jurisdiction will be <strong>Commercial Court of Zurich</strong>.\n    </p>\n  <div ng-if=\"$ctrl.type === 'policy'\">\n    <p align=\"center\" class=\"Stil2\">AUTOFORM EASYBLANK PRIVACY POLICY </p>\n    <p class=\"Stil1\">Last updated: March 8, 2007 </p>\n    <p class=\"Stil1\">AutoForm Engineering GmbH and all its affiliates (hereinafter collectively referred to as &quot;AutoForm&rdquo;) are committed to maintaining the privacy of customer (&ldquo;Customer&rdquo;). AutoForm acknowledges its responsibility to protect and safeguard any Customer&rsquo;s entrusted personal or business information (&ldquo;Customer Information&rdquo;) in accordance with this Privacy Policy (&quot;Policy&rdquo;), which may be updated from time to time without notice and at AutoForm&rsquo;s free discretion. All changes and updates will be promptly posted. </p>\n    <p class=\"Stil2\">Collected Information </p>\n    <p class=\"Stil1\">AutoForm or its authorized AutoForm partner StampingSimulation.com Pty Ltd. who is also bound by this Policy may collect Customer Information by:</p>\n    <ul>\n      <li class=\"Stil1\">automatically collecting data about Customer&rsquo;s usage of EasyBlank websites (&ldquo;Sites&rdquo;), products or services (collectively referred to as &ldquo;Products and Services&rdquo;) including IP address. This information is collected primarily for purposes of administering Sites, Products and Services and monitoring usage and performance of Sites, Products and Services as well as facilitating usage of Sites, Products and Services.</li>\n      <li class=\"Stil1\">collecting certain information that Customer is asked to provide, such as name, company name, title, address, country of residence, e-mail address, telephone number. Such information is used to verify Customer&rsquo;s identity and eligibility to receive certain Products and Services, to process orders, to communicate with Customer and to provide Customer with information about suitable Products and Services unless Customer informs AutoForm that it does not wish to receive such information in the future.</li>\n      <li class=\"Stil1\">collecting Customer Information from orders, applications, forms, agreements or other communication directed by Customer to AutoForm and primarily using it to make improvements to Services, for statistical analysis of user behaviour, market research, Product development, content improvement and marketing purposes.</li>\n    </ul>\n    <p class=\"Stil1\"> By using the Sites, Products and Services, Customer consents to such collection and use of Customer Information by AutoForm or its authorized AutoForm partner StampingSimulation.com Pty Ltd, anywhere they do business. </p>\n    <p class=\"Stil2\">Right of Review, Correction </p>\n    <p class=\"Stil1\">Upon request, AutoForm will at any time grant Customer access to its or its authorized AutoForm partner&rsquo;s collected Customer Information and Customer is entitled to ask for correction or deletion of any part of the Customer Information. Any request for review, correction or deletion of Customer Information may be sent by writing to AutoForm Engineering GmbH, Legal Department, Technoparkstrasse 1, CH-8005 Z&uuml;rich, Switzerland. </p>\n    <p class=\"Stil2\">Security of data transfer  </p>\n    <p class=\"Stil1\">AutoForm and its authorized partners use the industry-standard Secure Sockets Layer (SSL) technology that permits encryption of potentially sensitive information such as Customer name, address and business information. All transactions in connection with EasyBlank are transmitted encrypted. </p>\n    <p class=\"Stil2\">Protection, Processing and Handling of Personal Data  </p>\n    <p class=\"Stil1\">Appropriate physical, procedural and electronical security measures are in place at AutoForm&rsquo;s or its authorized partner&rsquo;s physical facilities to guard Customer Information and to protect against its loss, misuse or alteration. Access to Customer Information is restricted to those employees, agents or other parties who need to know it to provide Products or Services to Customer and they are required to use it exclusively for the purpose for which it is provided in accordance with this Policy.  </p>\n    <p class=\"Stil2\">Links </p>\n    <p class=\"Stil1\">An AutoForm Site may contain hyperlinks to other websites that are not operated or monitored by AutoForm. These other websites are not subject to this Privacy Policy and AutoForm is not responsible for their content or for the policy they apply to the treatment of personal data. </p>\n  </div>\n  <div ng-if=\"$ctrl.type === 'termsAndConditions'\">\n    <div class=\"agreemnt-container\">\n      <p align=\"center\" class=\"Stil3\">TERMS AND CONDITIONS</p>\n      <p class=\"Stil1\">AutoForm reserves the copyright, title, and all other intellectual property rights in its products and all accompanying material supplied by AutoForm.</p>\n      <p class=\"Stil1\">It may only be used on the computers and processors for which above company has a valid AutoForm license.It may not be transferred to other computer systems.Usage subject to the terms and conditions of the AutoForm license agreement. Unauthorized use is a serious violation of applicable copyright laws.</p>\n      <p class=\"Stil1\">AutoForm does not warrant, guarantee or make any representations regarding the use, or the results of the use, of the software with respect to its correctness, accuracy, reliability, currentness or otherwise. User shall be solely responsible for the selection, suitability, use and efficiency of AutoForm products, data and simulation results, and AutoForm shall have no liability thereof.</p>\n      <p class=\"Stil1\">AutoForm products and data are provided on an 'as is' basis, therefore AutoForm does not give any warranty, express or implied, including, but not limited to, the merchantability or fitness for a particular purpose.</p>\n      <p class=\"Stil1\">AutoForm  takes no responsibility for how these results are used or integrated or their accuracy. While every care is taken to ensure that simulation is as practical and accurate as possible, differences between the simulation parameters and actual physical tool may yield different results, these results are used at your own risk.</p>\n      <p class=\"Stil1\">Warning: This computer program is protected by copyright law and international treaties. Unauthorized reproduction or distribution of this program, or any portion of it, may result in severe civil and criminal penalties, and will be prosecuted to the maximum extent under the law.</p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn button-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n  </div>\n</div>\n</div>\n</div>\n"

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(452);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./info-widget.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./info-widget.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".help-button-left{position:absolute;bottom:10px;right:15px}.help-button-left .easyblank-icon{font-size:24px}button.help-button{border-radius:0;border-color:#666;color:#666;background-color:#e8e7e7;right:10px}button.help-button .button-label{margin-bottom:5px}button.help-button:hover{border-color:#666;color:#666;background-color:#e8e7e7}.help-modal .modal-body{padding:31px}.button-label-container{width:40px;display:inline-block}.button-label-container .button-label{position:absolute;top:8px;right:20px;font-size:16px}", ""]);
	
	// exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _errorWidget = __webpack_require__(454);
	
	var _errorWidget2 = _interopRequireDefault(_errorWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorNotificationModule = _angular2.default.module('error-notification', [_angularUiRouter2.default]).component('errorNotification', _errorWidget2.default).name;
	
	exports.default = errorNotificationModule;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _errorWidget = __webpack_require__(455);
	
	var _errorWidget2 = _interopRequireDefault(_errorWidget);
	
	var _errorWidget3 = __webpack_require__(456);
	
	var _errorWidget4 = _interopRequireDefault(_errorWidget3);
	
	__webpack_require__(461);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorNotificationComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _errorWidget2.default,
	  controller: _errorWidget4.default
	};
	
	exports.default = errorNotificationComponent;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = "<div>\n</div>\n"

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _errorNotificationModal = __webpack_require__(457);
	
	var _errorNotificationModal2 = _interopRequireDefault(_errorNotificationModal);
	
	var _errorNotificationModal3 = __webpack_require__(458);
	
	var _errorNotificationModal4 = _interopRequireDefault(_errorNotificationModal3);
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorNotificationController = function () {
	    function ErrorNotificationController($uibModal, $scope) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, ErrorNotificationController);
	
	        this._$uibModal = $uibModal;
	
	        $scope.$on('showErrorDialog', function (event, data) {
	            _this.openHelpWindow(data);
	        });
	    }
	
	    (0, _createClass3.default)(ErrorNotificationController, [{
	        key: 'openHelpWindow',
	        value: function openHelpWindow(_data) {
	            this.dialogIsShown = true;
	            this._$uibModal.open({
	                animation: false,
	                template: _errorNotificationModal4.default,
	                controllerAs: '$ctrl',
	                size: 'md',
	                resolve: {
	                    data: function data() {
	                        return {
	                            type: _data.type,
	                            text: _lodash2.default.get(_data, 'text.error')
	                        };
	                    }
	                },
	                controller: _errorNotificationModal2.default
	            });
	        }
	    }]);
	    return ErrorNotificationController;
	}();
	
	ErrorNotificationController.$inject = ['$uibModal', '$scope'];
	
	exports.default = ErrorNotificationController;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorModalController = function () {
	    function ErrorModalController($uibModalInstance, data) {
	        (0, _classCallCheck3.default)(this, ErrorModalController);
	
	        this.text = data.text;
	
	        if (data.type === 'feasibility') {
	            this.text = 'Solver error, please try modified geometry file.';
	        } else if (data.type === 'nest') {
	            this.text = 'Nester error, please try modified Blank outline.';
	        }
	
	        this._$uibModalInstance = $uibModalInstance;
	    }
	
	    (0, _createClass3.default)(ErrorModalController, [{
	        key: 'close',
	        value: function close() {
	            this._$uibModalInstance.close();
	        }
	    }]);
	    return ErrorModalController;
	}();
	
	ErrorModalController.$inject = ['$uibModalInstance', 'data'];
	
	exports.default = ErrorModalController;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content help-modal\">\n  <form name=\"form\" novalidate class=\"css-form\">\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div ng-if=\"!$ctrl.text\">\n        <h3><span class=\"icon easyblank-icon\">F</span>Service is not reachable</h3>\n          <p>The server cannot be reached at this moment.</p>\n          <p>Please Try again.</p>\n          <p>If the problem persists, call our service hotline.</p>\n      </div>\n      <div  ng-if=\"$ctrl.text\">\n        <h3><span class=\"icon easyblank-icon\">F</span>{{ $ctrl.text }}</h3>\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn button-plain\" type=\"button\" ng-click=\"$ctrl.close()\">Cancel</button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(462);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./error-widget.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./error-widget.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".help-button-left{position:absolute;bottom:10px;right:15px}button.help-button{border-radius:0}.help-modal .modal-body{padding:31px}", ""]);
	
	// exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pageNavigation = __webpack_require__(464);
	
	var _pageNavigation2 = _interopRequireDefault(_pageNavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageNavigationModule = _angular2.default.module('page-navigation', [_angularUiRouter2.default]).component('pageNavigation', _pageNavigation2.default).name;
	
	exports.default = pageNavigationModule;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pageNavigation = __webpack_require__(465);
	
	var _pageNavigation2 = _interopRequireDefault(_pageNavigation);
	
	var _pageNavigation3 = __webpack_require__(466);
	
	var _pageNavigation4 = _interopRequireDefault(_pageNavigation3);
	
	__webpack_require__(467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageNavigationComponent = {
	    restrict: 'E',
	    bindings: {
	        highlight: '=',
	        disabled: '=',
	        next: '@',
	        prev: '@'
	    },
	    template: _pageNavigation2.default,
	    controller: _pageNavigation4.default
	};
	
	exports.default = pageNavigationComponent;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navigation-container\">\n    <button\n      ng-if=\"$ctrl.isStateEnabled($ctrl.next)\"\n      type=\"button\" class=\"btn button-next pull-right\"\n      ng-class=\"{'data-changed-nest': $ctrl.highlight }\"\n      ng-click=\"$ctrl.goNext()\">\n      Next<span class=\"glyphicon glyphicon-menu-right button-arrow\"></span>\n    </button>\n</div>\n"

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageNavigationController = function () {
	    function PageNavigationController($state, LoadedModel, MenuElements) {
	        (0, _classCallCheck3.default)(this, PageNavigationController);
	
	        this._MenuElements = MenuElements;
	        this._LoadedModel = LoadedModel;
	        this._$state = $state;
	    }
	
	    (0, _createClass3.default)(PageNavigationController, [{
	        key: 'goNext',
	        value: function goNext() {
	            this._$state.go(this.next);
	        }
	    }, {
	        key: 'goPrev',
	        value: function goPrev() {
	            this._$state.go(this.prev);
	        }
	    }, {
	        key: 'isStateEnabled',
	        value: function isStateEnabled(stateName) {
	            return this._MenuElements.isStateEnabled(stateName);
	        }
	    }]);
	    return PageNavigationController;
	}();
	
	PageNavigationController.$inject = ['$state', 'LoadedModel', 'MenuElements'];
	
	exports.default = PageNavigationController;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(468);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./page-navigation.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./page-navigation.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".navigation-container{position:absolute;bottom:50px;right:50px}", ""]);
	
	// exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modelView = __webpack_require__(470);
	
	var _modelView2 = _interopRequireDefault(_modelView);
	
	var _threejsView = __webpack_require__(475);
	
	var _threejsView2 = _interopRequireDefault(_threejsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modelViewModule = _angular2.default.module('modelView', []).component('modelView', _modelView2.default).directive('threeJsView', _threejsView2.default).name;
	
	exports.default = modelViewModule;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modelView = __webpack_require__(471);
	
	var _modelView2 = _interopRequireDefault(_modelView);
	
	var _modelView3 = __webpack_require__(472);
	
	var _modelView4 = _interopRequireDefault(_modelView3);
	
	__webpack_require__(473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modelViewComponent = {
	  restrict: 'E',
	  bindings: {
	    mesh: '=',
	    fileName: '='
	  },
	  template: _modelView2.default,
	  controller: _modelView4.default
	};
	
	exports.default = modelViewComponent;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	module.exports = "<div three-js-view  class=\"model-container\">\n  <div class=\"model-view\"></div>\n</div>\n\n\n\n"

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModelViewController = function ModelViewController() {
	  (0, _classCallCheck3.default)(this, ModelViewController);
	};
	
	exports.default = ModelViewController;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(474);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./model-view.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./model-view.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".model-container{width:100%;height:100%}", ""]);
	
	// exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(476);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _scenes = __webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThreeJsView = function ThreeJsView($state, $window, LoadedModel) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element) {
	
	            var renderer = void 0,
	                scene = void 0,
	                camera = void 0,
	                viewData = void 0;
	            var renderElement = $element[0];
	
	            var parent = $element.parent().parent().parent()[0];
	
	            var _getSideLength = getSideLength(),
	                _getSideLength2 = (0, _slicedToArray3.default)(_getSideLength, 2),
	                width = _getSideLength2[0],
	                height = _getSideLength2[1];
	
	            function getSideLength() {
	
	                return [parent.clientWidth ? parent.clientWidth - 25 : 0, parent.clientHeight ? parent.clientHeight - 80 : 0];
	            }
	
	            function onResize() {
	                var _getSideLength3 = getSideLength();
	
	                var _getSideLength4 = (0, _slicedToArray3.default)(_getSideLength3, 2);
	
	                width = _getSideLength4[0];
	                height = _getSideLength4[1];
	
	                processData(viewData);
	                drawView();
	            }
	
	            function saveCameraPosition() {
	                if (LoadedModel.currentView && LoadedModel.currentView.viewType === 'free') {
	                    LoadedModel.position.free = camera.position;
	                } else if (LoadedModel.currentView && LoadedModel.currentView.viewType === 'blank') {
	                    LoadedModel.position.blank = camera.position;
	                } else if (LoadedModel.currentView && LoadedModel.currentView.viewType === 'nest') {
	                    LoadedModel.position.nest = camera.position;
	                }
	            }
	
	            function render() {
	                if (LoadedModel.animationId) {
	                    cancelAnimationFrame(LoadedModel.animationId);
	                }
	                LoadedModel.animationId = requestAnimationFrame(render);
	                var axis = _lodash2.default.get(LoadedModel, 'currentView.axis', false);
	                var currentView = LoadedModel.currentView;
	                if (currentView) {
	                    currentView.setLightPosition(camera);
	                }
	                if (axis) {
	                    axis.setPosition(camera);
	                }
	
	                renderer.setSize(width, height);
	                saveCameraPosition();
	                if (renderer) {
	                    renderer.render(scene, camera);
	                }
	            }
	
	            function drawView() {
	                if (renderElement.children.length) {
	                    renderElement.removeChild(renderElement.children[0]);
	                }
	                saveCameraPosition();
	
	                camera.lookAt(scene.position);
	                render();
	                renderElement.appendChild(renderer.domElement);
	            }
	
	            function processData(sceneAndData) {
	                var _sceneAndData = (0, _slicedToArray3.default)(sceneAndData, 5),
	                    data = _sceneAndData[0],
	                    view = _sceneAndData[1],
	                    type = _sceneAndData[2],
	                    force = _sceneAndData[3],
	                    offset = _sceneAndData[4];
	
	                var sceneMapper = {
	                    mesh: _scenes.MeshScene,
	                    feasibility: _scenes.FormabilityScene,
	                    thinning: _scenes.FormabilityScene,
	                    blank: _scenes.BlankScene,
	                    nest: _scenes.NestScene
	                };
	                if (view) {
	                    LoadedModel.currentView = view;
	                    if (force) {
	                        LoadedModel.currentView = new sceneMapper[type](view.data, width, height, LoadedModel.position, offset);
	                    } else {
	                        LoadedModel.currentView.restoreView(width, height, LoadedModel.position);
	                    }
	
	                    scene = LoadedModel.currentView.scene;
	                    camera = LoadedModel.currentView.camera;
	                    renderer = LoadedModel.currentView.renderer;
	                } else {
	                    LoadedModel.currentView = new sceneMapper[type](data, width, height, LoadedModel.position);
	                    scene = LoadedModel.currentView.scene;
	                    camera = LoadedModel.currentView.camera;
	                    renderer = LoadedModel.currentView.renderer;
	                    LoadedModel.updateView(LoadedModel.currentView, type);
	                }
	            }
	
	            $scope.$on('updateView', function (event, data) {
	                processData(data);
	                viewData = data;
	                drawView();
	            });
	
	            $scope.$on('meshDeleted', function () {
	                LoadedModel.clearCurrentView();
	            });
	
	            angular.element($window).bind('resize', function () {
	                onResize();
	            });
	        }
	    };
	};
	
	ThreeJsView.$inject = ['$state', '$window', 'LoadedModel'];
	
	exports.default = ThreeJsView;

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NestScene = exports.BlankScene = exports.FormabilityScene = exports.MeshScene = undefined;
	
	var _get2 = __webpack_require__(518);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(476);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _boundaries = __webpack_require__(554);
	
	var _axis = __webpack_require__(556);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THREE = __webpack_require__(555);
	var OrbitControls = __webpack_require__(558)(THREE);
	
	var START_CAMERA_POSITION = {
	    free: { x: 0, y: 0, z: -400 },
	    blank: { x: 0, y: -400, z: 0 },
	    nest: { x: 0, y: -400, z: 0 }
	};
	
	var DISTANCE_RATIO = 400;
	
	var DEFAULT_LIGHT_POSITION = { x: 1000, y: 1000, z: 1000 };
	var DEFAULT_LIGHT_COLOR = 0xffffff;
	var CLEAR_COLOR = 0x888888;
	
	var DEFAULT_MATERIAL_COLOR = 0x3556b7;
	var GREEN_MATERIAL_COLOR = 0x00ff00;
	var RED_MATERIAL_COLOR = 0xff0000;
	
	var ARROW_CYR_MATERIAL_COLOR = 0xffff00;
	var BOUNDARY_COLOR = 0x49D149;
	
	var BaseScene = function () {
	    function BaseScene(width, height, maxDimensions, position, viewType) {
	        (0, _classCallCheck3.default)(this, BaseScene);
	
	        this.viewType = viewType;
	        this.cameraDistanceRatio = maxDimensions / DISTANCE_RATIO;
	        this.width = width;
	        this.height = height;
	        this.ratio = width / height;
	        this.initScene();
	        this.initCamera(width, height, position);
	        this.initRenderer(width, height);
	        this.initControls(this.camera);
	    }
	
	    (0, _createClass3.default)(BaseScene, [{
	        key: 'restoreView',
	        value: function restoreView(width, height, positionObj) {
	            var position = positionObj[this.viewType];
	            this.initCamera(width, height, position);
	            this.renderer.setSize(width, height);
	
	            this.width = width;
	            this.height = height;
	            this.ratio = width / height;
	
	            this.camera.aspect = 1;
	            this.initControls(this.camera);
	        }
	    }, {
	        key: 'initSpotLight',
	        value: function initSpotLight() {
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LIGHT_POSITION;
	            var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LIGHT_COLOR;
	            var x = position.x,
	                y = position.y,
	                z = position.z;
	
	            var spotLight = new THREE.SpotLight(color);
	            spotLight.position.set(x, y, z);
	            spotLight.castShadow = true;
	            return spotLight;
	        }
	    }, {
	        key: 'initScene',
	        value: function initScene() {
	            var scene = new THREE.Scene();
	            this.light = this.initSpotLight();
	            scene.add(this.light);
	            this.scene = scene;
	        }
	    }, {
	        key: 'setLightPosition',
	        value: function setLightPosition(camera) {
	            this.light.position.set(camera.position.x, camera.position.y, camera.position.z);
	        }
	    }, {
	        key: 'initRenderer',
	        value: function initRenderer(width, height) {
	            var renderer = new THREE.WebGLRenderer({
	                preserveDrawingBuffer: true,
	                antialias: true,
	                alpha: true
	            });
	
	            this.renderer = renderer;
	            this.renderer.setSize(width, height);
	            renderer.setClearColor(CLEAR_COLOR, 0.0);
	            renderer.autoClear = true;
	            renderer.shadowMapEnabled = true;
	        }
	    }, {
	        key: 'generateGeometry',
	        value: function generateGeometry(rawGeometry, Y) {
	            var statistic = {};
	            var max = function max(key, value, statistic) {
	                var prevValue = statistic[key];
	                return prevValue === undefined || prevValue < value ? value : prevValue;
	            };
	
	            var min = function min(key, value, statistic) {
	                var prevValue = statistic[key];
	                return prevValue === undefined || prevValue > value ? value : prevValue;
	            };
	
	            var processCoordinate = function processCoordinate(key, value) {
	                var maxKey = 'max' + key;
	                var minKey = 'min' + key;
	                statistic[maxKey] = max(maxKey, value, statistic);
	                statistic[minKey] = min(minKey, value, statistic);
	            };
	
	            var geometry = new THREE.Geometry();
	
	            rawGeometry.vertices.forEach(function (point) {
	                var _point = (0, _slicedToArray3.default)(point, 3),
	                    x = _point[0],
	                    y = _point[1],
	                    z = _point[2];
	
	                processCoordinate('X', x);
	                processCoordinate('Z', z);
	                processCoordinate('Y', y);
	                if (Y) {
	                    geometry.vertices.push(new THREE.Vector3(x, Y, z));
	                } else {
	                    geometry.vertices.push(new THREE.Vector3(x, y, z));
	                }
	            });
	
	            rawGeometry.facets.forEach(function (face) {
	                var _face = (0, _slicedToArray3.default)(face, 3),
	                    x = _face[0],
	                    y = _face[1],
	                    z = _face[2];
	
	                geometry.faces.push(new THREE.Face3(x, y, z));
	            });
	            geometry.computeFaceNormals();
	            geometry.mergeVertices();
	            geometry.computeVertexNormals();
	            geometry.castShadow = true;
	            geometry.hasColors = true;
	            return geometry;
	        }
	    }, {
	        key: 'initAxis',
	        value: function initAxis() {
	            this.axis = new _axis2.default(this.scene, this.ratio);
	            this.scene.add(this.axis);
	        }
	    }, {
	        key: 'getAxis',
	        value: function getAxis() {
	            return this.axis;
	        }
	    }, {
	        key: 'initControls',
	        value: function initControls(camera) {
	            this.controls = new OrbitControls(camera, this.renderer.domElement);
	            this.controls.noKeys = true;
	        }
	    }, {
	        key: 'setDimensions',
	        value: function setDimensions(width, height) {
	            this.width = width;
	            this.height = height;
	        }
	    }, {
	        key: 'getCamera',
	        value: function getCamera(width, height) {
	            return new THREE.PerspectiveCamera(45, width / height, 5, 20000);
	        }
	    }, {
	        key: 'setCameraUp',
	        value: function setCameraUp() {
	            this.camera.up.set(1, 0, 0);
	        }
	    }, {
	        key: 'initCamera',
	        value: function initCamera(width, height, position) {
	            var camera = this.getCamera(width, height);
	            this.camera = camera;
	            this.setCameraUp();
	            camera.rotation.x = 90 * Math.PI / 180;
	
	            var camPosition = START_CAMERA_POSITION[this.viewType];
	            if (position) {
	                camera.position.x = position.x;
	                camera.position.y = position.y;
	                camera.position.z = position.z;
	            } else {
	                camera.position.x = camPosition.x * this.cameraDistanceRatio;
	                camera.position.y = camPosition.y * this.cameraDistanceRatio;
	                camera.position.z = camPosition.z * this.cameraDistanceRatio;
	            }
	        }
	    }, {
	        key: 'getControls',
	        value: function getControls() {
	            return this.controls;
	        }
	    }, {
	        key: 'limitCameraMovements',
	        value: function limitCameraMovements() {
	            var controls = this.getControls();
	            controls.minPolarAngle = -Math.PI;
	            controls.maxPolarAngle = -Math.PI;
	            controls.maxDistance = this.cameraDistanceRatio * this.getMaxDistanceRatio();
	        }
	    }, {
	        key: 'getBase64Image',
	        value: function getBase64Image() {
	            var strMime = "image/png";
	            return this.renderer.domElement.toDataURL(strMime, 1);
	        }
	    }, {
	        key: 'initArrow',
	        value: function initArrow(type, maxDimentions) {
	            var DIMENSION_RATIO = maxDimentions / 250;
	            var colorMapper = {
	                '0': DEFAULT_MATERIAL_COLOR,
	                '1': GREEN_MATERIAL_COLOR,
	                '-1': RED_MATERIAL_COLOR
	            };
	            var CYL_RAD = 6 * DIMENSION_RATIO;
	            var CYL_WIDTH = 2 * DIMENSION_RATIO;
	            var ARR_RAD = 7 * DIMENSION_RATIO;
	            var ARR_LEN = 5 * DIMENSION_RATIO;
	            var TOTAL_LEN = 20 * DIMENSION_RATIO;
	            var HAF_TOTAL_LEN = 10 * DIMENSION_RATIO;
	            var CIR_RAD = 3 * DIMENSION_RATIO;
	            var CIR_WIDTH = 1 * DIMENSION_RATIO;
	
	            var material = new THREE.MeshPhongMaterial({ color: colorMapper[type] });
	
	            var plate1 = new THREE.CylinderGeometry(CYL_RAD, CYL_RAD, CYL_WIDTH);
	            var plate1Mesh = new THREE.Mesh(plate1, material);
	            plate1Mesh.position.set(0, -HAF_TOTAL_LEN, 0);
	
	            var plate2 = new THREE.CylinderGeometry(CYL_RAD, CYL_RAD, CYL_WIDTH);
	            var plate2Mesh = new THREE.Mesh(plate2, material);
	            plate2Mesh.position.set(0, HAF_TOTAL_LEN, 0);
	
	            var arrow1 = new THREE.CylinderGeometry(0, ARR_LEN, ARR_RAD);
	            var arrow1Mesh = new THREE.Mesh(arrow1, material);
	            arrow1Mesh.position.set(0, HAF_TOTAL_LEN, 0);
	
	            var arrow2 = new THREE.CylinderGeometry(ARR_LEN, 0, ARR_RAD);
	            var arrow2Mesh = new THREE.Mesh(arrow2, material);
	            arrow2Mesh.position.set(0, -HAF_TOTAL_LEN, 0);
	
	            var settingsMapper = {
	                '0': {
	                    edge1: plate1Mesh,
	                    edge2: plate2Mesh
	                }, '1': {
	                    edge1: arrow1Mesh,
	                    edge2: plate1Mesh
	                }, '-1': {
	                    edge1: arrow2Mesh,
	                    edge2: plate2Mesh
	                }
	            };
	
	            var container = new THREE.Object3D();
	
	            var cirMaterial = new THREE.MeshPhongMaterial({ color: ARROW_CYR_MATERIAL_COLOR });
	
	            var body = new THREE.CylinderGeometry(CYL_WIDTH, CYL_WIDTH, TOTAL_LEN);
	            var bodyMesh = new THREE.Mesh(body, material);
	            container.add(bodyMesh);
	
	            var cir = new THREE.CylinderGeometry(CIR_RAD, CIR_RAD, CIR_WIDTH);
	            var cirMesh = new THREE.Mesh(cir, cirMaterial);
	            container.add(cirMesh);
	
	            container.add(settingsMapper[type].edge1);
	            container.add(settingsMapper[type].edge2);
	
	            container.rotateX(Math.PI / 2);
	
	            this.scene.add(container);
	        }
	    }]);
	    return BaseScene;
	}();
	
	var MeshScene = function (_BaseScene) {
	    (0, _inherits3.default)(MeshScene, _BaseScene);
	
	    function MeshScene(rawGeometry, width, height, position) {
	        (0, _classCallCheck3.default)(this, MeshScene);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MeshScene.__proto__ || (0, _getPrototypeOf2.default)(MeshScene)).call(this, width, height, rawGeometry.maxDimensions, position.free, 'free'));
	
	        _this.data = rawGeometry;
	        var geometry = _this.generateGeometry(rawGeometry.mesh);
	        var material = new THREE.MeshPhongMaterial({ opacity: geometry.alpha, vertexColors: THREE.VertexColors, side: THREE.DoubleSide, color: DEFAULT_MATERIAL_COLOR });
	        material.side = THREE.DoubleSide;
	        var mesh = new THREE.Mesh(geometry, material);
	        _this.scene.add(mesh);
	
	        _this.initArrow(rawGeometry.offset.value, rawGeometry.maxDimensions);
	        _this.initAxis();
	        _this.getControls().center = geometry.center();
	        return _this;
	    }
	
	    return MeshScene;
	}(BaseScene);
	
	var FormabilityScene = function (_BaseScene2) {
	    (0, _inherits3.default)(FormabilityScene, _BaseScene2);
	
	    function FormabilityScene(data, width, height, position) {
	        (0, _classCallCheck3.default)(this, FormabilityScene);
	
	        var _data = (0, _slicedToArray3.default)(data, 2),
	            geometry = _data[0],
	            maxDimensions = _data[1];
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (FormabilityScene.__proto__ || (0, _getPrototypeOf2.default)(FormabilityScene)).call(this, width, height, maxDimensions, position.free, 'free'));
	
	        geometry.mergeVertices();
	        geometry.computeVertexNormals();
	        var material = new THREE.MeshPhongMaterial({ opacity: 1, vertexColors: THREE.VertexColors, side: THREE.DoubleSide });
	        material.side = THREE.DoubleSide;
	        var mesh = new THREE.Mesh(geometry, material);
	        _this2.scene.add(mesh);
	        _this2.initAxis();
	
	        _this2.getControls().center = geometry.center();
	        return _this2;
	    }
	
	    return FormabilityScene;
	}(BaseScene);
	
	var BlankScene = function (_BaseScene3) {
	    (0, _inherits3.default)(BlankScene, _BaseScene3);
	    (0, _createClass3.default)(BlankScene, [{
	        key: 'setCameraUp',
	        value: function setCameraUp() {
	            this.camera.up.set(0, -1, 0);
	        }
	    }, {
	        key: 'getMaxDistanceRatio',
	        value: function getMaxDistanceRatio() {
	            return 900;
	        }
	    }]);
	
	    function BlankScene(data, width, height, position) {
	        (0, _classCallCheck3.default)(this, BlankScene);
	
	        var _data2 = (0, _slicedToArray3.default)(data, 3),
	            boundaryData = _data2[0],
	            meshData = _data2[1],
	            maxDimensions = _data2[2];
	
	        var _this3 = (0, _possibleConstructorReturn3.default)(this, (BlankScene.__proto__ || (0, _getPrototypeOf2.default)(BlankScene)).call(this, width, height, maxDimensions, position.blank, 'blank'));
	
	        var boundaryObj = (0, _boundaries.generateBoundary)(boundaryData);
	        var mesh = _this3.generateGeometry(meshData, boundaryObj[0].maxY + 1);
	
	        var _boundaryObj = (0, _slicedToArray3.default)(boundaryObj, 2),
	            boundary = _boundaryObj[1];
	
	        var lineMaterial = new THREE.LineBasicMaterial({ linewidth: 1 });
	        lineMaterial.color.setHex(BOUNDARY_COLOR);
	        var line = new THREE.Line(boundary, lineMaterial);
	        var meshMaterial = new THREE.MeshPhongMaterial({ opacity: mesh.alpha, vertexColors: THREE.VertexColors, side: THREE.DoubleSide, color: DEFAULT_MATERIAL_COLOR });
	        meshMaterial.side = THREE.DoubleSide;
	        var meshLL = new THREE.Mesh(mesh, meshMaterial);
	
	        _this3.scene.add(line);
	        _this3.scene.add(meshLL);
	
	        _this3.limitCameraMovements();
	        return _this3;
	    }
	
	    (0, _createClass3.default)(BlankScene, [{
	        key: 'restoreView',
	        value: function restoreView(width, height, position) {
	            (0, _get3.default)(BlankScene.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlankScene.prototype), 'restoreView', this).call(this, width, height, position);
	            this.limitCameraMovements();
	        }
	    }]);
	    return BlankScene;
	}(BaseScene);
	
	var NestScene = function (_BaseScene4) {
	    (0, _inherits3.default)(NestScene, _BaseScene4);
	
	    function NestScene(data, width, height, position) {
	        (0, _classCallCheck3.default)(this, NestScene);
	
	        var _data3 = (0, _slicedToArray3.default)(data, 3),
	            boundariesData = _data3[0],
	            edges = _data3[1],
	            maxDimensions = _data3[2];
	
	        var _this4 = (0, _possibleConstructorReturn3.default)(this, (NestScene.__proto__ || (0, _getPrototypeOf2.default)(NestScene)).call(this, width, height, maxDimensions * 4, position.nest, 'nest'));
	
	        var lineMaterial = new THREE.LineBasicMaterial({ linewidth: 20 });
	        lineMaterial.color.setHex(BOUNDARY_COLOR);
	
	        var _generateBoundaries = (0, _boundaries.generateBoundaries)(boundariesData, edges, maxDimensions),
	            _generateBoundaries2 = (0, _slicedToArray3.default)(_generateBoundaries, 2),
	            boundaryData = _generateBoundaries2[0],
	            boundaries = _generateBoundaries2[1];
	
	        _this4.container = new THREE.Object3D();
	
	        boundaries.forEach(function (boundaryObj) {
	            var _boundaryObj2 = (0, _slicedToArray3.default)(boundaryObj, 2),
	                boundary = _boundaryObj2[1];
	
	            var line = new THREE.Line(boundary, lineMaterial);
	            _this4.container.add(line);
	        });
	
	        var _this4$getPlane = _this4.getPlane(boundaryData, edges),
	            _this4$getPlane2 = (0, _slicedToArray3.default)(_this4$getPlane, 2),
	            plane = _this4$getPlane2[1];
	
	        _this4.maxPlateDimention = _.max([boundaryData.dimentionX, boundaryData.dimentionZ]) * 1.5;
	        _this4.container.add(plane);
	        _this4.container.rotation.y = Math.PI / 2;
	        _this4.scene.add(_this4.container);
	
	        _this4.limitCameraMovements();
	        return _this4;
	    }
	
	    (0, _createClass3.default)(NestScene, [{
	        key: 'limitCameraMovements',
	        value: function limitCameraMovements() {
	            var controls = this.getControls();
	            controls.minPolarAngle = -Math.PI;
	            controls.maxPolarAngle = -Math.PI;
	            controls.maxDistance = this.maxPlateDimention;
	        }
	    }, {
	        key: 'getMaxDistanceRatio',
	        value: function getMaxDistanceRatio() {
	            return 550;
	        }
	    }, {
	        key: 'setLightPosition',
	        value: function setLightPosition(camera) {
	            this.light.position.set(camera.position.x, camera.position.y - 400, camera.position.z);
	        }
	    }, {
	        key: 'setCameraUp',
	        value: function setCameraUp() {
	            this.camera.up.set(0, -1, 0);
	        }
	    }, {
	        key: 'restoreView',
	        value: function restoreView(width, height, position) {
	            (0, _get3.default)(NestScene.prototype.__proto__ || (0, _getPrototypeOf2.default)(NestScene.prototype), 'restoreView', this).call(this, width, height, position);
	            this.limitCameraMovements();
	        }
	    }, {
	        key: 'getPlane',
	        value: function getPlane(boundaryData, edges) {
	            var planeGeometry = new THREE.PlaneGeometry(boundaryData.dimentionX + edges.edge * 2, boundaryData.dimentionZ);
	            var planeMaterial = new THREE.MeshLambertMaterial({ color: DEFAULT_MATERIAL_COLOR, side: THREE.DoubleSide });
	            var plane = new THREE.Mesh(planeGeometry, planeMaterial);
	
	            plane.rotation.set(Math.PI / 2, 0, 0);
	            plane.position.y = 1;
	            plane.position.x = boundaryData.middleX;
	            plane.position.z = boundaryData.middleZ;
	
	            plane.receiveShadow = true;
	            return [planeGeometry, plane];
	        }
	    }]);
	    return NestScene;
	}(BaseScene);
	
	exports.MeshScene = MeshScene;
	exports.FormabilityScene = FormabilityScene;
	exports.BlankScene = BlankScene;
	exports.NestScene = NestScene;

/***/ }),
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.generateBoundary = exports.generateBoundaries = undefined;
	
	var _slicedToArray2 = __webpack_require__(476);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THREE = __webpack_require__(555);
	
	var max = function max(key, value, statistic) {
	    var prevValue = statistic[key];
	    return prevValue === undefined || prevValue < value ? value : prevValue;
	};
	
	var min = function min(key, value, statistic) {
	    var prevValue = statistic[key];
	    return prevValue === undefined || prevValue > value ? value : prevValue;
	};
	
	function generateBoundary(boundary) {
	    var geometry = new THREE.Geometry();
	    var statistic = {};
	
	    var processCoordinate = function processCoordinate(key, value) {
	        var maxKey = 'max' + key;
	        var minKey = 'min' + key;
	        statistic[maxKey] = max(maxKey, value, statistic);
	        statistic[minKey] = min(minKey, value, statistic);
	    };
	
	    boundary.polygons.forEach(function (poly) {
	        var _poly = (0, _slicedToArray3.default)(poly, 3),
	            x = _poly[0],
	            y = _poly[1],
	            z = _poly[2];
	
	        processCoordinate('X', x);
	        processCoordinate('Y', y);
	        processCoordinate('Z', z);
	        geometry.vertices.push(new THREE.Vector3(x, y, z));
	    });
	    return [statistic, geometry];
	}
	
	function getSiftDistance(statistics, edges) {
	    return statistics.maxZ - statistics.minZ + edges.bridgeSpan;
	}
	
	function shiftCoordinates(boundary, distance) {
	    return {
	        polygons: boundary.polygons.map(function (dot) {
	            var _dot = (0, _slicedToArray3.default)(dot, 3),
	                x = _dot[0],
	                y = _dot[1],
	                z = _dot[2];
	
	            return [x, y, z + distance];
	        })
	    };
	}
	
	function shiftRowCoordinates(boundaries, distance) {
	    var results = [];
	    boundaries.forEach(function (boundary) {
	        results.push(shiftCoordinates(boundary, distance));
	    });
	    return results;
	}
	
	function calculateBoundariesStatistic(boundariesData) {
	    var results = {};
	    boundariesData.forEach(function (boundary) {
	        var _boundary = (0, _slicedToArray3.default)(boundary, 1),
	            statistic = _boundary[0];
	
	        results.maxX = max('maxX', results.maxX, statistic);
	        results.minX = min('minX', results.minX, statistic);
	        results.maxZ = max('maxZ', results.maxZ, statistic);
	        results.minZ = min('minZ', results.minZ, statistic);
	    });
	    results.dimentionX = results.maxX - results.minX;
	    results.dimentionZ = results.maxZ - results.minZ;
	    results.middleX = results.maxX - results.dimentionX / 2;
	    results.middleZ = results.maxZ - results.dimentionZ / 2;
	    return results;
	}
	
	function cloneBoundaries(boundaries, edges, pitch) {
	    var results = boundaries.map(function (boundary) {
	        return generateBoundary(boundary);
	    });
	    var newBoundaries = _lodash2.default.concat(shiftRowCoordinates(boundaries, pitch), shiftRowCoordinates(boundaries, -pitch));
	    var result = _lodash2.default.concat(results, newBoundaries.map(function (boundary) {
	        return generateBoundary(boundary);
	    }));
	    return result;
	}
	
	function generateBoundaries(boundaries, edges, pitch) {
	    var boundariesData = cloneBoundaries(boundaries, edges, pitch);
	    return [calculateBoundariesStatistic(boundariesData), boundariesData];
	}
	
	exports.generateBoundaries = generateBoundaries;
	exports.generateBoundary = generateBoundary;

/***/ }),
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(476);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _helvetiker_regularTypeface = __webpack_require__(557);
	
	var _helvetiker_regularTypeface2 = _interopRequireDefault(_helvetiker_regularTypeface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THREE = __webpack_require__(555);
	
	// const font = import('three/examples/fonts/helvetiker_regular.typeface.json');
	
	var CYL_LENGTH = 5;
	var COOR_LENGTH = 7;
	var HALF_CYL_LENGTH = 2.5;
	var CHAR_DISTANCE = 6;
	var CYL_WIDTH = 0.2;
	var ARROW_WIDTH = 0.4;
	var ARROW_LENGTH = 0.8;
	var SPHERE_RADIUS = 0.6;
	var POLIGON_NUMBER = 32;
	
	var YELLOW = 0xDADA00;
	var RED = 0xDA0000;
	var BLUE = 0x009FFE;
	var GREEN = 0x007800;
	
	var PI_DIV_2 = Math.PI / 2;
	
	var Axis = function (_THREE$Object3D) {
	    (0, _inherits3.default)(Axis, _THREE$Object3D);
	    (0, _createClass3.default)(Axis, [{
	        key: 'getSphereMesh',
	        value: function getSphereMesh() {
	            var geometry = new THREE.SphereGeometry(SPHERE_RADIUS, POLIGON_NUMBER, POLIGON_NUMBER);
	            var material = new THREE.MeshPhongMaterial({ color: RED });
	            return new THREE.Mesh(geometry, material);
	        }
	    }, {
	        key: 'getPointerMesh',
	        value: function getPointerMesh(rotateX, rotateZ) {
	            var rotateFunction = void 0,
	                color = void 0,
	                x = 0,
	                y = 0,
	                z = 0,
	                x1 = 0,
	                y1 = 0,
	                z1 = 0;
	            if (rotateX) {
	                rotateFunction = 'rotateX';
	                color = YELLOW;
	                y = ARROW_WIDTH;
	                z = ARROW_LENGTH;
	                z1 = CYL_LENGTH;
	            } else if (rotateZ) {
	                rotateFunction = 'rotateZ';
	                color = GREEN;
	                x = ARROW_WIDTH;
	                z = ARROW_LENGTH;
	                x1 = CYL_LENGTH;
	            } else {
	                color = BLUE;
	                y = ARROW_WIDTH;
	                z = ARROW_LENGTH;
	                y1 = CYL_LENGTH;
	            }
	            var geometry = new THREE.CylinderGeometry(x, y, z);
	            var material = new THREE.MeshPhongMaterial({ color: color });
	            var mesh = new THREE.Mesh(geometry, material);
	            mesh.position.set(x1, y1, z1);
	            if (rotateFunction) {
	                mesh[rotateFunction](PI_DIV_2);
	            }
	            return mesh;
	        }
	    }, {
	        key: 'getCylMesh',
	        value: function getCylMesh(rotateX, rotateZ) {
	            var rotateFunction = void 0,
	                color = void 0,
	                x = 0,
	                y = 0,
	                z = 0;
	            if (rotateX) {
	                rotateFunction = 'rotateX';
	                color = YELLOW;
	                z = HALF_CYL_LENGTH;
	            } else if (rotateZ) {
	                color = GREEN;
	                rotateFunction = 'rotateZ';
	                x = HALF_CYL_LENGTH;
	            } else {
	                color = BLUE;
	                y = HALF_CYL_LENGTH;
	            }
	            var geometry = new THREE.CylinderGeometry(CYL_WIDTH, CYL_WIDTH, CYL_LENGTH);
	            var material = new THREE.MeshPhongMaterial({ color: color });
	            var mesh = new THREE.Mesh(geometry, material);
	            mesh.position.set(x, y, z);
	            if (rotateFunction) {
	                mesh[rotateFunction](-PI_DIV_2);
	            }
	            return mesh;
	        }
	    }, {
	        key: 'getArrowMesh',
	        value: function getArrowMesh(rotateX, rotateZ) {
	            return [this.getCylMesh(rotateX, rotateZ), this.getPointerMesh(rotateX, rotateZ), this.getCharMesh(rotateX, rotateZ)];
	        }
	    }, {
	        key: 'getCharMesh',
	        value: function getCharMesh(rotateX, rotateZ) {
	            var options = {
	                size: 1,
	                height: 0.1,
	                weight: 'normal',
	                font: new THREE.Font(_helvetiker_regularTypeface2.default),
	                style: 'normal',
	                bevelThickness: 0.1,
	                bevelSize: 0.1,
	                bevelSegments: 12,
	                bevelEnabled: true,
	                curveSegments: 12,
	                steps: 1
	            };
	
	            var rotateFunction = void 0,
	                color = void 0,
	                x = 0,
	                y = 0,
	                z = 0,
	                text = '';
	            if (rotateX) {
	                rotateFunction = 'rotateX';
	                color = YELLOW;
	                text = 'Z';
	                z = CHAR_DISTANCE;
	            } else if (rotateZ) {
	                color = GREEN;
	                rotateFunction = 'rotateZ';
	                text = 'Y';
	                x = CHAR_DISTANCE;
	            } else {
	                text = 'X';
	                color = BLUE;
	                y = CHAR_DISTANCE;
	            }
	            var geometry = new THREE.TextGeometry(text, options);
	            var material = new THREE.MeshPhongMaterial({ color: color });
	
	            var mesh = new THREE.Mesh(geometry, material);
	            this[text] = mesh;
	            mesh.position.set(x, y, z);
	            if (rotateFunction) {
	                mesh[rotateFunction](-PI_DIV_2);
	            }
	            return mesh;
	        }
	    }]);
	
	    function Axis(scene, ratio) {
	        (0, _classCallCheck3.default)(this, Axis);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Axis.__proto__ || (0, _getPrototypeOf2.default)(Axis)).call(this));
	
	        _this.ratio = ratio;
	        _this.scene = scene;
	        // this.drawLetters();
	        var axis = new THREE.Object3D();
	
	        var _this$getArrowMesh = _this.getArrowMesh(),
	            _this$getArrowMesh2 = (0, _slicedToArray3.default)(_this$getArrowMesh, 3),
	            cylY = _this$getArrowMesh2[0],
	            pointerY = _this$getArrowMesh2[1],
	            charY = _this$getArrowMesh2[2];
	
	        var _this$getArrowMesh3 = _this.getArrowMesh(true),
	            _this$getArrowMesh4 = (0, _slicedToArray3.default)(_this$getArrowMesh3, 3),
	            cylX = _this$getArrowMesh4[0],
	            pointerX = _this$getArrowMesh4[1],
	            charX = _this$getArrowMesh4[2];
	
	        var _this$getArrowMesh5 = _this.getArrowMesh(undefined, true),
	            _this$getArrowMesh6 = (0, _slicedToArray3.default)(_this$getArrowMesh5, 3),
	            cylZ = _this$getArrowMesh6[0],
	            pointerZ = _this$getArrowMesh6[1],
	            charZ = _this$getArrowMesh6[2];
	
	        axis.add(_this.getSphereMesh(), cylY, pointerY, cylX, pointerX, cylZ, pointerZ, charX, charZ, charY);
	
	        var axisPointer = new THREE.Object3D();
	
	        axisPointer.position.set(-20 * _this.ratio, -19, -60);
	        _this.add(axisPointer);
	        _this.axis = axis;
	        _this.scene.add(axis);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Axis, [{
	        key: 'setPosition',
	        value: function setPosition(camera) {
	            this.position.set(camera.position.x, camera.position.y, camera.position.z);
	            var cameraRotation = camera.rotation.toVector3();
	            this.rotation.setFromVector3(cameraRotation);
	            this.Y.rotation.setFromVector3(cameraRotation);
	            this.Z.rotation.setFromVector3(cameraRotation);
	            this.X.rotation.setFromVector3(cameraRotation);
	            this.children[0].rotation.setFromVector3(new THREE.Vector3());
	            this.scene.updateMatrixWorld();
	            this.updateMatrixWorld();
	            this.children[0].updateMatrixWorld();
	            var pointerPosition = this.children[0].getWorldPosition();
	            this.axis.position.set(pointerPosition.x, pointerPosition.y, pointerPosition.z);
	        }
	    }]);
	    return Axis;
	}(THREE.Object3D);
	
	exports.default = Axis;

/***/ }),
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fileUpload = __webpack_require__(560);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileUpload3 = __webpack_require__(565);
	
	var _fileUpload4 = _interopRequireDefault(_fileUpload3);
	
	var _loadedModel = __webpack_require__(566);
	
	var _loadedModel2 = _interopRequireDefault(_loadedModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileUploadModule = _angular2.default.module('base', []).component('fileUpload', _fileUpload2.default).directive('fileUpload', _fileUpload4.default).service('LoadedModel', _loadedModel2.default).name;
	
	exports.default = fileUploadModule;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fileUpload = __webpack_require__(561);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileUpload3 = __webpack_require__(562);
	
	var _fileUpload4 = _interopRequireDefault(_fileUpload3);
	
	__webpack_require__(563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileUploadComponent = {
	  restrict: 'E',
	  bindings: {
	    fileName: '@',
	    inline: '@'
	  },
	  template: _fileUpload2.default,
	  controller: _fileUpload4.default
	};
	
	exports.default = fileUploadComponent;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!$ctrl.inline && !$ctrl.areConditionsAccepted()\" class=\"file-upload\">\n  <div class=\"agreemnt-container\" >\n    <b>IMPORTANT – BEFORE USING THE EASYBLANK SERVICES, CAREFULLY READ THE LEGAL USE TERMS (”AGREEMENT”) AND OUR PRIVACY POLICY AND ACKNOWLEDGE YOUR ACCEPTANCE AND UNDERSTANDING BY PRESSING THE ACCEPT BUTTON BELOW. IF YOU DO NOT AGREE TO ALL OF THE TERMS AND/OR THE PRIVACY POLICY DO NOT USE THE SERVICES.</b>\n    <div class=\"agreemnt-links\">\n      <info-widget\n        topic=\"terms\"\n        link=\"TERMS AND CONDITIONS\">\n      </info-widget>\n      <a target=\"_blank\" href=\"https://www.autoform.com/en/legal/\">PRIVACY POLICY</a>\n    </div>\n  </div>\n\n  <div>\n    <md-checkbox class=\"md-primary\" ng-model=\"$ctrl.accepted\">\n      I have read and agree to the terms and conditions\n    </md-checkbox>\n    <button class=\"btn button-plain\" ng-disabled=\"!$ctrl.accepted\" ng-click=\"$ctrl.acceptAgreement()\">Accept</button>\n  </div>\n</div>\n<div  ngf-drop=\"$ctrl.uploadFiles($files)\"\n      ngf-drag-over-class=\"'dragover'\" ngf-multiple=\"false\"\n      ngf-pattern=\"'.stl,.igs'\"  ng-if=\"!$ctrl.inline && $ctrl.areConditionsAccepted()\" class=\"file-upload\">\n  <div class=\"file-upload-center\">\n    <div  class=\"drop-box\">\n      {{ $ctrl.uploadText }}\n    </div>\n    <label file-upload class=\"btn btn-default btn-file button-navigation\">\n      Upload<span class=\"icon easyblank-icon\">N</span>\n      <input class='upload-file' accept=\".igs, .stl, .IGS, .STL\" type=\"file\" style=\"display: none;\">\n    </label>\n  </div>\n</div>\n<div ng-if=\"$ctrl.inline\" class=\"form-group\">\n  <label class=\"control-label\">\n    Part\n  </label>\n  <div class=\"input-group\">\n    <input type=\"text\" ng-model=\"$ctrl.model.fileName\" class=\"form-control file-input\" readonly=\"\">\n    <label class=\"input-group-btn\">\n      <span file-upload class=\"btn file-input-button\">\n        <span class=\"input-container-inline\">\n          <span class=\"icon easyblank-icon file-input-button-inline\">J</span></span>\n        <input type=\"file\" style=\"display: none;\" multiple=\"\">\n      </span>\n    </label>\n  </div>\n</div>\n"

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileUploadController = function () {
	    function FileUploadController($scope, $state, LoadedModel, $uibModal) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, FileUploadController);
	
	        this._$state = $state;
	        this._$scope = $scope;
	        this._$uibModal = $uibModal;
	        this.model = LoadedModel;
	
	        var defaultUploadText = "Please upload 3D model (*.igs or *.stl only) via selection or drag and drop";
	        this.uploadText = defaultUploadText;
	
	        $scope.$on('fileLoaded', function (event, geometry) {
	            setTimeout(function () {
	                LoadedModel.uploadFile(geometry);
	            });
	        });
	
	        $scope.$on('meshError', function (event, error) {
	            _this.uploadText = error ? error : defaultUploadText;
	            _this._$scope.$apply();
	        });
	    }
	
	    (0, _createClass3.default)(FileUploadController, [{
	        key: 'hideButton',
	        value: function hideButton() {
	            if (this._$state.current.name === 'home') {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'areConditionsAccepted',
	        value: function areConditionsAccepted() {
	            return localStorage.getItem('isAgreementAccepted') === 'yes';
	        }
	    }, {
	        key: 'acceptAgreement',
	        value: function acceptAgreement() {
	            return localStorage.setItem('isAgreementAccepted', 'yes');
	        }
	    }, {
	        key: 'uploadFiles',
	        value: function uploadFiles(files) {
	            if (files.length) {
	                var file = files[0];
	                if (file.size > 15728640) {
	                    this._$scope.$broadcast('meshError', 'File is too big, maximum file size is 15MB.');
	                } else {
	                    this.model.uploadFile({
	                        fileName: file.name,
	                        rawData: file
	                    });
	                }
	            }
	            this._$scope.files = files;
	        }
	    }]);
	    return FileUploadController;
	}();
	
	FileUploadController.$inject = ['$scope', '$state', 'LoadedModel', '$uibModal'];
	
	exports.default = FileUploadController;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(564);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./file-upload.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./file-upload.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, ".base-gradient{background:linear-gradient(0deg,#cdcdcd,#fefefe,#cdcdcd)}body{height:100%;font:62.5% helvetica,arial,verdana,sans-serif}.css-form input.ng-invalid.ng-touched{background-color:#fa787e}.button-general,.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev,label.button-navigation{border-radius:0;color:#fff}.button-general:focus,.button-general:hover,.button-navigation:focus,.button-navigation:hover,button.button-cancel:focus,button.button-cancel:hover,button.button-next:focus,button.button-next:hover,button.button-plain:focus,button.button-plain:hover,button.button-prev:focus,button.button-prev:hover,label.button-navigation:focus,label.button-navigation:hover{color:#fff}.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev,label.button-navigation{padding:10px 20px;border-width:1px;border-color:#fff;background-color:#406494}button.button-cancel{background-color:#999}.button-icon,button.button-next .button-arrow{margin-left:5px}button.button-prev .button-arrow{margin-right:5px}.capcha-container{padding:0 17px}.form-error-label{color:red;font-style:italic}select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\"}.utilization-info{margin-top:20px}.utilization-info,.utilization-info .table-row{margin-bottom:10px}.input-error{background-color:#fa787e!important}.agreemnt-container{text-align:center;padding:100px 100px 150px}.agreemnt-container p{text-indent:20px}.agreemnt-links{padding-top:20px}.agreemnt-links a{padding-left:20px;padding-right:20px;padding-bottom:10px;cursor:pointer}.file-upload{height:100%;text-align:center}.file-upload-center{position:fixed;top:50%;left:50%;margin-top:-50px;margin-left:-100px;margin:0 auto}.file-upload-center .drop-box{font-size:30px;max-width:500px;color:#969696}label.button-navigation.active,label.button-navigation.active:hover,label.button-navigation:hover{background-color:#406494}.base{background-color:#263238;height:50rem;padding:3rem}.base *{color:#f5f5f5}.input-container-inline{display:inline-block;width:14px;height:14px}.input-container-inline .file-input-button-inline{position:absolute;left:7px;top:9px}", ""]);
	
	// exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileUpload = function FileUpload($state, $rootScope) {
	    return {
	        restrict: "A",
	        link: function link($scope, $element) {
	            var fileName = void 0;
	            var el = $element.find('input');
	
	            function checkExtension(fileName) {
	                var y = fileName.split(".");
	                var extension = y[y.length - 1];
	
	                return ['igs', 'stl'].indexOf(extension.toLocaleLowerCase()) !== -1;
	            }
	
	            function checkSize(file) {
	                return file.size < 15 * 1048576;
	            }
	
	            function updateModel(e) {
	                fileName = _lodash2.default.get(e, 'target.files[0].name', false);
	                if (fileName) {
	                    if (!checkExtension(fileName)) {
	                        $rootScope.$broadcast('meshError', "Wrong file format, only .igs and .stl files are allowed.");
	                    } else if (!checkSize(e.target.files[0])) {
	                        $rootScope.$broadcast('meshError', "File is too big, maximum file size is 15MB.");
	                    } else {
	                        $rootScope.$broadcast('fileLoaded', {
	                            mesh: "",
	                            fileName: fileName,
	                            rawData: e.target.files[0]
	                        });
	                        $rootScope.$broadcast('meshError', undefined);
	                    }
	                    el[0].value = "";
	                }
	            }
	
	            el.bind('change', updateModel);
	        }
	    };
	};
	
	FileUpload.$inject = ['$state', '$rootScope', 'LoadedModel'];
	
	exports.default = FileUpload;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(476);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(567);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(587);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(589);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _afebConventor = __webpack_require__(592);
	
	var _afebConventor2 = _interopRequireDefault(_afebConventor);
	
	var _selectOptions = __webpack_require__(593);
	
	var _selectOptions2 = _interopRequireDefault(_selectOptions);
	
	var _fieldProcessor = __webpack_require__(594);
	
	var _fieldProcessor2 = _interopRequireDefault(_fieldProcessor);
	
	var _boundariesHelpers = __webpack_require__(595);
	
	var _boundariesHelpers2 = _interopRequireDefault(_boundariesHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPARATION_NOTIFICATION_GAP = 17 * 60 * 1000;
	
	var LoadedModel = function () {
	    function LoadedModel($resource, $state, $rootScope, $interval) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, LoadedModel);
	
	        this._$resource = $resource;
	        this._$state = $state;
	        this._$rootScope = $rootScope;
	        this._afebConvertor = new _afebConventor2.default();
	        this._options = (0, _selectOptions2.default)();
	        this.fieldProcessor = new _fieldProcessor2.default();
	        this.setDefaultParams();
	        $interval(function () {
	            if (_this.showExpirationDialog()) {
	                _this._$rootScope.$broadcast('showExpirationDialog');
	            }
	        }, 5000);
	    }
	
	    (0, _createClass3.default)(LoadedModel, [{
	        key: 'showExpirationDialog',
	        value: function showExpirationDialog() {
	            return this.expirationTime && this.hasMesh() && !this.requestInProgress && Date.now() - EXPARATION_NOTIFICATION_GAP > this.expirationTime;
	        }
	    }, {
	        key: 'setDefaultParams',
	        value: function setDefaultParams(stepToOmit) {
	            var _this2 = this;
	
	            var fields = this.fieldProcessor.getDefaultParams();
	            var fieldsToOmit = [];
	
	            if (stepToOmit) {
	                this.getPassedStepsByStep(stepToOmit).forEach(function (step) {
	                    fieldsToOmit = fieldsToOmit.concat(_this2.fieldProcessor.getUIKeysByStep(step));
	                });
	                fields = _lodash2.default.omit(fields, fieldsToOmit);
	            }
	
	            for (var key in fields) {
	                this[key] = fields[key];
	            }
	        }
	    }, {
	        key: 'thicknessGetFocus',
	        value: function thicknessGetFocus() {
	            this._thicknessTMP = this._thickness;
	        }
	    }, {
	        key: 'invalidateThickness',
	        value: function invalidateThickness() {
	            if (this._thicknessTMP !== this._thickness) {
	                this._thicknessTMP = this._thickness;
	                this._$rootScope.$broadcast('partStepChanged');
	            }
	        }
	    }, {
	        key: 'isThicknessValid',
	        value: function isThicknessValid() {
	            var limitValue = this._unit.value === 'psi' ? this.convertMetricToPSI(8) : 8;
	            return this._thickness <= limitValue;
	        }
	    }, {
	        key: 'getCurrNestValues',
	        value: function getCurrNestValues() {
	            var result = {
	                materialCost: this.materialCost,
	                priceUnit: this.priceUnit.value,
	                addWidth: this.addWidth,
	                bridgeSpan: this.bridgeSpan,
	                nType: this.nType.value,
	                orientType: this.orientType.value
	
	            };
	            if (result.orientAngle) {
	                result.orientAngle = this.orientAngle;
	            }
	            return result;
	        }
	    }, {
	        key: 'getCurrBlankValues',
	        value: function getCurrBlankValues() {
	            return {
	                customWidth: this.customWidth
	            };
	        }
	    }, {
	        key: 'getNestBoundaries',
	        value: function getNestBoundaries() {
	            var result = [this.nestN2];
	            if (this.nestN3) {
	                result.push(this.nestN3); // Tmp changes should be returned after some testing.
	            }
	            return result;
	        }
	    }, {
	        key: 'getFloatPitch',
	        value: function getFloatPitch() {
	            return this.pitch ? parseFloat(this.pitch.replace(',', '.'), 2) : undefined;
	        }
	    }, {
	        key: 'convertToCurrentSys',
	        value: function convertToCurrentSys(value) {
	            return this._unit.value === 'psi' ? value * 25.4 : value;
	        }
	    }, {
	        key: 'getViewData',
	        value: function getViewData(key) {
	            var dataMapper = {
	                blank: [this.boundary, this.meshLL, this.maxDimensions],
	                feasibility: [this.getFormabilityData(), this.maxDimensions],
	                thinning: [this.getThinningData(), this.maxDimensions],
	                nest: [this.getNestBoundaries(), this.calculateEdges(), this.convertToCurrentSys(this.getFloatPitch())],
	                mesh: {
	                    fileName: this.fileName,
	                    mesh: this.mesh,
	                    maxDimensions: this.maxDimensions
	                } };
	            return dataMapper[key];
	        }
	    }, {
	        key: 'updateSim',
	        value: function updateSim(simData) {
	            var _this3 = this;
	
	            (0, _keys2.default)(simData).forEach(function (key) {
	                _this3[key] = simData[key];
	            });
	        }
	    }, {
	        key: 'updateSimAndCash',
	        value: function updateSimAndCash(holdingCond, simData) {
	            this.cashedSim[holdingCond] = simData;
	            this.updateSim(simData);
	        }
	    }, {
	        key: 'getCashed',
	        value: function getCashed() {
	            return this.cashedSim[this.holdingCond] || false;
	        }
	    }, {
	        key: 'getCashedSimView',
	        value: function getCashedSimView() {
	            var holdViews = this.cashedSimViews[this.holdingCond] || false;
	            if (holdViews) {
	                return holdViews[this.results] || false;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'setCashedView',
	        value: function setCashedView(view) {
	            var holdViews = this.cashedSimViews[this.holdingCond] || false;
	            if (!holdViews) {
	                this.cashedSimViews[this.holdingCond] = {};
	                holdViews = this.cashedSimViews[this.holdingCond];
	            }
	            holdViews[this.results] = view;
	        }
	    }, {
	        key: 'getMeshLL',
	        value: function getMeshLL() {
	            var cashedData = this.cashedSim[this.holdingCond];
	            if (cashedData) {
	                return cashedData.meshLL;
	            } else {
	                return this.meshLL;
	            }
	        }
	    }, {
	        key: 'updateBoundary',
	        value: function updateBoundary() {
	            var useCustom = this.showWidthInput && this.isUsedCustomWidth;
	            var dataFile = useCustom ? this.blankBoundaryModCustom : this.blankBoundaryMod;
	            var width = useCustom ? 4 : this.width;
	            var meshLL = this.getMeshLL();
	            if (dataFile) {
	                this._$rootScope.$broadcast('updateView', [[(0, _boundariesHelpers2.default)(dataFile, this._convex, this._smooth, width), meshLL, this.maxDimensions], undefined, 'blank']);
	            }
	        }
	    }, {
	        key: 'isStepPassed',
	        value: function isStepPassed(step) {
	            return this.passedSteps.indexOf(step) !== -1;
	        }
	    }, {
	        key: 'calculateEdges',
	        value: function calculateEdges() {
	            // TODO find correct formulas
	            return {
	                bridgeSpan: _lodash2.default.isNaN(parseFloat(this.bridgeSpan)) ? 0 : parseFloat(this.bridgeSpan),
	                edge: this.convertToCurrentSys(_lodash2.default.isNaN(parseFloat(this.addWidth)) ? 0 : parseFloat(this.addWidth))
	            };
	        }
	    }, {
	        key: 'getBoundaryData',
	        value: function getBoundaryData() {
	            // return this.blankBoundaryMod || this.boundary;
	            return this.boundary;
	        }
	    }, {
	        key: 'getThinningData',
	        value: function getThinningData() {
	            return this._afebConvertor.convertThinning(this.afeb);
	        }
	    }, {
	        key: 'getFormabilityData',
	        value: function getFormabilityData() {
	            return this._afebConvertor.convertFormability(this.afeb);
	        }
	    }, {
	        key: 'hasMesh',
	        value: function hasMesh() {
	            return !!this.mesh;
	        }
	    }, {
	        key: 'uuid',
	        value: function uuid() {
	            var d = new Date().getTime();
	            if (window.performance && typeof window.performance.now === "function") {
	                d += performance.now(); //use high-precision timer if available
	            }
	            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = (d + Math.random() * 16) % 16 | 0;
	                d = Math.floor(d / 16);
	                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	            });
	            return uuid;
	        }
	    }, {
	        key: 'getProgress',
	        value: function getProgress(timeStamp, step, first) {
	            var _this4 = this;
	
	            var req = first ? { first: true } : {};
	            req.timestamp = timeStamp;
	            this._$resource('/api/progress').get(req).$promise.then(function (data) {
	                _this4._$rootScope.$broadcast('progressUpdated', { step: step, key: data.progress });
	                if (_this4.requestInProgress && data.progress !== 'finish') {
	                    _this4.getProgress(data.timestamp, step);
	                }
	            });
	        }
	    }, {
	        key: 'fillProperties',
	        value: function fillProperties(resource, step, uniqParam) {
	            var _this5 = this;
	
	            this.fieldProcessor.getStepValues()[step].forEach(function (key) {
	                resource[key] = _this5[key];
	            });
	            resource.timestamp = uniqParam;
	            resource.passedSteps = this.addPassedStep(step);
	            return resource;
	        }
	    }, {
	        key: 'getInvalidateKeys',
	        value: function getInvalidateKeys(step) {
	            return this.fieldProcessor.getInvalidatedKeys(step);
	        }
	    }, {
	        key: 'addPassedStep',
	        value: function addPassedStep(step) {
	            var mapper = {
	                clear: [],
	                part: ['part'],
	                feasibility: ['part', 'feasibility'],
	                blank: ['part', 'feasibility', 'blank'],
	                nest: ['part', 'feasibility', 'blank', 'nest'],
	                report: ['part', 'feasibility', 'blank', 'nest']
	            };
	            return mapper[step];
	        }
	    }, {
	        key: 'takeSnapshot',
	        value: function takeSnapshot(viewName, reportType) {
	            var snapshot = this.getBase64Image(viewName);
	            if (snapshot) {
	                this.snapshots.push({
	                    image: snapshot,
	                    type: viewName,
	                    index: Date.now(),
	                    selected: false,
	                    default: reportType
	                });
	            }
	        }
	    }, {
	        key: 'getBase64Image',
	        value: function getBase64Image(viewName) {
	            var view = this[viewName];
	            if (view) {
	                return view.getBase64Image();
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'getPassedStepsByStep',
	        value: function getPassedStepsByStep(step) {
	            var stepMapper = {
	                'part': ['part'],
	                'feasibility': ['part', 'feasibility'],
	                'blank': ['part', 'feasibility', 'blank'],
	                'nest': ['part', 'feasibility', 'blank', 'nest']
	            };
	            return stepMapper[step];
	        }
	    }, {
	        key: 'invalidateSnapshots',
	        value: function invalidateSnapshots(step) {
	            var invalidateMap = {
	                feasibility: ['thinningView', 'formabilityView', 'blankView', 'nestView'],
	                part: ['thinningView', 'formabilityView', 'blankView', 'nestView'],
	                blank: ['blankView', 'nestView'],
	                nest: ['nestView']
	            };
	            _lodash2.default.remove(this.snapshots, function (item) {
	                if (invalidateMap[step].indexOf(item.type) === -1) {
	                    return false;
	                } else {
	                    return true;
	                }
	            });
	        }
	    }, {
	        key: 'invalidateUI',
	        value: function invalidateUI(step) {
	            this.setDefaultParams(step);
	            this.invalidateSnapshots(step);
	            this.passedSteps = this.getPassedStepsByStep(step);
	        }
	    }, {
	        key: 'invalidateStep',
	        value: function invalidateStep(step) {
	            var _this6 = this;
	
	            this._$rootScope.$broadcast('solverStarted', 'Invalidating');
	            this.sendInvalidateRequest(step).then(function () {
	                _this6.generateExpTime();
	                _this6.invalidateUI(step);
	                _this6._$rootScope.$broadcast('solverFinished', 'Invalidating');
	                _this6._$rootScope.$broadcast('updateSteps', { step: step });
	            }, function (err) {
	                _this6._$rootScope.$broadcast('showErrorDialog', { type: 'error' });
	                _this6.generateExpTime();
	                _this6._$rootScope.$broadcast('solverFinished', 'Invalidating');
	                // TODO handle me
	            });
	        }
	    }, {
	        key: 'sendInvalidateRequest',
	        value: function sendInvalidateRequest(step) {
	            var res = new this._$resource('/api/invalidate');
	            return res.save({ step: step }).$promise;
	        }
	    }, {
	        key: 'sendReport',
	        value: function sendReport(uniqParam) {
	            var _this7 = this;
	
	            // const promise = new Promise((resolve, reject) => {
	            var xhr = new XMLHttpRequest();
	            var fd = new FormData();
	
	            var dataURLtoFile = function dataURLtoFile(dataurl) {
	                var arr = dataurl.split(','),
	                    mime = arr[0].match(/:(.*?);/)[1];
	                var binary = atob(dataurl.split(',')[1]);
	                var array = [];
	                for (var i = 0; i < binary.length; i++) {
	                    array.push(binary.charCodeAt(i));
	                }return new Blob([new Uint8Array(array)], { type: mime });
	            };
	
	            var keyList = ['materialCost', 'scrapVal', 'fileName', 'partsNumber', 'userLastName', 'email', 'comment', 'organization', 'name', 'snapshots', 'addNumber', 'phone', 'phoneCode'];
	
	            keyList.forEach(function (key) {
	                fd.append(key, _this7[key]);
	            });
	            var imageTypes = [];
	            var selectedSnapshots = this.getSelectedSnapshots();
	            selectedSnapshots.forEach(function (snapshot, index) {
	                var fileName = 'image' + index;
	                fd.append("file", dataURLtoFile(snapshot.image), fileName);
	                imageTypes.push(snapshot.type);
	            });
	
	            var errorHandler = function errorHandler(error) {
	                try {
	                    var result = JSON.parse(error.target.response);
	                    _this7._$rootScope.$broadcast('showErrorDialog', { text: result });
	                } catch (err) {
	                    _this7._$rootScope.$broadcast('showErrorDialog', { type: 'error' });
	                }
	                _this7.generateExpTime();
	                _this7._$rootScope.$broadcast('solverFinished', 'report');
	                _this7.requestInProgress = false;
	            };
	
	            fd.append('imageTypes', imageTypes);
	            fd.append('timestamp', uniqParam);
	
	            xhr.open("POST", 'api/solver/report', true);
	            xhr.send(fd);
	
	            xhr.onload = function (resp) {
	                if ([500, 503].indexOf(resp.target.status) === -1) {
	                    _this7.requestInProgress = false;
	                    _this7.generateExpTime();
	                    var result = JSON.parse(resp.target.response);
	                    _this7._$rootScope.$broadcast('sendReportData', result);
	                    _this7._$rootScope.$broadcast('solverFinished', 'report');
	                    _this7.calculateUtilizationInfo();
	                } else {
	                    errorHandler(resp);
	                }
	            };
	
	            xhr.onerror = function (err) {
	                errorHandler(resp);
	            };
	
	            xhr.timeout = function (err) {
	                errorHandler(resp);
	            };
	        }
	    }, {
	        key: 'sendUserData',
	        value: function sendUserData(uuid) {
	            var res = new this._$resource('/api/save-user-info');
	            return res.save({
	                uuid: uuid,
	                email: this.email,
	                name: this.name,
	                userLastName: this.userLastName,
	                organization: this.organization,
	                phoneCode: this.phoneCode,
	                phone: this.phone,
	                addNumber: this.addNumber
	            }).$promise;
	        }
	    }, {
	        key: 'saveUserDetails',
	        value: function saveUserDetails() {
	            localStorage.setItem('userInfoDetails', (0, _stringify2.default)({
	                email: this.email,
	                name: this.name,
	                userLastName: this.userLastName,
	                organization: this.organization,
	                phoneCode: this.phoneCode,
	                phone: this.phone,
	                addNumber: this.addNumber
	            }));
	        }
	    }, {
	        key: 'getUserInfo',
	        value: function getUserInfo(uuid) {
	            var _this8 = this;
	
	            var res = new this._$resource('/api/get-user-info');
	            return res.get({
	                uuid: uuid
	            }).$promise.then(function (data) {
	                _this8.email = data.email;
	                _this8.name = data.name;
	                _this8.userLastName = data.userLastName;
	                _this8.organization = data.organization;
	                _this8.phoneCode = data.phoneCode;
	                _this8.phone = data.phone;
	                _this8.addNumber = data.addNumber === 'true' ? true : false;
	            }, function (error) {
	                _this8.email = '';
	                _this8.name = '';
	                _this8.userLastName = '';
	                _this8.organization = '';
	                _this8.phoneCode = '';
	                _this8.phone = '';
	                _this8.addNumber = false;
	            });
	        }
	    }, {
	        key: 'restoreUserDetails',
	        value: function restoreUserDetails() {
	            var dataToParse = localStorage.getItem('userInfoDetails');
	            if (dataToParse) {
	                var data = JSON.parse(dataToParse);
	                this.email = data.email;
	                this.name = data.name;
	                this.userLastName = data.userLastName;
	                this.organization = data.organization;
	                this.phoneCode = data.phoneCode;
	                this.phone = data.phone;
	                this.addNumber = data.addNumber;
	            }
	            return !!dataToParse;
	        }
	    }, {
	        key: 'getSelectedSnapshots',
	        value: function getSelectedSnapshots() {
	            return this.snapshots.filter(function (snapshot) {
	                return snapshot.selected === true;
	            });
	        }
	    }, {
	        key: 'getSnapshotsLength',
	        value: function getSnapshotsLength() {
	            return this.getSelectedSnapshots().length;
	        }
	    }, {
	        key: 'generateExpTime',
	        value: function generateExpTime() {
	            this.expirationTime = Date.now();
	        }
	    }, {
	        key: 'getErrResponse',
	        value: function getErrResponse(res) {
	            var result = "Missing response from server";
	            try {
	                result = JSON.parse(res).error;
	            } catch (err) {}
	            return result;
	        }
	    }, {
	        key: 'uploadFile',
	        value: function uploadFile(geometry) {
	            var _this9 = this;
	
	            this._$rootScope.$broadcast('solverStarted', 'part');
	            this.setDefaultParams();
	            var xhr = new XMLHttpRequest();
	            var formData = new FormData();
	            var timeStamp = this.uuid();
	
	            formData.append("file", geometry.rawData);
	            formData.append("fileName", geometry.fileName);
	            formData.append("passedSteps", this.addPassedStep('part'));
	            formData.append("timestamp", timeStamp);
	            formData.append("name", this.name);
	            formData.append("userLastName", this.userLastName);
	            formData.append("email", this.email);
	            formData.append("organization", this.organization);
	            formData.append("phoneCode", this.phoneCode);
	            formData.append("phone", this.phone);
	            formData.append("addNumber", this.addNumber);
	
	            xhr.open("POST", 'api/file-upload', true);
	            xhr.send(formData);
	
	            this.requestInProgress = true;
	            this.getProgress(timeStamp, 'part', true);
	            setTimeout(function () {
	                _this9._$rootScope.$broadcast('meshError', undefined);
	            });
	
	            var showError = function showError(resp) {
	                _this9._$rootScope.$broadcast('meshError', _this9.getErrResponse(resp.target.response));
	                _this9.requestInProgress = false;
	                _this9._$rootScope.$broadcast('solverFinished', {
	                    step: 'part',
	                    error: true
	                });
	            };
	
	            xhr.onload = function (resp) {
	                if ([500, 503].indexOf(resp.target.status) === -1) {
	                    _this9.generateExpTime();
	                    _this9.requestInProgress = false;
	                    _this9._$rootScope.$broadcast('meshError', undefined);
	                    var result = JSON.parse(xhr.response);
	                    _this9.passedSteps = result.passedSteps;
	
	                    _this9.boundaries = result.boundaries;
	
	                    if (_this9.boundaries[2]) {
	                        _this9._offset = result.offset;
	                        _this9._$rootScope.$broadcast('meshedFileSurface', _this9.boundaries[2]);
	                    }
	
	                    _this9._$rootScope.$broadcast('solverFinished', {
	                        step: 'part'
	                    });
	                    var updateData = {
	                        fileName: geometry.fileName,
	                        mesh: result.mesh,
	                        maxDimensions: _this9.maxDimensions
	
	                    };
	                    if (result.lockOffset) {
	                        updateData.offset = result.offset;
	                        updateData.lockOffset = result.lockOffset;
	                        updateData.thickness = result.thickness;
	                    } else {
	                        updateData.offset = _this9.offset, updateData.thickness = _this9.thickness;
	                    }
	                    _this9.position = {};
	                    _this9._$rootScope.$broadcast('fileMeshed', updateData);
	                    _this9._$rootScope.$broadcast('updateView', [updateData, _this9.meshView, 'mesh']);
	                } else {
	                    showError(resp);
	                }
	            };
	
	            xhr.ontimeout = function (resp) {
	                showError(resp, true);
	                // this._$rootScope.$broadcast('meshError', "Server haven't sent response");
	            };
	
	            xhr.onerror = function (resp) {
	                showError(resp);
	            };
	        }
	    }, {
	        key: 'getOffsetName',
	        value: function getOffsetName() {
	            return this.offset.name;
	        }
	    }, {
	        key: 'clearCurrentView',
	        value: function clearCurrentView() {
	            this.currentView = undefined;
	        }
	    }, {
	        key: 'getViewMapper',
	        value: function getViewMapper() {
	            return {
	                mesh: 'meshView',
	                feasibility: 'formabilityView',
	                thinning: 'thinningView',
	                blank: 'blankView',
	                nest: 'nestView'
	            };
	        }
	    }, {
	        key: 'getViewKey',
	        value: function getViewKey(key) {
	            return this.getViewMapper()[key];
	        }
	    }, {
	        key: 'updateView',
	        value: function updateView(view, type) {
	            this[this.getViewMapper()[type]] = view;
	        }
	    }, {
	        key: 'getView',
	        value: function getView(type) {
	            return this[this.getViewMapper()[type]];
	        }
	    }, {
	        key: 'getUrl',
	        value: function getUrl(step) {
	            var mapper = {
	                feasibility: 'solver/feasibility',
	                nest: 'solver/nest',
	                blank: 'solver/blank',
	                report: 'solver/report',
	                clear: 'clear-session'
	            };
	            return mapper[step];
	        }
	    }, {
	        key: 'saveDataAndReturnPromise',
	        value: function saveDataAndReturnPromise(res) {
	            return new _promise2.default(function (resolve, reject) {
	                res.$save().then(function (results) {
	                    resolve(results);
	                }, function (results) {
	                    reject(results);
	                });
	            });
	        }
	    }, {
	        key: 'sendData',
	        value: function sendData(step) {
	            var suppressBroadcast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var uniqParam = arguments[2];
	
	            var url = this.getUrl(step);
	            console.log('Sending data to ' + step);
	            var MeshResource = this._$resource('/api/' + url, {}, { withCredentials: true });
	            if (!suppressBroadcast) {
	                this._$rootScope.$broadcast('solverStarted', step);
	            }
	            return this.saveDataAndReturnPromise(this.fillProperties(new MeshResource(), step, uniqParam));
	        }
	    }, {
	        key: 'clearSession',
	        value: function clearSession() {
	            var _this10 = this;
	
	            this._$rootScope.$broadcast('solverStarted', 'clear');
	            var res = this.sendData('clear', true);
	            this.requestInProgress = true;
	            res.then(function () {
	                _this10.requestInProgress = false;
	                _this10.generateExpTime();
	                _this10._$rootScope.$broadcast('solverFinished', { step: 'clear' });
	                _this10.setDefaultParams();
	                _this10._$rootScope.$broadcast('meshDeleted', true);
	                _this10._$state.go('home', { delete: true });
	            }, function () {
	                _this10._$rootScope.$broadcast('showErrorDialog', { type: 'error' });
	                _this10.requestInProgress = false;
	                _this10.generateExpTime();
	                _this10._$rootScope.$broadcast('solverFinished', { step: 'clear' });
	                // Handle me
	            });
	
	            return res;
	        }
	    }, {
	        key: 'getCurrentSession',
	        value: function getCurrentSession() {
	            var _this11 = this;
	
	            if (!this.mesh) {
	
	                var currentResource = new this._$resource('/api/get-current-data');
	                this.requestInProgress = true;
	                return currentResource.get().$promise.then(function (data) {
	                    _this11.requestInProgress = false;
	                    _this11.generateExpTime();
	                    var dataToSave = data.toJSON();
	                    if (_lodash2.default.isEmpty(dataToSave)) {
	                        _this11.setDefaultParams();
	                    } else {
	                        if (_lodash2.default.isString(dataToSave.passedSteps)) {
	                            dataToSave.passedSteps = [dataToSave.passedSteps];
	                        }
	                        _lodash2.default.extend(_this11, dataToSave);
	                    }
	                }, function () {
	                    _this11._$rootScope.$broadcast('showErrorDialog', { type: 'error' });
	                    _this11.requestInProgress = false;
	                });
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'sendPingRequest',
	        value: function sendPingRequest() {
	            var currentResource = new this._$resource('/api/continue-session');
	            return currentResource.get().$promise;
	        }
	    }, {
	        key: 'getOptions',
	        value: function getOptions(key) {
	            return this._options[key];
	        }
	    }, {
	        key: 'getHumanReadableName',
	        value: function getHumanReadableName(key) {
	            return this[key] ? this[key].name : '';
	        }
	    }, {
	        key: 'convertMetricToPSI',
	        value: function convertMetricToPSI(value) {
	            return value / 25.4;
	        }
	    }, {
	        key: 'convertPSIToMetric',
	        value: function convertPSIToMetric(value) {
	            return value * 25.4;
	        }
	    }, {
	        key: 'getWeightFactor',
	        value: function getWeightFactor() {
	            return this.partWeightUnits === 'kg' ? 1000 : 2000;
	        }
	    }, {
	        key: 'calculateUtilizationInfo',
	        value: function calculateUtilizationInfo() {
	            if (this.materialCost && this.utilization) {
	                this.utilizationInfo = {
	                    priceUnit: this.priceUnit.value,
	                    utilization: parseFloat(this.utilization, 2).toFixed(0),
	                    costCoilSegment: this.coilSegmentWeight / this.getWeightFactor() * this.materialCost
	                };
	            }
	        }
	    }, {
	        key: 'getTotalRaw',
	        value: function getTotalRaw() {
	            return this.partsNumber * this.coilSegmentWeight / this.getWeightFactor();
	        }
	    }, {
	        key: 'getTotalScrap',
	        value: function getTotalScrap() {
	            return this.partsNumber * (this.coilSegmentWeight - this.partWeight) / this.getWeightFactor();
	        }
	    }, {
	        key: 'cleanUserDetails',
	        value: function cleanUserDetails() {
	            this.email = '';
	            this.organization = '';
	            this.name = '';
	            this.company = '';
	            this.phone = '';
	            this.userLastName = '';
	            this.phoneCode = '';
	            this.addNumber = false;
	        }
	    }, {
	        key: 'unit',
	        set: function set(newName) {
	            this._unit = newName;
	            this._thickness = this._unit.value === 'psi' ? this.convertMetricToPSI(this._thickness) : this.convertPSIToMetric(this._thickness);
	            this._$rootScope.$broadcast('partStepChanged');
	        },
	        get: function get() {
	            return this._unit;
	        }
	    }, {
	        key: 'boundaries',
	        get: function get() {
	            return this._boundaries;
	        },
	        set: function set(data) {
	            this._boundaries = data;
	            if (data) {
	                var _data = (0, _slicedToArray3.default)(data, 2),
	                    v1 = _data[0],
	                    v2 = _data[1];
	
	                var dx = v1.x - v2.x;
	                var dy = v1.y - v2.y;
	                var dz = v1.z - v2.z;
	                this.maxDimensions = Math.sqrt(dx * dx + dy * dy + dz * dz);
	            } else {
	                this.maxDimensions = undefined;
	            }
	        }
	    }, {
	        key: 'systemsOfMeasurementUnit',
	        get: function get() {
	            return this._unit.value === 'psi' ? 'inch' : 'mm';
	        }
	    }, {
	        key: 'orientType',
	        get: function get() {
	            return this._orientType;
	        },
	        set: function set(value) {
	            this._orientType = value;
	            // this.orientAngle = undefined;
	        }
	    }, {
	        key: 'thickness',
	        get: function get() {
	            return this._thickness;
	        },
	        set: function set(value) {
	            this._thickness = value;
	            this._$rootScope.$broadcast('thicknessChanged', value);
	        }
	    }, {
	        key: 'holdingCond',
	        set: function set(newName) {
	            this._holdingCond = newName;
	            this._$rootScope.$broadcast('formingTypeChanged', newName);
	        },
	        get: function get() {
	            return this._holdingCond;
	        }
	    }, {
	        key: 'selectedReportView',
	        set: function set(newValue) {
	            this._selectedReportView = newValue;
	            var value = newValue.value;
	            var view = this[this.getViewMapper()[value]];
	            if (view) {
	                this._$rootScope.$broadcast('updateView', [undefined, view, value]);
	            } else {
	                this._$rootScope.$broadcast('updateView', [this.getViewData(value), undefined, value]);
	            }
	        },
	        get: function get() {
	            return this._selectedReportView;
	        }
	    }, {
	        key: 'smooth',
	        set: function set(value) {
	            this._smooth = value;
	            this.updateBoundary();
	            this.invalidateSnapshots('blank');
	            this.invalidateStep('blank');
	        },
	        get: function get() {
	            return this._smooth;
	        }
	    }, {
	        key: 'width',
	        set: function set(value) {
	            var _this12 = this;
	
	            var round = function round(value) {
	                if (_this12._unit.value === 'psi') {
	                    return value.toFixed(1);
	                } else {
	                    return value.toFixed(0);
	                }
	            };
	            this._width = value;
	            if (this._unit.value === 'psi') {
	                this.calculatedWidth = round(value / 4 * this.mex / 25.4);
	            } else {
	                this.calculatedWidth = round(value / 4 * this.mex);
	            }
	            this.isUsedCustomWidth = false;
	            this.updateBoundary();
	            this.invalidateSnapshots('blank');
	            this.invalidateStep('blank');
	        },
	        get: function get() {
	            return this._width;
	        }
	    }, {
	        key: 'convex',
	        set: function set(value) {
	            this._convex = value;
	            this.updateBoundary();
	            this.invalidateSnapshots('blank');
	            this.invalidateStep('blank');
	        },
	        get: function get() {
	            return this._convex;
	        }
	    }, {
	        key: 'results',
	        set: function set(newName) {
	            this._results = newName;
	            if (newName === 'thinning') {
	                this._$rootScope.$broadcast('updateView', [[this.getThinningData(), this.maxDimensions], undefined, 'thinning']);
	            } else {
	                this._$rootScope.$broadcast('updateView', [[this.getFormabilityData(), this.maxDimensions], undefined, 'feasibility']);
	            }
	        },
	        get: function get() {
	            return this._results;
	        }
	    }, {
	        key: 'material',
	        get: function get() {
	            return this._material;
	        },
	        set: function set(value) {
	            this._material = value;
	            this._$rootScope.$broadcast('partStepChanged');
	        }
	    }, {
	        key: 'offset',
	        get: function get() {
	            return this._offset;
	        },
	        set: function set(value) {
	            this._offset = value;
	
	            var view = this[this.getViewMapper()['mesh']];
	
	            if (view) {
	                var data = view.data;
	                data.offset = value;
	                this._$rootScope.$broadcast('updateView', [view.data, view, 'mesh', true]);
	            }
	
	            this._$rootScope.$broadcast('partStepChanged');
	        }
	    }]);
	    return LoadedModel;
	}();
	
	LoadedModel.$inject = ['$resource', '$state', '$rootScope', '$interval'];
	
	var LoadedModelService = _angular2.default.module('app.common.services', []).service('LoadedModel', LoadedModel).name;
	
	exports.default = LoadedModelService;

/***/ }),
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THREE = __webpack_require__(555);
	
	var ConvertAfebToMesh = function () {
	  function ConvertAfebToMesh() {
	    (0, _classCallCheck3.default)(this, ConvertAfebToMesh);
	  }
	
	  (0, _createClass3.default)(ConvertAfebToMesh, [{
	    key: 'parseASCII',
	    value: function parseASCII(data, thinning) {
	
	      var length, normal, patternNormal, patternVertex, result, text;
	      var faceInd = 0;
	      var geometry = new THREE.Geometry();
	      var patternFace = /facet([\s\S]*?)endfacet/g;
	      var patternNode = /Node([\s\S]*?)endNode/g;
	      var offset = 0;
	      var r, g, b;
	      var nFaces;
	      var facesFound = false;
	
	      var start = Date.now();
	
	      var nodeT = new Float32Array(123000);
	      var nodeF = new Float32Array(123000);
	
	      // get Nodes
	      while ((result = patternNode.exec(data)) !== null) {
	
	        facesFound = true;
	        text = result[0];
	
	        patternVertex = /vertex[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternVertex.exec(text)) !== null) {
	
	          var v1 = parseFloat(result[1]);
	          var v2 = parseFloat(result[3]);
	          var v3 = parseFloat(result[5]);
	          geometry.vertices.push(new THREE.Vector3(v1, v2, v3));
	        }
	
	        patternNormal = /normal[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternNormal.exec(text)) !== null) {
	          offset += 0;
	        }
	
	        patternValue = /values[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternValue.exec(text)) !== null) {
	          nodeT[offset] = parseFloat(result[1]);
	          nodeF[offset] = parseFloat(result[3]);
	        }
	        offset += 1;
	      }
	
	      var simResT = new Float32Array(123000);
	      var simResF = new Float32Array(123000);
	      var ind_1 = new Float32Array(123000);
	      var ind_2 = new Float32Array(123000);
	      var ind_3 = new Float32Array(123000);
	
	      while ((result = patternFace.exec(data)) !== null) {
	
	        facesFound = true;
	        text = result[0];
	        patternNormal = /normal[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternNormal.exec(text)) !== null) {
	
	          normal = new THREE.Vector3(parseFloat(result[1]), parseFloat(result[3]), parseFloat(result[5]));
	        }
	        var patternValue = /values[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternValue.exec(text)) !== null) {
	          simResT[faceInd] = parseFloat(result[1]);
	          simResF[faceInd] = parseFloat(result[3]);
	        }
	
	        var patternValue = /nodeIndices[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternValue.exec(text)) !== null) {
	
	          ind_1[faceInd] = parseInt(result[1]);
	          ind_2[faceInd] = parseInt(result[3]);
	          ind_3[faceInd] = parseInt(result[5]);
	        }
	
	        patternVertex = /vertex[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;
	
	        while ((result = patternVertex.exec(text)) !== null) {}
	
	        length = geometry.vertices.length;
	
	        var i1 = ind_1[faceInd];
	        var i2 = ind_2[faceInd];
	        var i3 = ind_3[faceInd];
	        geometry.faces.push(new THREE.Face3(i1, i2, i3, normal));
	        faceInd += 1;
	      }
	      nFaces = geometry.faces.length;
	
	      geometry.hasColors = false;
	      geometry.alpha = 0.8;
	      geometry.computeBoundingBox();
	      geometry.computeBoundingSphere();
	
	      var val;
	      var resColor = new Float32Array(3);
	
	      for (var face = 0; face < nFaces; face++) {
	
	        var color1 = new THREE.Color(0x00ff00);
	        var color2 = new THREE.Color(0x0000ff);
	        var color3 = new THREE.Color(0x0000ff);
	
	        var ind1 = ind_1[face];
	        var ind2 = ind_2[face];
	        var ind3 = ind_3[face];
	        var val1, val2, val3;
	        val1 = nodeT[ind1];
	        val2 = nodeT[ind2];
	        val3 = nodeT[ind3];
	
	        if (thinning) {
	          // thinning
	          val = simResT[face];
	
	          resColor = this.colorTable(val);
	          r = resColor[0];
	          g = resColor[1];
	          b = resColor[2];
	
	          var resColor1 = this.colorTable(val1);
	          var resColor2 = this.colorTable(val2);
	          var resColor3 = this.colorTable(val3);
	
	          color1.setRGB(resColor1[0], resColor1[1], resColor1[2]);
	          color2.setRGB(resColor2[0], resColor2[1], resColor2[2]);
	          color3.setRGB(resColor3[0], resColor3[1], resColor3[2]);
	        } else {
	          // formability
	          val = simResF[face];
	          switch (val) {
	            case 0:
	              r = 1; //penColor = Color::Red;
	              g = 0;
	              b = 0;
	              break;
	            case 1:
	              r = 1; //penColor =  Color::Orange;
	              g = 0.75;
	              b = 0;
	              break;
	            case 2:
	              r = 1; //penColor =  Color::Yellow;
	              g = 1;
	              b = 0;
	              break;
	            case 3:
	              r = 0.5; //penColor =  Color::Aquamarine;
	              g = 1;
	              b = 0.83;
	              break;
	            case 4:
	              r = 0.5; //penColor =  Color::LightGray;
	              g = 0.5;
	              b = 0.5;
	              break;
	            case 5:
	              r = 0; //penColor =  Color::Blue;
	              g = 0;
	              b = 1;
	              break;
	            case 6:
	              r = 1; //penColor =  Color::Magenta;
	              g = 0;
	              b = 1;
	              break;
	          }
	          color1.setRGB(r, g, b);
	          color2.setRGB(r, g, b);
	          color3.setRGB(r, g, b);
	        }
	
	        geometry.faces[face].vertexColors[0] = color1;
	        geometry.faces[face].vertexColors[1] = color2;
	        geometry.faces[face].vertexColors[2] = color3;
	      }
	
	      if (facesFound) {
	        return geometry;
	      }
	    }
	  }, {
	    key: 'colorTable',
	    value: function colorTable(dv) {
	      var resClr = new Float32Array(3);
	      var r, g, b;
	      // Percentage based ramp from blue to Red(-negative thinning)
	
	      if (-0.3 > dv) //Pink
	        {
	          r = 1.0;
	          g = 0.1;
	          b = 1.0;
	        } else if (-0.3 <= dv && dv < -0.25) //Pink to Red
	        {
	          r = 0.9 + (dv + 0.3) * (1 - 0.9) / (-0.25 + 0.3);
	          g = 0.2 + (dv + 0.3) * -0.2 / (-0.25 + 0.3);
	          b = 0.9 + (dv + 0.3) * -0.9 / (-0.25 + 0.3);
	        } else if (-0.25 <= dv && dv < -0.20) //Red to Orange
	        {
	          r = 1.0;
	          g = (dv + 0.25) * 0.5 / (0.25 - 0.20);
	          b = 0;
	        } else if (-0.20 <= dv && dv < -0.15) // Orange to Yellow
	        {
	          r = 1.0;
	          g = 0.5 + (dv + 0.20) * (1.0 - 0.5) / (-0.15 + 0.20);
	          b = 0;
	        } else if (-0.15 <= dv && dv < -0.10) //Yellow to Green
	        {
	          r = 1.0 + (dv + 0.15) * -1.0 / (-0.10 + 0.15);
	          g = 1.0;
	          b = 0;
	        } else if (-0.10 <= dv && dv < -0.05) //Green to cyan
	        {
	          r = 0;
	          g = 1.0;
	          b = (dv + 0.10) * 1.0 / (0.10 - 0.05);
	        } else if (-0.05 <= dv && dv < 0.0) // Cyan to Light Blue
	        {
	          r = 0;
	          g = 1.0 + (dv + 0.05) * (0.6 - 1.0) / 0.05;
	          b = 1.0;
	        } else if (0.0 <= dv && dv < 0.05) //Light Blue to Blue
	        {
	          r = 0;
	          g = (dv - 0.0) * (0.2 - 0.6) / 0.05 + 0.6;
	          b = 1;
	        } else if (dv >= 0.05) //Blue
	        {
	          r = 0;
	          g = 0.2;
	          b = 1.0;
	        } else {
	        //Console.WriteLine(dv);
	      }
	      resClr[0] = r;
	      resClr[1] = g;
	      resClr[2] = b;
	
	      return resClr;
	    }
	  }, {
	    key: 'ensureString',
	    value: function ensureString(buf) {
	      if (typeof buf !== "string") {
	
	        var array_buffer = new Uint8Array(buf);
	        var str = '';
	        for (var i = 0; i < buf.byteLength; i++) {
	
	          str += String.fromCharCode(array_buffer[i]); // implicitly assumes little-endian
	        }
	        return str;
	      } else {
	        return buf;
	      }
	    }
	  }, {
	    key: 'convertThinning',
	    value: function convertThinning(data) {
	      return this.parseASCII(this.ensureString(data), true);
	    }
	  }, {
	    key: 'convertFormability',
	    value: function convertFormability(data) {
	      return this.parseASCII(this.ensureString(data));
	    }
	  }]);
	  return ConvertAfebToMesh;
	}();
	
	exports.default = ConvertAfebToMesh;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	function getSelectOptions() {
	    return {
	        materialInch: [{
	            name: 'Mild Steel 44 ksi',
	            value: 'DC04'
	        }, {
	            name: 'High strength steel 62.1 ksi',
	            value: 'HX260YD'
	        }, {
	            name: 'Dual phase steel 95.7 ksi',
	            value: 'HCT590X'
	        }, {
	            name: 'Stainless steel  105  ksi',
	            value: '14301'
	        }, {
	            name: 'Aluminium 1050_O  11.8 ksi',
	            value: '1050_O'
	        }, {
	            name: 'Aluminium 5754_O 33 ksi',
	            value: '5754_O'
	        }, {
	            name: 'Aluminium 6016_T4P  35 ksi',
	            value: '6016_T4P'
	        }],
	        materialMm: [{
	            name: 'Mild Steel 303.5 MPa ',
	            value: 'DC04'
	        }, {
	            name: 'High strength steel 428.3 MPa',
	            value: 'HX260YD'
	        }, {
	            name: 'Dual phase steel 659.8   MPa',
	            value: 'HCT590X'
	        }, {
	            name: 'Stainless steel 723.7 MPa',
	            value: '14301'
	        }, {
	            name: 'Aluminium 1050_O 81.6 MPa',
	            value: '1050_O'
	        }, {
	            name: 'Aluminium 5754_O 227.2 MPa',
	            value: '5754_O'
	        }, {
	            name: 'Aluminium 6016_T4P 241.4 MPa',
	            value: '6016_T4P'
	        }],
	        offset: [{
	            name: 'mid surface of part',
	            value: '0'
	        }, {
	            name: 'lower surface of part',
	            value: '-1'
	        }, {
	            name: 'upper surface of part',
	            value: '1'
	        }],
	        unit: [{
	            name: 'Metric',
	            value: 'metric'
	        }, {
	            name: 'PSI',
	            value: 'psi'
	        }],
	        holdingCond: [{
	            name: 'Crash form',
	            value: '0.0'
	        }, {
	            name: 'Deep draw',
	            value: '0.3'
	        }, {
	            name: 'Stretch form',
	            value: '1.0'
	        }],
	        results: [{
	            name: 'Thinning',
	            letter: 'T',
	            value: 'thinning'
	        }, {
	            name: 'Formability',
	            letter: 'G',
	            value: 'feasibility'
	        }],
	        priceUnit: [{
	            name: '$/ton',
	            value: '$'
	        }, {
	            name: '€/ton',
	            value: '€'
	        }, {
	            name: '£/ton',
	            value: '£'
	        }, {
	            name: '¥/ton',
	            value: '¥'
	        }],
	        nType: [{
	            name: 'OneUp',
	            value: '0'
	        }, {
	            name: 'TwoUp',
	            value: '1'
	        }, {
	            name: 'UpDown',
	            value: '2'
	        }],
	        _orientType: [{
	            name: 'Free',
	            value: '0'
	        }, {
	            name: 'Angle',
	            value: '1'
	        }], selectedReportView: [{
	            name: 'Formability',
	            value: 'feasibility'
	        }, {
	            name: 'Thinning',
	            value: 'thinning'
	        }, {
	            name: 'Blank',
	            value: 'blank'
	        }, {
	            name: 'Nest',
	            value: 'nest'
	        }]
	    };
	}
	
	exports.default = getSelectOptions;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(589);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _selectOptions = __webpack_require__(593);
	
	var _selectOptions2 = _interopRequireDefault(_selectOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldProcessor = function () {
	    function FieldProcessor() {
	        (0, _classCallCheck3.default)(this, FieldProcessor);
	    }
	
	    (0, _createClass3.default)(FieldProcessor, [{
	        key: 'getDefaultParams',
	        value: function getDefaultParams() {
	            return {
	                passedSteps: [],
	                _material: this.getSelectOptions('materialMm')[0],
	                _offset: this.getSelectOptions('offset')[0],
	                mesh: undefined,
	                fileName: undefined,
	                orientType: this.getSelectOptions('_orientType')[0],
	                _thickness: " 0.8",
	                lockOffset: false,
	                _holdingCond: '0.0',
	                _results: 'thinning',
	                materialCost: 1000,
	                // calculatedWidth: 0,
	                _width: 0,
	                _convex: 0,
	                _smooth: 0,
	                priceUnit: this.getSelectOptions('priceUnit')[0],
	                nType: this.getSelectOptions('nType')[0],
	                _selectedReportView: this.getSelectOptions('selectedReportView')[0],
	                coilMargin: 0,
	                bridgeSpan: 0,
	                addWidth: 0,
	                customWidth: undefined,
	                isUsedCustomWidth: undefined,
	                scrapVal: 200,
	                partsNumber: 10000,
	                meshView: undefined,
	                nestN2: undefined,
	                meshLL: undefined,
	                boundary: undefined,
	                blankBoundaryMod: undefined,
	                blankBoundaryModCustom: undefined,
	                afeb: undefined,
	                _unit: this.getSelectOptions('unit')[0],
	                formabilityView: undefined,
	                thinningView: undefined,
	                blankView: undefined,
	                nestView: undefined,
	                snapshots: [],
	                position: {},
	                // userLastName: '',
	                utilizationInfo: 0,
	                cashedSim: {},
	                cashedSimViews: {}
	                // expirationTime: undefined
	            };
	        }
	    }, {
	        key: 'getSelectOptions',
	        value: function getSelectOptions(key) {
	            return (0, _selectOptions2.default)()[key];
	        }
	    }, {
	        key: 'getAllKeys',
	        value: function getAllKeys() {
	            return (0, _keys2.default)(this.getDefaultParams());
	        }
	    }, {
	        key: 'getAllUIKeys',
	        value: function getAllUIKeys() {
	            return {
	                part: ['mesh', 'fileName', '_holdingCond', 'cashedSim', '_thickness', '_material', 'unit', '_unit', '_offset', 'lockOffset', 'maxDimensions', 'meshView', 'passedSteps'], nest: ['_thickness', 'material', 'nType', 'unit', '_unit', 'coilMargin', 'bridgeSpan', 'orientType', 'orientAngle', 'materialCost', 'priceUnit', 'scrapVal', 'addWidth', '_unit'], blank: [
	                // 'width',
	                'isUsedCustomWidth', '_width', 'thinningView', 'formabilityView',
	                // 'convex',
	                '_convex',
	                // 'smooth',
	
	                'customWidth', 'addWidth', 'snapshots', '_smooth', 'unit', 'afeb', '_unit', 'meshLL', 'mex', 'boundary', 'blankBoundaryMod', 'blankBoundaryModCustom', 'blankView'], clear: []
	            };
	        }
	    }, {
	        key: 'getStepValues',
	        value: function getStepValues() {
	            return {
	                feasibility: ['fileName', 'holdingCond', 'thickness', 'material', 'offset'], blank: ['convex', 'smooth', 'holdingCond', 'customWidth', 'addWidth', '_unit'], nest: ['isUsedCustomWidth', 'width', 'results', 'holdingCond', 'calculatedWidth', 'smooth', 'convex', 'thickness', 'material', 'nType', 'coilMargin', 'bridgeSpan', 'orientType', 'orientAngle', 'materialCost', 'priceUnit', 'scrapVal', 'addWidth', '_unit'], clear: []
	            };
	        }
	    }, {
	        key: 'getInvalidatedKeys',
	        value: function getInvalidatedKeys(key) {
	            var mapper = {
	                part: ['meshFile', 'fileName', 'mesh', 'material', 'offset', 'unit', '_unit', 'boundaries', 'thickness', '_thickness'],
	                feasiblity: ['holdingCond']
	            };
	            return mapper[key];
	        }
	    }, {
	        key: 'getUIKeysByStep',
	        value: function getUIKeysByStep(step) {
	            return this.getAllUIKeys()[step];
	        }
	    }, {
	        key: 'getUnitFiels',
	        value: function getUnitFiels() {
	            return ['_thickness', 'thickness', 'addWidth', 'bridgeSpan', 'convex', 'smooth', 'width'];
	        }
	    }]);
	    return FieldProcessor;
	}();
	
	exports.default = FieldProcessor;

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var selectBlankBoundaries = function selectBlankBoundaries(boundaries, convex, smooth, width) {
	    var key = "." + smooth + "." + convex + "." + width;
	    return boundaries[key];
	};
	exports.default = selectBlankBoundaries;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuElements = function () {
	    function MenuElements($state, LoadedModel) {
	        (0, _classCallCheck3.default)(this, MenuElements);
	
	        this._$state = $state;
	        this._LoadedModel = LoadedModel;
	        this.initMenu();
	        this.resetStates();
	    }
	
	    (0, _createClass3.default)(MenuElements, [{
	        key: 'resetStates',
	        value: function resetStates() {
	            this.activeStates = this._LoadedModel.passedSteps.slice(0);
	        }
	    }, {
	        key: 'get',
	        value: function get() {
	            return this._menuElements;
	        }
	    }, {
	        key: 'initMenu',
	        value: function initMenu() {
	            var _this = this;
	
	            this._menuElements = [{
	                state: 'home',
	                letter: 'O',
	                name: 'Part',
	                isValid: function isValid() {
	                    return !_this._LoadedModel.isThicknessValid();
	                }
	            }, {
	                state: 'feasibility',
	                activeState: 'part',
	                letter: 'T',
	                name: 'Feasibility',
	                isValid: function isValid() {
	                    return true;
	                }
	            }, {
	                state: 'blank',
	                activeState: 'feasibility',
	                letter: 'B',
	                name: 'Blank',
	                isValid: function isValid() {
	                    return true;
	                }
	            }, {
	                state: 'nest',
	                activeState: 'blank',
	                letter: 'L',
	                name: 'Nest',
	                isValid: function isValid() {
	                    return true;
	                }
	            }, {
	                state: 'report',
	                activeState: 'nest',
	                letter: 'R',
	                name: 'Report',
	                isValid: function isValid() {
	                    return true;
	                }
	            }];
	        }
	    }, {
	        key: 'updateActiveStates',
	        value: function updateActiveStates(step, soft) {
	            if (step && (!soft || soft && this.activeStates.indexOf(step) === -1)) {
	                this.activeStates = this._LoadedModel.addPassedStep(step);
	            }
	        }
	    }, {
	        key: 'isStateEnabled',
	        value: function isStateEnabled(stateName) {
	            if (!stateName) {
	                return false;
	            }
	            var element = _lodash2.default.find(this._menuElements, { state: stateName });
	            return !element.activeState || this.activeStates.indexOf(element.activeState) !== -1;
	        }
	    }]);
	    return MenuElements;
	}();
	
	MenuElements.$inject = ['$state', 'LoadedModel'];
	
	var MenuElementsService = _angular2.default.module('app.common.services').service('MenuElements', MenuElements).name;
	
	exports.default = MenuElementsService;

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var SetThickness = function SetThickness(LoadedModel) {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function link(scope, elem, attrs, ctrl) {
	            elem.on("keyup", function (ev) {
	                if (ev.keyCode === 13 && LoadedModel.thickness !== elem.val()) {
	                    LoadedModel.invalidateThickness();
	                    scope.$apply();
	                }
	            });
	        }
	    };
	};
	
	SetThickness.$inject = ['LoadedModel'];
	
	var setThicknessModule = angular.module('SetThickness', []).directive('setThickness', SetThickness).name;
	
	exports.default = setThicknessModule;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _radioControl = __webpack_require__(599);
	
	var _radioControl2 = _interopRequireDefault(_radioControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var radioControlModule = _angular2.default.module('radio-control', [_angularUiRouter2.default]).component('radioControl', _radioControl2.default).name;
	
	exports.default = radioControlModule;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _radioControl = __webpack_require__(600);
	
	var _radioControl2 = _interopRequireDefault(_radioControl);
	
	var _radioControl3 = __webpack_require__(601);
	
	var _radioControl4 = _interopRequireDefault(_radioControl3);
	
	__webpack_require__(602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var radioControlComponent = {
	    restrict: 'E',
	    bindings: {
	        name: '@',
	        model: '=',
	        options: '='
	    },
	    template: _radioControl2.default,
	    controller: _radioControl4.default
	};
	
	exports.default = radioControlComponent;

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports = "<div ng-repeat=\"option in $ctrl.options\" class=\"btn-group radio-buttons\" data-toggle=\"buttons\" id=\"modelselect\">\n  <label class=\"btn button\" ng-class=\"{'active': $ctrl.model === option.value }\">\n    <input type=\"radio\" value='{{ option.value}}' id=\"{{ $ctrl.name }}\" name=\"{{ $ctrl.name }}\" ng-model=\"$ctrl.model\">\n    <span ng-if=\"option.letter\" class=\"icon easyblank-icon\">{{ option.letter }}</span>{{ option.name }}\n  </label>\n</div>\n"

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioControlController = function RadioControlController() {
	    (0, _classCallCheck3.default)(this, RadioControlController);
	};
	
	exports.default = RadioControlController;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(603);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./radio-control.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./radio-control.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".radio-buttons .button{margin:2px;padding:13px;border-width:0;border-radius:0}.radio-buttons .button,.radio-buttons .button:active,.radio-buttons .button:hover{color:#666;background-color:silver}.radio-buttons .button.active,.radio-buttons .button.active:active,.radio-buttons .button.active:hover{color:#fff;background-color:#5586c7}", ""]);
	
	// exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _selectControl = __webpack_require__(605);
	
	var _selectControl2 = _interopRequireDefault(_selectControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectControlModule = _angular2.default.module('select-control', [_angularUiRouter2.default]).component('selectControl', _selectControl2.default).name;
	
	exports.default = selectControlModule;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectControl = __webpack_require__(606);
	
	var _selectControl2 = _interopRequireDefault(_selectControl);
	
	var _selectControl3 = __webpack_require__(607);
	
	var _selectControl4 = _interopRequireDefault(_selectControl3);
	
	__webpack_require__(608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectControlComponent = {
	  restrict: 'E',
	  bindings: {
	    model: '=',
	    options: '='
	  },
	  template: _selectControl2.default,
	  controller: _selectControl4.default
	};
	
	exports.default = selectControlComponent;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<label class=\"custom-select\">\n  <select\n      ng-options=\"option.name for option in $ctrl.options track by option.value\"\n      ng-model=\"$ctrl.model\">\n  </select>\n</label>\n\n\n"

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectControlController = function SelectControlController() {
	    (0, _classCallCheck3.default)(this, SelectControlController);
	};
	
	exports.default = SelectControlController;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(609);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./select-control.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./select-control.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, "label.custom-select{position:relative;display:block}.custom-select select{display:inline-block;border:1px solid #bbb;padding:6px 3px 6px 5px;margin:0;font-weight:400;font-family:Helvetica;outline:none;background:#f8f8f8;width:100%;-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){.custom-select select{padding-right:30px}}.custom-select select:focus{box-shadow:0 0 3px 1px #0db9f0}.custom-select:after{content:\"E\";font-family:easyblank;position:absolute;top:0;right:0;bottom:0;font-size:110%;line-height:30px;padding:0 8px;background:#bcbcbc;color:#646464;pointer-events:none}.no-pointer-events .custom-select:after{content:none}", ""]);
	
	// exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _solverProgress = __webpack_require__(611);
	
	var _solverProgress2 = _interopRequireDefault(_solverProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solverProgressModule = _angular2.default.module('solver-progress', []).component('solverProgress', _solverProgress2.default).name;
	
	exports.default = solverProgressModule;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solverProgress = __webpack_require__(612);
	
	var _solverProgress2 = _interopRequireDefault(_solverProgress);
	
	var _solverProgress3 = __webpack_require__(613);
	
	var _solverProgress4 = _interopRequireDefault(_solverProgress3);
	
	__webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var solverProgressComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _solverProgress2.default,
	  controller: _solverProgress4.default
	};
	
	exports.default = solverProgressComponent;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.showProgressBar\">\n  <div class=\"progress-wrapper\"></div>\n  <div class=\"progress-background\"></div>\n  <div class=\"progress-container\">\n    <div class=\"progress-title\">Processing...<span ng-if=\"$ctrl.processName\">{{ $ctrl.processName }}</span></div>\n    <div class=\"progress bar\">\n      <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"{{ $ctrl.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{{ $ctrl.progress }}%\"></div>\n    </div>\n  </div>\n</div>\n\n"

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolverProgressController = function SolverProgressController($scope) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SolverProgressController);
	
	    this._$scope = $scope;
	
	    this.progressMapper = {
	        part: {
	            startPosition: 0,
	            startLabel: 'Uploading Part',
	            data: {
	                load: {
	                    name: 'Uploading Part',
	                    percent: 20
	                }, read: {
	                    name: 'Sending request',
	                    percent: 40
	                }, wait: {
	                    name: 'Meshing',
	                    percent: 60
	                }, save: {
	                    name: 'Receiving Mesh',
	                    percent: 80
	                }
	            }
	        }, feasibility: {
	            startPosition: 0,
	            startLabel: 'Sending Request',
	            data: {
	                wait: {
	                    name: 'Waiting for Service',
	                    percent: 25
	                }, load: {
	                    name: 'Simulation',
	                    percent: 50
	                }, save: {
	                    name: 'Receiving Results',
	                    percent: 75
	                }
	            }
	        }, nest: {
	            startPosition: 0,
	            startLabel: 'Sending Request',
	            data: {
	                wait: {
	                    name: 'Waiting for Service',
	                    percent: 25
	                }, load: {
	                    name: 'Nesting',
	                    percent: 50
	                }, save: {
	                    name: 'Receiving Results',
	                    percent: 75
	                }
	            }
	        }, blank: {
	            startPosition: 0,
	            startLabel: 'Sending Request',
	            data: {
	                wait: {
	                    name: 'Waiting for Service',
	                    percent: 25
	                }, load: {
	                    name: 'Blanking',
	                    percent: 50
	                }, save: {
	                    name: 'Receiving Results',
	                    percent: 75
	                }
	            }
	        }, report: {
	            startPosition: 0,
	            startLabel: 'Sending data',
	            data: {
	                assemble: {
	                    name: 'Assembling response images',
	                    percent: 15
	                }, read: {
	                    name: 'Assembling report images',
	                    percent: 30
	                }, upload: {
	                    name: 'Waiting for Service',
	                    percent: 45
	                }, wait: {
	                    name: 'Waiting for Service',
	                    percent: 60
	                }, send: {
	                    name: 'Sending email',
	                    percent: 75
	                }, save: {
	                    name: 'Sending email',
	                    percent: 90
	                }
	            }
	        }, Invalidating: {
	            startPosition: 15,
	            startLabel: 'Invalidating'
	        }, clear: {
	            startPosition: 15,
	            startLabel: 'Clearing session'
	        }, ping: {
	            startPosition: 15,
	            startLabel: 'Continuing session'
	        }
	    };
	
	    $scope.$on('solverStarted', function (event, key) {
	        _this.showProgressBar = true;
	        var data = _this.progressMapper[key];
	        _this.progress = data.startPosition || 0;
	        _this.processName = data.startLabel || 'Processing';
	    });
	
	    $scope.$on('progressUpdated', function (event, data) {
	        if (data.key === 'Finished') {
	            _this.showProgressBar = false;
	            _this.processName = undefined;
	        } else {
	            var info = _this.progressMapper[data.step].data[data.key];
	            _this.progress = info.percent;
	            _this.processName = info.name;
	        }
	    });
	
	    $scope.$on('solverFinished', function () {
	        _this.showProgressBar = false;
	        _this.processName = undefined;
	    });
	};
	
	SolverProgressController.$inject = ['$scope'];
	
	exports.default = SolverProgressController;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(615);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./solver-progress.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./solver-progress.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".progress-background{width:100%;height:100%;background:rgba(0,0,0,.25);position:fixed;top:0;left:0;z-index:2}.progress-wrapper{height:90px;background:#fff;opacity:.5;z-index:3}.progress-container,.progress-wrapper{position:absolute;width:400px;margin:-100px 0 0 -200px;top:50%;left:50%}.progress-container{height:150px;z-index:4}.progress-container .progress-title{font-size:20px;text-align:center;margin-top:20px;margin-bottom:7px}.progress-container .progress{border-radius:12px;border-color:#000;border-width:2px;height:15px;margin:0 20px}.progress-container .progress .progress-bar{background-color:#406494}", ""]);
	
	// exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _snapshotWidget = __webpack_require__(617);
	
	var _snapshotWidget2 = _interopRequireDefault(_snapshotWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var snapshotWidgetModule = _angular2.default.module('snapshot-widget', []).component('snapshotWidget', _snapshotWidget2.default).name;
	
	exports.default = snapshotWidgetModule;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _snapshotWidget = __webpack_require__(618);
	
	var _snapshotWidget2 = _interopRequireDefault(_snapshotWidget);
	
	var _snatpshotWidget = __webpack_require__(619);
	
	var _snatpshotWidget2 = _interopRequireDefault(_snatpshotWidget);
	
	__webpack_require__(620);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var snapshotWidgetComponent = {
	  restrict: 'E',
	  bindings: {
	    type: '='
	  },
	  template: _snapshotWidget2.default,
	  controller: _snatpshotWidget2.default
	};
	
	exports.default = snapshotWidgetComponent;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"snapshot-widget\">\n  <div ng-show=\"!$ctrl.snapshots.length\" class=\"snapshot-header\">\n    <button type=\"button\" ng-click=\"$ctrl.takeSnapshot()\" class=\"btn add-button glyphicon glyphicon-camera\"></button>\n  </div>\n  <div ng-show=\"$ctrl.snapshots.length\">\n    <div class=\"snapshot-background\" ng-class=\"{'one-line': $ctrl.snapshots.length < 3, 'two-line': $ctrl.snapshots.length > 2}\"></div>\n    <div class=\"snapshot-container\">\n      <div ng-show=\"$ctrl.snapshots.length\" class=\"snapshot-inner-header\">\n        <span class=\"title\">Snapshots</span>\n        <span type=\"button\" ng-click=\"$ctrl.takeSnapshot()\" class=\"pull-right glyphicon glyphicon-camera icon\"></span>\n      </div>\n      <div class=\"snapshots\">\n        <div  class=\"snapshot\" ng-repeat=\"snapshot in $ctrl.snapshots | limitTo: -4\">\n          <img ng-src=\"{{ snapshot.image }}\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SnapshotWidgetController = function () {
	    function SnapshotWidgetController($scope, LoadedModel) {
	        (0, _classCallCheck3.default)(this, SnapshotWidgetController);
	
	        this._$scope = $scope;
	        this.model = LoadedModel;
	        this.snapshots = this.model.snapshots;
	    }
	
	    (0, _createClass3.default)(SnapshotWidgetController, [{
	        key: 'takeSnapshot',
	        value: function takeSnapshot() {
	            var type = this.model.getViewKey(this.type);
	
	            if (!this.model[type] && type === 'nestView') {
	                type = 'blankView';
	            }
	
	            this.model.takeSnapshot(type);
	        }
	    }]);
	    return SnapshotWidgetController;
	}();
	
	SnapshotWidgetController.$inject = ['$scope', 'LoadedModel'];
	
	exports.default = SnapshotWidgetController;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(621);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./snapshot-widget.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./snapshot-widget.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, ".base-gradient,.snapshot-widget .snapshot-container .snapshot img{background:linear-gradient(0deg,#cdcdcd,#fefefe,#cdcdcd)}body{height:100%;font:62.5% helvetica,arial,verdana,sans-serif}.css-form input.ng-invalid.ng-touched{background-color:#fa787e}.button-general,.button-navigation,.snapshot-widget .add-button,button.button-cancel,button.button-next,button.button-plain,button.button-prev{border-radius:0;color:#fff}.button-general:focus,.button-general:hover,.button-navigation:focus,.button-navigation:hover,.snapshot-widget .add-button:focus,.snapshot-widget .add-button:hover,button.button-cancel:focus,button.button-cancel:hover,button.button-next:focus,button.button-next:hover,button.button-plain:focus,button.button-plain:hover,button.button-prev:focus,button.button-prev:hover{color:#fff}.button-navigation,.snapshot-widget .add-button,button.button-cancel,button.button-next,button.button-plain,button.button-prev{padding:10px 20px;border-width:1px;border-color:#fff;background-color:#406494}button.button-cancel{background-color:#999}.button-icon,button.button-next .button-arrow{margin-left:5px}button.button-prev .button-arrow{margin-right:5px}.capcha-container{padding:0 17px}.form-error-label{color:red;font-style:italic}select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\"}.utilization-info{margin-top:20px}.utilization-info,.utilization-info .table-row{margin-bottom:10px}.input-error{background-color:#fa787e!important}.snapshot-widget{position:absolute;width:180px;right:45px}.snapshot-widget .snapshot-background{opacity:.5;width:180px;position:absolute;background-color:#333}.snapshot-widget .one-line{height:100px}.snapshot-widget .two-line{height:150px}.snapshot-widget .snapshot-container{width:180px}.snapshot-widget .snapshot-container .snapshots{margin:0 10px 10px}.snapshot-widget .snapshot-container .snapshot-inner-header{padding-top:10px;padding-left:5px;padding-right:5px;color:#fff;height:40px}.snapshot-widget .snapshot-container .snapshot-inner-header .title{position:relative;margin:0 2px 2px 10px}.snapshot-widget .snapshot-container .snapshot-inner-header .icon{margin:4px 10px 4px 4px}.snapshot-widget .snapshot-container .snapshot{position:relative;margin:4px;display:inline-block}.snapshot-widget .snapshot-container .snapshot img{width:71px;height:42px}.snapshot-widget .add-button{margin:0 2px 2px 95px;display:inline-block}", ""]);
	
	// exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sessionNotification = __webpack_require__(623);
	
	var _sessionNotification2 = _interopRequireDefault(_sessionNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sessionNotificationModule = _angular2.default.module('session-notification', [_angularUiRouter2.default]).component('sessionNotification', _sessionNotification2.default).name;
	
	exports.default = sessionNotificationModule;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sessionNotification = __webpack_require__(624);
	
	var _sessionNotification2 = _interopRequireDefault(_sessionNotification);
	
	var _sessionNotification3 = __webpack_require__(625);
	
	var _sessionNotification4 = _interopRequireDefault(_sessionNotification3);
	
	__webpack_require__(628);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sessionNotificationComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _sessionNotification2.default,
	  controller: _sessionNotification4.default
	};
	
	exports.default = sessionNotificationComponent;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = "<div>\n</div>\n"

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sessionNotificationModal = __webpack_require__(626);
	
	var _sessionNotificationModal2 = _interopRequireDefault(_sessionNotificationModal);
	
	var _sessionNotificationModal3 = __webpack_require__(627);
	
	var _sessionNotificationModal4 = _interopRequireDefault(_sessionNotificationModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SessionNotificationController = function () {
	    function SessionNotificationController($rootScope, $uibModal, $scope) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, SessionNotificationController);
	
	        this._$uibModal = $uibModal;
	        this._$rootScope = $rootScope;
	
	        $scope.$on('showExpirationDialog', function () {
	            if (!_this.dialogIsShown) {
	                _this.openHelpWindow();
	            }
	        });
	    }
	
	    (0, _createClass3.default)(SessionNotificationController, [{
	        key: 'openHelpWindow',
	        value: function openHelpWindow() {
	            var _this2 = this;
	
	            this.dialogIsShown = true;
	            this._$uibModal.open({
	                animation: false,
	                template: _sessionNotificationModal4.default,
	                controllerAs: '$ctrl',
	                size: 'md',
	                resolve: {},
	                controller: _sessionNotificationModal2.default
	            }).result.then(function () {
	                _this2._$rootScope.$broadcast('solverFinished', 'ping');
	                _this2.dialogIsShown = undefined;
	            }, function () {
	                _this2.dialogIsShown = undefined;
	                _this2._$rootScope.$broadcast('solverFinished', 'ping');
	            });
	        }
	    }]);
	    return SessionNotificationController;
	}();
	
	SessionNotificationController.$inject = ['$rootScope', '$uibModal', '$scope'];
	
	exports.default = SessionNotificationController;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpModalController = function () {
	    function HelpModalController($rootScope, $uibModalInstance, $timeout, LoadedModel) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, HelpModalController);
	
	        this._$rootScope = $rootScope;
	        this._$uibModalInstance = $uibModalInstance;
	        this._$timeout = $timeout;
	        this.model = LoadedModel;
	        this.timeout = $timeout(function () {
	            _this._$uibModalInstance.close();
	            _this.model.clearSession();
	        }, 120000);
	        this._$uibModalInstance.close();
	    }
	
	    (0, _createClass3.default)(HelpModalController, [{
	        key: 'ok',
	        value: function ok() {
	            var _this2 = this;
	
	            this._$uibModalInstance.close();
	            this._$rootScope.$broadcast('solverStarted', 'ping');
	            this.model.sendPingRequest().then(function () {
	                _this2.model.generateExpTime();
	                _this2._$timeout.cancel(_this2.timeout);
	            }, function () {
	                _this2._$timeout.cancel(_this2.timeout);
	                _this2.model.generateExpTime();
	            });
	        }
	    }]);
	    return HelpModalController;
	}();
	
	HelpModalController.$inject = ['$rootScope', '$uibModalInstance', '$timeout', 'LoadedModel'];
	
	exports.default = HelpModalController;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content help-modal\">\n  <form name=\"form\" novalidate class=\"css-form\">\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div>\n        <h3>Session will expire soon, to continue click OK.</h3>\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn button-plain\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(629);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./session-notification.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./session-notification.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".help-button-left{position:absolute;bottom:10px;right:15px}button.help-button{border-radius:0}.help-modal .modal-body{padding:31px}", ""]);
	
	// exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _captchaWithFallback = __webpack_require__(631);
	
	var _captchaWithFallback2 = _interopRequireDefault(_captchaWithFallback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var captchaWithFallbackModule = _angular2.default.module('captcha-with-fallback', []).component('captchaWithFallback', _captchaWithFallback2.default).name;
	
	exports.default = captchaWithFallbackModule;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _captchaWithFallback = __webpack_require__(632);
	
	var _captchaWithFallback2 = _interopRequireDefault(_captchaWithFallback);
	
	var _captchaWithFallback3 = __webpack_require__(633);
	
	var _captchaWithFallback4 = _interopRequireDefault(_captchaWithFallback3);
	
	__webpack_require__(634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var captchaWithFallbackComponent = {
	  restrict: 'E',
	  bindings: {
	    onInit: '&'
	  },
	  template: _captchaWithFallback2.default,
	  controller: _captchaWithFallback4.default
	};
	
	exports.default = captchaWithFallbackComponent;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"captcha-fallback\">\n  <div ng-if=\"$ctrl.loading\" class=\"captcha-fallback__loader\" ng-click=\"$ctrl.fallback()\">\n    Loading...\n  </div>\n  <div ng-if=\"!$ctrl.loading\">\n    <div ng-if=\"!$ctrl.renderReCaptcha\">\n      <botdetect-captcha captchaStyleName=\"autoFormCaptchaStyle\"></botdetect-captcha>\n      <input id=\"autoFormCaptchaUserInput\"\n             class=\"form-control default-element input-l\"\n             type=\"text\" name=\"userCaptchaInput\" ng-model=\"userCaptchaInput\" >\n    </div>\n    <div ng-if=\"$ctrl.renderReCaptcha\"\n         vc-recaptcha\n         ng-model=\"$ctrl.reCaptchaResponse\"\n         key=\"'6LdtYg8UAAAAAG4YB_hfOv42OnvPj1ehX289Cqn7'\"></div>\n  </div>\n</div>\n"

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(567);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaptchaWithFallbackController = function () {
	  function CaptchaWithFallbackController($http, Captcha, $rootScope) {
	    (0, _classCallCheck3.default)(this, CaptchaWithFallbackController);
	
	    this._$http = $http;
	    this._Captcha = Captcha;
	    this.reCaptchaResponse = null;
	    this.loading = false;
	    this.renderReCaptcha = true;
	    this._$rootScope = $rootScope;
	    this.checkCountryAndRecaptcha();
	  }
	
	  (0, _createClass3.default)(CaptchaWithFallbackController, [{
	    key: 'checkCountryAndRecaptcha',
	    value: function checkCountryAndRecaptcha() {
	      var _this = this;
	
	      this._$rootScope.reCaptchaFailed ? this.fallback() : this.isChina().then(this.fallback.bind(this), function () {
	        if (!window.recaptcha) {
	          _this.waitReCaptcha(15);
	        }
	      });
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      var validate = function validate() {
	        if (_this2.loading) {
	          _this2.fallback();
	          return _promise2.default.reject();
	        }
	        return _this2.renderReCaptcha ? _this2.validateReCaptcha() : _this2.validateFallbackCaptcha();
	      };
	      this.onInit({ validate: validate });
	    }
	  }, {
	    key: 'fallback',
	    value: function fallback() {
	      this.loading = false;
	      this.renderReCaptcha = false;
	      this._$rootScope.reCaptchaFailed = true;
	    }
	  }, {
	    key: 'waitReCaptcha',
	    value: function waitReCaptcha(seconds) {
	      var _this3 = this;
	
	      this.loading = true;
	      setTimeout(function () {
	        !window.recaptcha && _this3.fallback();
	      }, seconds * 1000);
	    }
	  }, {
	    key: 'validateReCaptcha',
	    value: function validateReCaptcha() {
	      return this.reCaptchaResponse ? _promise2.default.resolve() : _promise2.default.reject();
	    }
	  }, {
	    key: 'validateFallbackCaptcha',
	    value: function validateFallbackCaptcha() {
	      var captcha = new this._Captcha();
	      var userEnteredCaptchaCode = captcha.getUserEnteredCaptchaCode();
	      var captchaId = captcha.getCaptchaId();
	
	      return this._$http({
	        headers: { 'Content-Type': 'application/json; charset=utf-8' },
	        method: 'POST',
	        url: '/captcha/validate',
	        data: {
	          userEnteredCaptchaCode: userEnteredCaptchaCode,
	          captchaId: captchaId
	        }
	      }).then(function (response) {
	        if (response.data.success === false) {
	          captcha.reloadImage();
	          return _promise2.default.reject();
	        }
	      });
	    }
	  }, {
	    key: 'isChina',
	    value: function isChina() {
	      return this._$http({
	        headers: { 'Content-Type': 'application/json; charset=utf-8' },
	        method: 'GET',
	        url: '/captcha/ischina'
	      }).then(function (response) {
	        if (!response.data) {
	          return _promise2.default.reject();
	        }
	      });
	    }
	  }]);
	  return CaptchaWithFallbackController;
	}();
	
	CaptchaWithFallbackController.$inject = ['$http', 'Captcha', '$rootScope'];
	
	exports.default = CaptchaWithFallbackController;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(635);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./captcha-with-fallback.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./captcha-with-fallback.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".captcha-fallback .BDC_CaptchaDiv{margin:0 auto!important}.captcha-fallback__loader{height:75px;line-height:75px;text-align:center;background-color:#f9f9f9}", ""]);
	
	// exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(637);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/stylus-loader/index.js!./common.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/stylus-loader/index.js!./common.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, ".base-gradient{background:linear-gradient(0deg,#cdcdcd,#fefefe,#cdcdcd)}body{height:100%;font:62.5% helvetica,arial,verdana,sans-serif}.css-form input.ng-invalid.ng-touched{background-color:#fa787e}.button-general,.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev{border-radius:0;color:#fff}.button-general:focus,.button-general:hover,.button-navigation:focus,.button-navigation:hover,button.button-cancel:focus,button.button-cancel:hover,button.button-next:focus,button.button-next:hover,button.button-plain:focus,button.button-plain:hover,button.button-prev:focus,button.button-prev:hover{color:#fff}.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev{padding:10px 20px;border-width:1px;border-color:#fff;background-color:#406494}button.button-cancel{background-color:#999}.button-icon,button.button-next .button-arrow{margin-left:5px}button.button-prev .button-arrow{margin-right:5px}.capcha-container{padding:0 17px}.form-error-label{color:red;font-style:italic}select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\"}.utilization-info{margin-top:20px}.utilization-info,.utilization-info .table-row{margin-bottom:10px}.input-error{background-color:#fa787e!important}", ""]);
	
	// exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(639);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _feasibility = __webpack_require__(650);
	
	var _feasibility2 = _interopRequireDefault(_feasibility);
	
	var _blank = __webpack_require__(656);
	
	var _blank2 = _interopRequireDefault(_blank);
	
	var _nest = __webpack_require__(662);
	
	var _nest2 = _interopRequireDefault(_nest);
	
	var _report = __webpack_require__(666);
	
	var _report2 = _interopRequireDefault(_report);
	
	__webpack_require__(674);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_home2.default, _feasibility2.default, _blank2.default, _nest2.default, _report2.default]).name;
	
	exports.default = componentModule;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(640);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('home', [_angularUiRouter2.default]).config(["$httpProvider", "$stateProvider", "$urlRouterProvider", function ($httpProvider, $stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $httpProvider.defaults.withCredentials = true;
	    $urlRouterProvider.otherwise('/');
	    $stateProvider.state('home', {
	        resolve: {
	            currentData: ["LoadedModel", function currentData(LoadedModel) {
	                return LoadedModel.getCurrentSession();
	            }]
	        },
	        url: '/',
	        component: 'home'
	    });
	}]).component('home', _home2.default).name;
	
	exports.default = homeModule;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(641);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(642);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default
	};
	
	exports.default = homeComponent;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<div></div>\n<div class=\"main-container\">\n  <navbar>\n  </navbar>\n  <div class=\"main-content\">\n    <div class=\"left\">\n      <form ng-if=\"$ctrl.model.hasMesh()\" name=\"form\" class=\"control-container form-horizontal\">\n        <div class=\"form-wrapper\">\n          <file-upload\n            file-name=\"{{ $ctrl.model.fileName }}\"\n            inline=\"true\">\n          </file-upload>\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Material\n            </label>\n            <select-control\n              ng-if=\"$ctrl.model.systemsOfMeasurementUnit === 'inch'\"\n              options=\"$ctrl.model.getOptions('materialInch')\"\n              model = \"$ctrl.model.material\">\n            </select-control>\n            <select-control\n              ng-if=\"$ctrl.model.systemsOfMeasurementUnit === 'mm'\"\n              options=\"$ctrl.model.getOptions('materialMm')\"\n              model = \"$ctrl.model.material\">\n            </select-control>\n          </div>\n          <div ng-if=\"!$ctrl.model.lockOffset\" class=\"form-group\">\n            <label class=\"control-label\">\n              Geometry usage\n            </label>\n            <select-control\n              model=\"$ctrl.model.offset\"\n              options=\"$ctrl.model.getOptions('offset')\">\n            </select-control>\n          </div>\n          <div ng-if=\"$ctrl.model.lockOffset\" class=\"form-group\">\n            <label class=\"control-label\">\n              Geometry usage:\n            </label>\n            <span>\n                {{ $ctrl.model.getOffsetName() }}\n            </span>\n          </div>\n\n          <!--<div class=\"form-check\">-->\n            <!--<label class=\"form-check-label\">-->\n              <!--Email:-->\n              <!--<div  class=\"input-container\">-->\n                <!--<input type=\"email\" ng-model=\"$ctrl.model.email\" required name=\"email\"  ng-class=\"{'data-checked': form.email.$valid}\" class=\"form-control default-element input-l\">-->\n                <!--<span ng-show=\"form.email.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>-->\n              <!--</div>-->\n              <!--<div class=\"form-error-label\" ng-show=\"form.$submitted && !form.email.$valid || form.email.$touched && !form.email.$valid\">-->\n                <!--<span ng-show=\"form.email.$error.required\">Email is required</span>-->\n                <!--<span ng-show=\"form.email.$error.email\">Email is not valid</span>-->\n              <!--</div>-->\n            <!--</label>-->\n          <!--</div>-->\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Thickness\n            </label>\n            <input ng-class=\"{'input-error': $ctrl.checkThickness()}\" max=\"10\" min=\"0\" name=\"thickness\" set-thickness awnum=\"\" num-neg=\"false\" num-sep=\".\" num-int=\"4\" num-fract=\"2\" ng-focus=\"$ctrl.model.thicknessGetFocus()\" ng-blur=\"$ctrl.model.invalidateThickness()\" type=\"text\" ng-model=\"$ctrl.model.thickness\" class=\"form-control labeled-input default-element\">\n            <span class=\"bold-text\">\n              {{ $ctrl.model.systemsOfMeasurementUnit }}\n            </span>\n            <div class=\"form-error-label\" ng-show=\"$ctrl.checkThickness()\">\n              <span ng-show=\"$ctrl.model.systemsOfMeasurementUnit === 'mm'\" >Please enter a value between 0 and 8.0</span>\n              <span ng-show=\"$ctrl.model.systemsOfMeasurementUnit !== 'mm'\" >Please enter a value between 0 and 0.315</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Units\n            </label>\n            <select-control\n              model=\"$ctrl.model.unit\"\n              options=\"$ctrl.model.getOptions('unit')\">\n            </select-control>\n          </div>\n        </div>\n        <div class=\"help-button-left\">\n          <info-widget\n            topic=\"part\"\n            label=\"true\">\n          </info-widget>\n        </div>\n      </form>\n      <form ng-if=\"!$ctrl.model.hasMesh()\" class=\"control-container form-horizontal\">\n        <div class=\"footer-wrapper\">\n        <!--<file-upload-->\n          <!--file-name=\"{{ $ctrl.model.fileName }}\"-->\n          <!--inline=\"true\">-->\n        <!--</file-upload>-->\n        <!--{{ $ctrl.model.fileName }} something missing-->\n          <div class=\"help-button-left\">\n            <info-widget\n              topic=\"part\"\n              label=\"true\">\n            </info-widget>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"right\">\n        <file-upload\n          ng-if=\"!$ctrl.model.hasMesh()\"\n          file-name=\"{{ $ctrl.model.fileName }}\">\n        </file-upload>\n        <div ng-if=\"$ctrl.model.hasMesh()\">\n          <model-view>\n          </model-view>\n          <page-navigation\n            next=\"feasibility\">\n          </page-navigation>\n        </div>\n    </div>\n  </div>\n  <session-notification>\n  </session-notification>\n  <solver-progress>\n  </solver-progress>\n  <error-notification>\n  </error-notification>\n</div>\n"

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseViewController = __webpack_require__(643);
	
	var _baseViewController2 = _interopRequireDefault(_baseViewController);
	
	var _notificationModal = __webpack_require__(644);
	
	var _notificationModal2 = _interopRequireDefault(_notificationModal);
	
	var _notificationModal3 = __webpack_require__(645);
	
	var _notificationModal4 = _interopRequireDefault(_notificationModal3);
	
	var _saveUserInfoModal = __webpack_require__(646);
	
	var _saveUserInfoModal2 = _interopRequireDefault(_saveUserInfoModal);
	
	var _saveUserInfoModal3 = __webpack_require__(647);
	
	var _saveUserInfoModal4 = _interopRequireDefault(_saveUserInfoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function (_BaseViewController) {
	    (0, _inherits3.default)(HomeController, _BaseViewController);
	
	    function HomeController($scope, $state, LoadedModel, $uibModal, $cookies) {
	        (0, _classCallCheck3.default)(this, HomeController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (HomeController.__proto__ || (0, _getPrototypeOf2.default)(HomeController)).call(this, $scope, $state, LoadedModel));
	
	        _this._$uibModal = $uibModal;
	        _this.viewKey = _this.meshViewKey;
	
	        var defaultUploadText = "Please upload 3D model (*.igs or *.stl only) via selection or drag and drop";
	        _this.meshError = defaultUploadText;
	        var userInfo = _this.model.restoreUserDetails();
	        if (!userInfo) {
	            _this.openModal();
	        }
	        if (_this.getCurrentView()) {
	            _this.loadCurrentView();
	        } else if (_this.model.mesh) {
	            _this.loadViewByData({
	                fileName: _this.model.fileName,
	                mesh: _this.model.mesh,
	                maxDimensions: _this.model.maxDimensions,
	                offset: _this.model.offset
	
	            }, 'mesh');
	            var self = _this;
	            setTimeout(function () {
	                self._$scope.$broadcast('solverFinished', {
	                    step: 'part'
	                });
	            });
	        }
	
	        $scope.$on('meshedFileSurface', function (event, data) {
	            _this.showSurfaceMessage(data);
	        });
	
	        $scope.$on('partStepChanged', function () {
	            _this.model.invalidateStep('part');
	        });
	
	        $scope.$on('fileMeshed', function (event, data) {
	            _this.setMesh(data);
	            _this._$scope.$apply();
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(HomeController, [{
	        key: 'checkThickness',
	        value: function checkThickness() {
	            return !this.model.isThicknessValid();
	        }
	    }, {
	        key: 'showSurfaceMessage',
	        value: function showSurfaceMessage() {
	            var _message = 'A solid is imported and the ' + this.model.offset.name + ' has been selected.';
	            this._$uibModal.open({
	                animation: false,
	                template: _notificationModal4.default,
	                controllerAs: '$ctrl',
	                size: 'sm',
	                resolve: {
	                    message: function message() {
	                        return _message;
	                    }
	                },
	                controller: _notificationModal2.default
	            });
	        }
	    }, {
	        key: 'setMesh',
	        value: function setMesh(data) {
	            this.model.fileName = data.fileName;
	            this.model.mesh = data.mesh;
	            if (data.lockOffset) {
	                this.model._offset = data.offset;
	                this.model._thickness = data.thickness;
	                this.model.lockOffset = data.lockOffset;
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this._$uibModal.open({
	                size: 'sm',
	                animation: false,
	                template: _saveUserInfoModal2.default,
	                controllerAs: '$ctrl',
	                backdrop: 'static',
	                keyboard: false,
	                controller: _saveUserInfoModal4.default
	            });
	        }
	    }]);
	    return HomeController;
	}(_baseViewController2.default);
	
	HomeController.$inject = ['$scope', '$state', 'LoadedModel', '$uibModal', '$cookies'];
	
	exports.default = HomeController;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseViewController = function () {
	    function BaseViewController($scope, $state, LoadedModel) {
	        (0, _classCallCheck3.default)(this, BaseViewController);
	
	        this._$scope = $scope;
	        this._$state = $state;
	
	        this.model = LoadedModel;
	
	        this.updateEvent = 'updateView';
	
	        this.meshViewKey = 'mesh';
	        this.feasibilityViewKey = 'feasibility';
	        this.thinningViewKey = 'thinning';
	        this.blankViewKey = 'blank';
	        this.nestViewKey = 'nest';
	    }
	
	    (0, _createClass3.default)(BaseViewController, [{
	        key: 'getCurrentView',
	        value: function getCurrentView() {
	            return this.model.getView(this.viewKey);
	        }
	    }, {
	        key: 'loadView',
	        value: function loadView(view, key) {
	            var self = this;
	            setTimeout(function () {
	                self._$scope.$broadcast(self.updateEvent, [undefined, view, key]);
	            });
	        }
	    }, {
	        key: 'updateView',
	        value: function updateView(key) {
	            this.loadViewByData(this.model.getViewData(key), key);
	        }
	    }, {
	        key: 'loadViewByData',
	        value: function loadViewByData(data, key) {
	            var self = this;
	            setTimeout(function () {
	                self._$scope.$broadcast(self.updateEvent, [data, undefined, key]);
	            }, 0);
	        }
	    }, {
	        key: 'loadViewOrUpdate',
	        value: function loadViewOrUpdate(key) {
	            var view = this.model.getView(key);
	            if (view) {
	                this.loadView(view, key);
	            } else {
	                this.updateView(key);
	            }
	        }
	    }, {
	        key: 'loadCurrentView',
	        value: function loadCurrentView() {
	            this.loadView(this.getCurrentView(), this.viewKey);
	        }
	    }, {
	        key: 'updateCurrentView',
	        value: function updateCurrentView(data) {
	            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.viewKey;
	
	            this.loadViewByData(data, key);
	        }
	    }]);
	    return BaseViewController;
	}();
	
	exports.default = BaseViewController;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationController = function () {
	    function NotificationController($uibModalInstance, message) {
	        (0, _classCallCheck3.default)(this, NotificationController);
	
	        this.message = message;
	        this._$uibModalInstance = $uibModalInstance;
	    }
	
	    (0, _createClass3.default)(NotificationController, [{
	        key: 'ok',
	        value: function ok() {
	            this._$uibModalInstance.close();
	        }
	    }]);
	    return NotificationController;
	}();
	
	NotificationController.$inject = ['$uibModalInstance', 'message'];
	
	exports.default = NotificationController;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content report-modal\">\n    <div class=\"modal-header ng-scope\">\n      <h3 class=\"modal-title\" id=\"modal-title\">{{ $ctrl.message }}</h3>\n    </div>\n    <div class=\"modal-footer ng-scope\">\n      <button class=\"btn button-plain\" ng-click=\"$ctrl.ok(form)\">OK</button>\n    </div>\n</div>\n"

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content report-modal\">\n  <form name=\"form\" novalidate ng-submit=\"$ctrl.ok(form)\" class=\"css-form\">\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-check\">\n        <label class=\"form-check-label inline-input\">\n          First Name\n          <input type=\"text\" ng-model=\"$ctrl.model.name\" required name=\"name\" class=\"form-control default-element input-s\">\n        </label>\n        <label class=\"form-check-label inline-input\">\n          Last Name\n          <input type=\"text\" ng-model=\"$ctrl.model.userLastName\" required name=\"userLastName\" class=\"form-control default-element input-s\">\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <label class=\"form-check-label inline-input\">\n          <div class=\"form-error-label\" ng-show=\"(form.$submitted || form.name.$touched) && form.name.$invalid\">\n            <span>First name is required</span>\n          </div>\n        </label>\n        <label class=\"form-check-label inline-input\">\n          <div class=\"form-error-label\" ng-show=\"(form.$submitted || form.userLastName.$touched) && form.userLastName.$invalid\">\n            <span>Last Name is required</span>\n          </div>\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <label class=\"form-check-label\">\n          Organization Name:\n          <div  class=\"input-container\">\n            <input type=\"text\" ng-model=\"$ctrl.model.organization\" name=\"organization\"  class=\"form-control default-element input-l\">\n          </div>\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <label class=\"form-check-label\">\n          Email:\n          <div  class=\"input-container\">\n            <input type=\"email\" ng-model=\"$ctrl.model.email\" required name=\"email\"  ng-class=\"{'data-checked': form.email.$valid}\" class=\"form-control default-element input-l\">\n            <span ng-show=\"form.email.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>\n          </div>\n          <div class=\"form-error-label\" ng-show=\"(form.$submitted || form.email.$touched) && form.email.$invalid\">\n            <span ng-show=\"form.email.$error.required\">Email is required</span>\n            <span ng-show=\"form.email.$error.email\">Email is not valid</span>\n          </div>\n        </label>\n      </div>\n      <div class=\"form-checked\">\n        <md-checkbox class=\"md-primary\" ng-model=\"$ctrl.model.addNumber\">\n          Contact me via phone\n        </md-checkbox>\n      </div>\n      <div ng-if=\"$ctrl.model.addNumber\" class=\"form-check\">\n        <label class=\"phone-label\">\n          Phone number\n        </label>\n        <div>\n          <label class=\"form-check-label inline-input\">\n            <label>+</label>\n            <input awnum=\"\" num-int=\"5\" num-fract=\"0\" type=\"text\" ng-model=\"$ctrl.model.phoneCode\" ng-class=\"{'checked': form.phoneCode.$valid}\" required name=\"phoneCode\" class=\"form-control phone-code default-element input-s\">\n            <span ng-show=\"form.phoneCode.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>\n          </label>\n          <label class=\"form-check-label inline-input\">\n            <input awnum=\"\" num-int=\"11\" num-fract=\"0\" type=\"text\" ng-model=\"$ctrl.model.phone\" required name=\"phone\"  ng-class=\"{'checked': form.phone.$valid}\" class=\"form-control phone default-element input-s\">\n            <span ng-show=\"form.phone.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>\n          </label>\n        </div>\n      </div>\n    </div>\n    <div clas=\"form-check\">\n      <div class=\"capcha-container\">\n        <captcha-with-fallback on-init=\"$ctrl.onCaptchaInit(validate)\"></captcha-with-fallback>\n        <div class=\"form-error-label\" ng-show=\"$ctrl.catpchaIsInvalid\"><span>Invalid captcha code</span></div>\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn button-plain\" ng-disabled=\"$ctrl.model.requestInProgress || form.$invalid\">\n          </span>Continue</span>\n          <span class=\"icon-button-container\">\n            <span class=\"icon easyblank-icon button-icon\">S</span>\n          </span>\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(567);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SendSaveUserInfoController = function () {
	  function SendSaveUserInfoController($uibModalInstance, $rootScope, $scope, LoadedModel, $uibModal, $cookies) {
	    (0, _classCallCheck3.default)(this, SendSaveUserInfoController);
	
	    this._$cookies = $cookies;
	    this._$rootScope = $rootScope;
	    this._$uibModal = $uibModal;
	    this._$scope = $scope;
	    this.model = LoadedModel;
	    this.model.cleanUserDetails();
	    this._$uibModalInstance = $uibModalInstance;
	    this._captchaValidate = function () {
	      return _promise2.default.reject();
	    };
	  }
	
	  (0, _createClass3.default)(SendSaveUserInfoController, [{
	    key: 'onCaptchaInit',
	    value: function onCaptchaInit(validate) {
	      this._captchaValidate = validate;
	    }
	  }, {
	    key: 'ok',
	    value: function ok(form) {
	      var _this = this;
	
	      if (form.$valid) {
	        this._captchaValidate().then(function () {
	          _this.requestInProgress = _this.model.requestInProgress = true;
	          _this.model.saveUserDetails();
	          _this._$uibModalInstance.close();
	        }, function () {
	          return _this.catpchaIsInvalid = true;
	        });
	      }
	    }
	  }]);
	  return SendSaveUserInfoController;
	}();
	
	SendSaveUserInfoController.$inject = ['$uibModalInstance', '$rootScope', '$scope', 'LoadedModel', '$uibModal', '$cookies'];
	
	exports.default = SendSaveUserInfoController;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(649);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./home.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./home.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _feasibility = __webpack_require__(651);
	
	var _feasibility2 = _interopRequireDefault(_feasibility);
	
	__webpack_require__(654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var feasibilityModule = _angular2.default.module('feasibility', [_angularUiRouter2.default]).config(["$httpProvider", "$stateProvider", "$urlRouterProvider", function ($httpProvider, $stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.otherwise('/');
	    $httpProvider.defaults.withCredentials = true;
	    $stateProvider.state('feasibility', {
	        url: '/feasibility',
	        resolve: {
	            currentData: ["LoadedModel", function currentData(LoadedModel) {
	                return LoadedModel.getCurrentSession();
	            }]
	        },
	        component: 'feasibility'
	    });
	}]).component('feasibility', _feasibility2.default).name;
	
	exports.default = feasibilityModule;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _feasibility = __webpack_require__(652);
	
	var _feasibility2 = _interopRequireDefault(_feasibility);
	
	var _feasibility3 = __webpack_require__(653);
	
	var _feasibility4 = _interopRequireDefault(_feasibility3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var feasibilityComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _feasibility2.default,
	  controller: _feasibility4.default
	};
	
	exports.default = feasibilityComponent;

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = "<div></div>\n<div class=\"main-container\">\n  <navbar>\n  </navbar>\n  <div class=\"main-content\">\n    <div class=\"left\">\n      <form class=\"control-container form-horizontal\">\n        <div class=\"form-wrapper\">\n          <div class=\"form-group\">\n            <radio-control\n              name=\"'holdingCond'\"\n              options=\"$ctrl.model.getOptions('holdingCond')\"\n              model=\"$ctrl.model.holdingCond\">\n            </radio-control>\n          </div>\n          <div ng-if=\"$ctrl.model.results === 'feasibility'\" class=\"legend legend-formability\">\n            <div class=\"labels\">\n              <span class=\"color-sample splits\"></span>\n              <span class=\"color-sample-line-formability splits\">Splits</span>\n            </div>\n            <div class=\"labels\">\n              <span class=\"color-sample excess\"></span>\n              <span class=\"color-sample-line-formability excess\">Excessive Thinning</span>\n            </div>\n            <div class=\"labels\">\n              <span class=\"color-sample splits-risk\"></span>\n              <span class=\"color-sample-line-formability splits-risk\">Risk of Splits</span>\n            </div>\n            <div class=\"labels\">\n              <span class=\"color-sample safe\"></span>\n              <span class=\"color-sample-line-formability safe\">Safe</span>\n            </div>\n            <div class=\"labels\">\n              <span class=\"color-sample stretch\"></span>\n              <span class=\"color-sample-line-formability stretch\">Insufficient Stretch</span>\n\n            </div>\n            <div class=\"labels\">\n              <span class=\"color-sample compression\"></span>\n              <span class=\"color-sample-line-formability compression\">Compression</span>\n\n            </div>\n            <div class=\"labels\">\n              <span class=\"color-sample thick\"></span>\n              <span class=\"color-sample-line-formability thick\">Thickening</span>\n            </div>\n          </div>\n          <div class=\"legend-thinning-container\" ng-if=\"$ctrl.model.results === 'thinning'\">\n            <div class=\"legend legend-thinning\">\n              <div class=\"labels\">\n                <span class=\"gradient-30 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-30\">-30%</span>\n              </div>\n              <div class=\"labels\">\n                <span class=\"gradient-25 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-25\">-25%</span>\n              </div>\n              <div class=\"labels\">\n                <span class=\"gradient-20 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-20\">-20%</span>\n              </div>\n              <div class=\"labels\">\n                <span class=\"gradient-15 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-15\">-15%</span>\n              </div>\n              <div class=\"labels\">\n                <span class=\"gradient-10 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-10\">-10%</span>\n              </div>\n              <div class=\"labels\">\n                <span class=\"gradient-5 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-5\">-5%</span>\n              </div>\n              <div class=\"labels\">\n                <span class=\"gradient-0 color-sample\"></span>\n                <span class=\"color-sample-line-thinning label-0\">0</span>\n                <span class=\"color-sample-line-thinning bottom-label\">5%</span>\n                <span class=\"color-sample-line-thinning bottom label5\"></span>\n              </div>\n            </div>\n            <span class=\"thinning-explanation\">\n                Please note that the accuracy of these results depends on how well the applied process parameters match the reality.\n                It could be increased by using more advanced approaches like the software module AutoForm-Incremental.\n            </span>\n\n          </div>\n        </div>\n        <div class=\"footer-wrapper\">\n          <div class=\"info-widget\">\n            <div>Part <strong>{{ $ctrl.model.fileName  }}</strong></div>\n            <div>Material <strong>{{ $ctrl.model.getHumanReadableName('material') }}</strong></div>\n            <div>Thickness <strong>{{ ($ctrl.model.thickness | number : 2) * 1 }} {{ $ctrl.model.systemsOfMeasurementUnit }}</strong></div>\n          </div>\n        </div>\n        <div class=\"help-button-left\">\n          <info-widget\n            topic=\"feasibility\"\n            label=\"true\">\n          </info-widget>\n        </div>\n      </form>\n    </div>\n    <div class=\"right\">\n      <div>\n        <div class=\"forming-container\">\n          <div class=\"forming-inner\">\n            <radio-control\n              name=\"'results'\"\n              options=\"$ctrl.model.getOptions('results')\"\n              model=\"$ctrl.model.results\">\n            </radio-control>\n          </div>\n        </div>\n        <snapshot-widget\n          type=\"$ctrl.getViewKey()\">\n        </snapshot-widget>\n        <model-view>\n        </model-view>\n        <page-navigation\n          next=\"blank\"\n          prev=\"home\">\n        </page-navigation>\n      </div>\n    </div>\n  </div>\n  <session-notification>\n  </session-notification>\n  <solver-progress>\n  </solver-progress>\n  <error-notification>\n  </error-notification>\n</div>\n"

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseViewController = __webpack_require__(643);
	
	var _baseViewController2 = _interopRequireDefault(_baseViewController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeasibilityController = function (_BaseViewController) {
	    (0, _inherits3.default)(FeasibilityController, _BaseViewController);
	
	    function FeasibilityController($scope, $state, $rootScope, LoadedModel) {
	        (0, _classCallCheck3.default)(this, FeasibilityController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (FeasibilityController.__proto__ || (0, _getPrototypeOf2.default)(FeasibilityController)).call(this, $scope, $state, LoadedModel));
	
	        _this._$rootScope = $rootScope;
	
	        var view = _this.getCurrentView();
	
	        var meshView = _this.model.getView(_this.meshViewKey);
	
	        $scope.$on('formingTypeChanged', function () {
	            _this.checkAndSendModel();
	        });
	
	        var sendSolverRequest = function sendSolverRequest() {
	            setTimeout(function () {
	                _this.sendModel();
	            }, 0);
	        };
	
	        if (view) {
	            _this.loadCurrentView();
	        } else if (meshView) {
	            _this.loadView(meshView, _this.meshViewKey);
	            if (_this.model.passedSteps.indexOf('feasibility') === -1) {
	                sendSolverRequest();
	            }
	        } else if (_this.model.isStepPassed('part')) {
	            _this.loadViewByType();
	        } else {
	            _this._$state.go('home');
	        }
	        return _this;
	    }
	
	    (0, _createClass3.default)(FeasibilityController, [{
	        key: 'getSelectedKey',
	        value: function getSelectedKey() {
	            return this.model.results === 'thinning' ? this.thinningViewKey : this.feasibilityViewKey;
	        }
	    }, {
	        key: 'getViewKey',
	        value: function getViewKey() {
	            return this.model.results === 'thinning' ? this.thinningViewKey : this.feasibilityViewKey;
	        }
	    }, {
	        key: 'getCurrentView',
	        value: function getCurrentView() {
	            return this.model.getView(this.getSelectedKey());
	        }
	    }, {
	        key: 'loadCurrentView',
	        value: function loadCurrentView() {
	            var view = this.getCurrentView();
	            this.model.setCashedView(view);
	            var key = this.getSelectedKey();
	            this.loadView(view, key);
	        }
	    }, {
	        key: 'loadViewByType',
	        value: function loadViewByType() {
	            var formingType = this.model.results;
	            var data = formingType === 'thinning' ? this.model.getThinningData() : this.model.getFormabilityData();
	            this.updateCurrentView([data, this.model.maxDimensions], formingType);
	        }
	    }, {
	        key: 'invalidateBlankData',
	        value: function invalidateBlankData() {
	            var _this2 = this;
	
	            var invalidateDataMapper = ['blankBoundaryModCustom', 'showWidthInput', 'isUsedCustomWidth', 'customWidth', 'nestN3', 'nestN2', 'nestView'];
	            invalidateDataMapper.forEach(function (key) {
	                _this2.model[key] = undefined;
	            });
	        }
	    }, {
	        key: 'checkAndSendModel',
	        value: function checkAndSendModel() {
	            var cashedModel = this.model.getCashed();
	            if (cashedModel) {
	                this.model.passedSteps = ["part", "feasibility"];
	                this._$rootScope.$broadcast('updateSteps', { step: "feasibility" });
	                this.model.updateSim(cashedModel);
	                var view = this.model.getCashedSimView();
	                var key = this.getSelectedKey();
	                this.invalidateBlankData();
	                this.model.invalidateSnapshots('feasibility');
	                // this.model.invalidateStep('feasibility');
	                this.model[key] = view;
	                this.loadViewByData(this.model.getViewData(key), key);
	                this.model.calculateUtilizationInfo();
	            } else {
	                this.sendModel();
	            }
	        }
	    }, {
	        key: 'sendModel',
	        value: function sendModel() {
	            var _this3 = this;
	
	            this.requestInProgress = this.model.requestInProgress = true;
	            var uniqParam = this.model.uuid();
	            this.model.getProgress(uniqParam, 'feasibility', true);
	            this.model.sendData('feasibility', false, uniqParam).then(function (results) {
	                _this3.model.generateExpTime();
	                _this3.requestInProgress = _this3.model.requestInProgress = false;
	                _this3.model.passedSteps = results.passedSteps;
	                _this3.model.invalidateSnapshots('feasibility');
	                _this3.invalidateBlankData();
	                var simData = {
	                    afeb: results.afeb,
	                    blankBoundaryMod: results.blankBoundaryMod,
	                    mex: results.mex,
	                    boundary: results.boundary,
	                    meshLL: results.meshLL
	                };
	
	                _this3.model.updateSimAndCash(_this3.model.holdingCond, simData);
	                _this3.model.calculateUtilizationInfo();
	                _this3.loadViewByType();
	                _this3._$scope.$broadcast('solverFinished', { step: 'feasibility' });
	            }, function () {
	                _this3._$rootScope.$broadcast('showErrorDialog', { type: 'feasibility' });
	                _this3.model.generateExpTime();
	                _this3.requestInProgress = _this3.model.requestInProgress = false;
	            });
	        }
	    }]);
	    return FeasibilityController;
	}(_baseViewController2.default);
	
	FeasibilityController.$inject = ['$scope', '$state', '$rootScope', 'LoadedModel'];
	
	exports.default = FeasibilityController;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./feasibility.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./feasibility.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, ".forming-container{position:absolute;width:100%;margin-left:-360px}.forming-container .forming-inner{position:absolute;right:300px}.forming-container .forming-inner label{margin-top:0}.legend-thinning{color:#4169e1;max-width:130px}.thinning-explanation{float:right;width:150px;margin-top:-355px;color:#848484;font-size:12px}.legend-formability{color:#4169e1;max-width:170px}.labels{text-align:left;height:50px}.labels .color-sample-line,.labels .color-sample-line-formability{width:150px;height:2px;float:left;text-align:right;color:#444}.labels .color-sample-line-thinning{width:60px;height:2px;float:left;text-align:right;color:#444}.labels .color-sample-line-thinning.bottom{margin-top:46px}.labels .color-sample-line-thinning.bottom-label{margin-top:29px}.labels .color-sample-line-thinning.bottom{margin-top:15px}.labels .color-sample{float:left;width:20px;height:50px;display:inline-block}.labels .splits{background-color:red}.labels .excess{background-color:orange}.labels .splits-risk{background-color:#ff0}.labels .safe{background-color:#7fffd4}.labels .stretch{background-color:#a9a9a9}.labels .compression{background-color:#00f}.labels .thick{background-color:#f0f}.labels .gradient-30{background:linear-gradient(#d239d2,#f42417)}.labels .gradient-25{background:linear-gradient(#f42417,#f5a525)}.labels .gradient-20{background:linear-gradient(#f5a525,#91ff00)}.labels .gradient-15{background:linear-gradient(#91ff00,#62e186)}.labels .gradient-10{background:linear-gradient(#62e186,#a1f9d8)}.labels .gradient-5{background:linear-gradient(#a1f9d8,#00a7ff)}.labels .gradient-0{background:linear-gradient(#00a7ff,#00a7ff)}.labels .label-30{background-color:#d239d2}.labels .label-25{background-color:#f42417}.labels .label-20{background-color:#f5a525}.labels .label-15{background-color:#91ff00}.labels .label-10{background-color:#62e186}.labels .label-5{background-color:#a1f9d8}.labels .label5,.labels .label-0{background-color:#00a7ff}", ""]);
	
	// exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _blank = __webpack_require__(657);
	
	var _blank2 = _interopRequireDefault(_blank);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blankModule = _angular2.default.module('blank', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.otherwise('/');
	
	    $stateProvider.state('blank', {
	        url: '/blank',
	        resolve: {
	            currentData: ["LoadedModel", function currentData(LoadedModel) {
	                return LoadedModel.getCurrentSession();
	            }]
	        },
	        component: 'blank'
	    });
	}]).component('blank', _blank2.default).name;
	
	exports.default = blankModule;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _blank = __webpack_require__(658);
	
	var _blank2 = _interopRequireDefault(_blank);
	
	var _blank3 = __webpack_require__(659);
	
	var _blank4 = _interopRequireDefault(_blank3);
	
	__webpack_require__(660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blankComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _blank2.default,
	  controller: _blank4.default
	};
	
	exports.default = blankComponent;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-container\">\n  <navbar>\n  </navbar>\n  <div class=\"main-content\">\n    <div class=\"left\">\n      <form class=\"control-container form-horizontal\">\n        <div class=\"form-wrapper\">\n          <div class=\"text-labels form-group\">\n            <label class=\"control-label\">Convex</label>\n            <rzslider class=\"custom-slider\"\n                      rz-slider-model=\"$ctrl.model.convex\"\n                      rz-slider-options=\"$ctrl.slidersOptions.convex.options\">\n            </rzslider>\n          </div>\n          <div class=\"text-labels form-group\">\n            <label class=\"control-label\">Smooth</label>\n            <rzslider class=\"custom-slider\"\n                      rz-slider-model=\"$ctrl.model.smooth\"\n                      rz-slider-options=\"$ctrl.slidersOptions.smooth.options\">\n            </rzslider>\n          </div>\n          <div class=\"form-group\">\n            <button ng-class=\"{'disabled': $ctrl.blockToggleButton()}\" type=\"button\" class=\"btn button-plain pull-right\" ng-click=\"$ctrl.toggleWithInput()\">{{ $ctrl.canShowInput() ? 'Use slider' : 'Use input'}}</button>\n            <!--<button type=\"button\" class=\"btn button-plain pull-right\"  ng-if=\"$ctrl.model.customWidth\">Use pre-calculated expand</button>-->\n          </div>\n          <div ng-show=\"!$ctrl.canShowInput()\" class=\"form-group\">\n            <label class=\"control-label\">Expand ({{ $ctrl.model.systemsOfMeasurementUnit }})</label>\n            <rzslider class=\"custom-slider\"\n                      rz-slider-model=\"$ctrl.model.width\"\n                      rz-slider-options=\"$ctrl.slidersOptions.width.options\">\n            </rzslider>\n          </div>\n          <div ng-show=\"$ctrl.canShowInput()\" class=\"form-group\">\n            <label class=\"control-label\">\n              Expand\n            </label>\n            <input awnum=\"\" num-sep=\".\" num-neg=\"false\" num-int=\"4\" num-fract=\"2\" type=\"text\" ng-model=\"$ctrl.model.customWidth\" class=\"form-control default-element labeled-input\">\n            <span class=\"bold-text\">\n              {{ $ctrl.model.systemsOfMeasurementUnit }}\n            </span>\n          </div>\n          <div ng-show=\"$ctrl.canShowInput()\" class=\"form-group\">\n            <button type=\"button\" ng-class=\"{ 'data-changed-nest': $ctrl.isDataChanged()}\"  class=\"btn button-plain pull-right\"  ng-click=\"$ctrl.sendModel()\">Apply</button>\n          </div>\n        </div>\n        <div class=\"footer-wrapper\">\n          <div class=\"info-widget\">\n            <div>Part <strong>{{ $ctrl.model.fileName  }}</strong></div>\n            <div>Material <strong>{{ $ctrl.model.getHumanReadableName('material') }}</strong></div>\n            <div>Thickness <strong>{{ ($ctrl.model.thickness | number : 2) * 1 }} {{ $ctrl.model.systemsOfMeasurementUnit }}</strong></div>\n          </div>\n          <div class=\"help-button-left\">\n            <info-widget\n              topic=\"blank\"\n              label=\"true\">\n            </info-widget>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"right\">\n      <div>\n        <snapshot-widget\n          type=\"$ctrl.viewKey\">\n        </snapshot-widget>\n        <model-view>\n        </model-view>\n        <page-navigation\n          next=\"nest\"\n          prev=\"feasibility\">\n        </page-navigation>\n      </div>\n    </div>\n    </div>\n    <session-notification>\n    </session-notification>\n    <solver-progress>\n    </solver-progress>\n    <error-notification>\n    </error-notification>\n  </div>\n"

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(587);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseViewController = __webpack_require__(643);
	
	var _baseViewController2 = _interopRequireDefault(_baseViewController);
	
	var _boundariesHelpers = __webpack_require__(595);
	
	var _boundariesHelpers2 = _interopRequireDefault(_boundariesHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlankController = function (_BaseViewController) {
	    (0, _inherits3.default)(BlankController, _BaseViewController);
	
	    function BlankController($scope, $state, $rootScope, LoadedModel, MenuElements) {
	        (0, _classCallCheck3.default)(this, BlankController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BlankController.__proto__ || (0, _getPrototypeOf2.default)(BlankController)).call(this, $scope, $state, LoadedModel));
	
	        _this._$rootScope = $rootScope;
	        _this.viewKey = _this.blankViewKey;
	
	        _this.model.showWidthInput = _this.model.isUsedCustomWidth;
	
	        // TODO find out how to deal with this hack
	        if (!_this.model.calculatedWidth) {
	            _this.model.calculatedWidth = 0;
	        }
	        if (_this.model.isStepPassed('feasibility')) {
	            _this.updateCurrentView(_this.calculateBoundaries());
	        } else if (_this.model.isStepPassed('part')) {
	            _this._$state.go('feasibility');
	        } else {
	            _this._$state.go('home');
	        }
	
	        var mex = _this.model._unit.value === 'psi' ? _this.model.convertMetricToPSI(_this.model.mex) : _this.model.mex;
	        _this.slidersOptions = {
	            convex: {
	                options: {
	                    showSelectionBar: true,
	                    stepsArray: [{ value: 0, legend: 'Low' }, { value: 1 }, { value: 2 }, { value: 3, legend: 'High' }],
	                    floor: 0,
	                    ceil: 3,
	                    step: 1,
	                    showTicks: true
	                }
	            }, smooth: {
	                options: {
	                    showSelectionBar: true,
	                    stepsArray: [{ value: 0, legend: 'Low' }, { value: 1 }, { value: 2 }, { value: 3, legend: 'High' }],
	                    floor: 0,
	                    ceil: 3,
	                    step: 1,
	                    showTicks: true
	                }
	            }, width: {
	                options: {
	                    showSelectionBar: true,
	                    floor: 0,
	                    ceil: 4,
	                    step: 1,
	                    showTicks: true,
	                    showTicksValues: true,
	                    stepsArray: [{ value: 0, legend: "0" }, { value: 1, legend: _this.round(mex / 4) }, { value: 2, legend: _this.round(mex / 4 * 2) }, { value: 3, legend: _this.round(mex / 4 * 3) }, { value: 4, legend: _this.round(mex / 1) }]
	                }
	            }
	        };
	        var currBlankValues = _this.model.getCurrBlankValues();
	        if (currBlankValues && currBlankValues.customWidth !== undefined) {
	            _this._masterBlankValues = currBlankValues;
	        }
	        MenuElements.updateActiveStates('blank', true);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BlankController, [{
	        key: 'sendModel',
	        value: function sendModel() {
	            var _this2 = this;
	
	            this.requestInProgress = this.model.requestInProgress = true;
	            var uniqParam = this.model.uuid();
	            this.model.getProgress(uniqParam, 'blank', true);
	
	            if (this.model.customWidth === undefined) {
	                this.model.customWidth = 0;
	            }
	
	            this.model.sendData(this.viewKey, false, uniqParam).then(function (results) {
	                _this2.model.isUsedCustomWidth = true;
	                _this2.model.generateExpTime();
	                _this2.requestInProgress = _this2.model.requestInProgress = false;
	                var res = results.toJSON();
	                _this2.model.invalidateSnapshots('blank');
	                _.extend(_this2.model, res);
	                var useCustom = _this2.model.showWidthInput && _this2.model.isUsedCustomWidth;
	
	                var dataFile = useCustom ? _this2.model.blankBoundaryModCustom : _this2.model.blankBoundaryMod;
	                var width = useCustom ? 4 : _this2.model.width;
	                _this2.model.calculatedWidth = _this2.model.customWidth;
	                _this2._$rootScope.$broadcast('updateView', [[(0, _boundariesHelpers2.default)(dataFile, _this2.model.convex, _this2.model.smooth, width), _this2.model.meshLL, _this2.model.maxDimensions], undefined, 'blank']);
	                _this2._$scope.$broadcast('solverFinished', { step: 'blank' });
	                _this2._masterBlankValues = _this2.model.getCurrBlankValues();
	            }, function (error) {
	                _this2._$rootScope.$broadcast('showErrorDialog', { type: 'blank' });
	                _this2.model.generateExpTime();
	                _this2.requestInProgress = _this2.model.requestInProgress = false;
	            });
	        }
	    }, {
	        key: 'isDataChanged',
	        value: function isDataChanged() {
	            this.model.dataBlankChanged = (0, _stringify2.default)(this._masterBlankValues) !== (0, _stringify2.default)(this.model.getCurrBlankValues());
	            return this.model.dataBlankChanged;
	        }
	    }, {
	        key: 'round',
	        value: function round(value) {
	            if (this.model._unit.value === 'psi') {
	                return value.toFixed(1);
	            } else {
	                return value.toFixed(0);
	            }
	        }
	    }, {
	        key: 'toggleWithInput',
	        value: function toggleWithInput() {
	            this.model.showWidthInput = !this.model.showWidthInput;
	            // if(!this.model.showWidthInput) {
	            //     // this.model.isUsedCustomWidth = false;
	            // } else if (this.model.showWidthInput && this.model.blankBoundaryModCustom) {
	            //     // this.model.isUsedCustomWidth = true;
	            // }
	            this.model.updateBoundary();
	            // this.updateCurrentView(this.calculateBoundaries());
	        }
	    }, {
	        key: 'canShowInput',
	        value: function canShowInput() {
	            return this.model.showWidthInput;
	        }
	    }, {
	        key: 'blockToggleButton',
	        value: function blockToggleButton() {
	            return false;
	        }
	    }, {
	        key: 'calculateBoundaries',
	        value: function calculateBoundaries() {
	            var useCustom = this.model.isUsedCustomWidth;
	            var dataFile = useCustom ? this.model.blankBoundaryModCustom : this.model.blankBoundaryMod;
	            var width = useCustom ? 4 : this.model.width;
	            return [(0, _boundariesHelpers2.default)(dataFile, this.model.convex, this.model.smooth, width), this.model.meshLL, this.model.maxDimensions];
	        }
	    }]);
	    return BlankController;
	}(_baseViewController2.default);
	
	BlankController.$inject = ['$scope', '$state', '$rootScope', 'LoadedModel', 'MenuElements'];
	
	exports.default = BlankController;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(661);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./slider.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./slider.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! angularjs-slider - v6.0.0 -\n (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervieu.me>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> -\n https://github.com/angular-slider/angularjs-slider -\n 2017-01-02 */.rzslider{position:relative;display:inline-block;width:100%;height:4px;margin:20px 0 35px;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rzslider.with-legend{margin-bottom:40px}.rzslider[disabled]{cursor:not-allowed}.rzslider[disabled] .rz-pointer{cursor:not-allowed;background-color:#d8e0f3}.rzslider[disabled] .rz-draggable{cursor:not-allowed}.rzslider[disabled] .rz-selection{background:#8b91a2}.rzslider[disabled] .rz-tick{cursor:not-allowed}.rzslider[disabled] .rz-tick.rz-selected{background:#8b91a2}.rzslider span{position:absolute;display:inline-block;white-space:nowrap}.rzslider .rz-base{width:100%;height:100%;padding:0}.rzslider .rz-bar-wrapper{left:0;z-index:1;width:100%;height:32px;padding-top:16px;margin-top:-16px;box-sizing:border-box}.rzslider .rz-draggable{cursor:move}.rzslider .rz-bar{left:0;z-index:1;width:calc(100% - 12px);height:4px;background:#d8e0f3;border-radius:2px}.rzslider .rz-selection{z-index:2;background:#0db9f0;border-radius:2px;width:100%}.rzslider .rz-pointer{top:-14px;z-index:3;width:32px;height:32px;cursor:pointer;background-color:#0db9f0;border-radius:16px}.rzslider .rz-pointer:after{position:absolute;top:12px;left:12px;width:8px;height:8px;background:#fff;border-radius:4px;content:\"\"}.rzslider .rz-pointer:hover:after{background-color:#fff}.rzslider .rz-pointer.rz-active{z-index:4}.rzslider .rz-pointer.rz-active:after{background-color:#451aff}.rzslider .rz-bubble{bottom:16px;padding:1px 3px;color:#55637d;cursor:default;display:none}.rzslider .rz-bubble.rz-limit{color:#55637d}.rzslider .rz-ticks{position:absolute;top:-3px;left:0;z-index:1;width:100%;height:0;margin:0;list-style:none;box-sizing:border-box}.rzslider .rz-ticks-values-under .rz-tick-value{top:auto;bottom:-32px;display:none}.rzslider .rz-tick{position:absolute;top:0;left:0;width:10px;height:10px;margin-left:11px;text-align:center;cursor:pointer;background:#d8e0f3;border-radius:50%}.rzslider .rz-tick.rz-selected{background:silver}.rzslider .rz-tick-value{position:absolute;top:20px;transform:translate(-50%);display:none}.text-labels .rzslider .rz-tick-legend{padding-left:18px}.rzslider .rz-tick-legend{position:absolute;top:24px;max-width:50px;white-space:normal;transform:translate(-50%)}.rzslider.rz-vertical{position:relative;width:4px;height:100%;padding:0;margin:0 20px;vertical-align:baseline}.rzslider.rz-vertical .rz-base{width:100%;height:100%;padding:0}.rzslider.rz-vertical .rz-bar-wrapper{top:auto;left:0;width:32px;height:100%;padding:0 0 0 16px;margin:0 0 0 -16px}.rzslider.rz-vertical .rz-bar{bottom:0;left:auto;width:4px;height:100%}.rzslider.rz-vertical .rz-pointer{top:auto;bottom:0;left:-14px!important}.rzslider.rz-vertical .rz-bubble{bottom:0;left:16px!important;margin-left:3px;display:none}.rzslider.rz-vertical .rz-ticks{top:0;left:-3px;z-index:1;width:0;height:100%}.rzslider.rz-vertical .rz-tick{margin-top:11px;margin-left:auto;vertical-align:middle}.rzslider.rz-vertical .rz-tick-value{top:auto;left:24px;transform:translateY(-28%)}.rzslider.rz-vertical .rz-tick-legend{top:auto;right:24px;max-width:none;white-space:nowrap;transform:translateY(-28%)}.rzslider.rz-vertical .rz-ticks-values-under .rz-tick-value{right:24px;bottom:auto;left:auto}.custom-slider.rzslider .rz-bar{background:#6d6c6c;height:10px}.custom-slider.rzslider .rz-selection{background:#5686c7}.custom-slider.rzslider .rz-pointer{width:15px;height:24px;top:-7px;bottom:0;background-color:#a5a5a5;border-radius:0}.custom-slider.rzslider .rz-pointer:after{display:none}.custom-slider.rzslider .rz-bubble{bottom:14px;display:none}.custom-slider.rzslider .rz-limit{font-weight:700;color:#5686c7}.custom-slider.rzslider .rz-tick{width:8px;height:10px;margin-left:0;margin-top:3px;border-radius:0;background:#5686c7}.custom-slider.rzslider .rz-tick.rz-selected{background:silver}", ""]);
	
	// exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _nest = __webpack_require__(663);
	
	var _nest2 = _interopRequireDefault(_nest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestModule = _angular2.default.module('nest', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.otherwise('/');
	
	    $stateProvider.state('nest', {
	        url: '/nest',
	        resolve: {
	            currentData: ["LoadedModel", function currentData(LoadedModel) {
	                return LoadedModel.getCurrentSession();
	            }]
	        },
	        component: 'nest'
	    });
	}]).component('nest', _nest2.default).name;
	
	exports.default = nestModule;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nest = __webpack_require__(664);
	
	var _nest2 = _interopRequireDefault(_nest);
	
	var _nest3 = __webpack_require__(665);
	
	var _nest4 = _interopRequireDefault(_nest3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _nest2.default,
	  controller: _nest4.default
	};
	
	exports.default = nestComponent;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-container\">\n  <navbar>\n  </navbar>\n  <div class=\"main-content\">\n    <div class=\"left\">\n      <form class=\"control-container form-horizontal\">\n        <div class=\"form-wrapper\">\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Material price\n            </label>\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <input awnum=\"\" num-sep=\".\" num-neg=\"false\" num-int=\"4\" num-fract=\"2\" type=\"text\" ng-model=\"$ctrl.model.materialCost\" class=\"form-control default-element\"\">\n              </div>\n              <div class=\"col-sm-6\">\n                <label class=\"custom-select\">\n                  <select ng-options=\"option.name for option in $ctrl.model.getOptions('priceUnit') track by option.value\"\n                          ng-model=\"$ctrl.model.priceUnit\"></select>\n                </label>\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Expand:\n            </label>\n            {{ $ctrl.model.calculatedWidth }} {{ $ctrl.model.systemsOfMeasurementUnit }}\n          </div>\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Coil Edge\n            </label>\n            <input awnum=\"\" num-sep=\".\" num-neg=\"false\" num-int=\"4\" num-fract=\"2\" type=\"text\" ng-model=\"$ctrl.model.addWidth\" class=\"form-control default-element labeled-input\">\n            <span class=\"bold-text\">\n              {{ $ctrl.model.systemsOfMeasurementUnit }}\n            </span>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Bridge span\n            </label>\n            <input  awnum=\"\" num-sep=\".\" num-neg=\"false\" num-int=\"4\" num-fract=\"2\"  type=\"text\" ng-model=\"$ctrl.model.bridgeSpan\" class=\"form-control default-element labeled-input\">\n            <span class=\"bold-text\">\n              {{ $ctrl.model.systemsOfMeasurementUnit }}\n            </span>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"custom-select\">\n              <select ng-options=\"option.name for option in $ctrl.model.getOptions('nType') track by option.value\"\n                      ng-model=\"$ctrl.model.nType\"></select>\n            </label>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Orientation\n            </label>\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <label class=\"custom-select\">\n                  <select ng-options=\"option.name for option in $ctrl.model.getOptions('_orientType') track by option.value\"\n                          ng-model=\"$ctrl.model.orientType\">\n                  </select>\n                </label>\n              </div>\n              <div class=\"col-sm-6\">\n                <input type=\"text\"  awnum=\"\" num-sep=\".\" num-int=\"4\" num-fract=\"2\" ng-disabled=\"$ctrl.model.orientType.value === '0'\" ng-model=\"$ctrl.model.orientAngle\" class=\"form-control default-element\"\">\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <div ng-if=\"$ctrl.model.utilizationInfo\" class=\"utilization-info\">\n              <div class=\"table-row\">\n                <div class=\"report-cell-label\">Material cost:</div>\n                <div class=\"report-cell-value\">{{ ($ctrl.model.utilizationInfo.costCoilSegment | number : 2) * 1 }}</div>\n                <div class=\"report-cell-unit\"> {{ $ctrl.model.priceUnit.value }}</div>\n              </div>\n              <div class=\"table-row\">\n                <div class=\"report-cell-label\"> Utilization:</div>\n                <div class=\"report-cell-value\">{{ $ctrl.model.utilizationInfo.utilization }}</div>\n                <div class=\"report-cell-unit\">%</div>\n              </div>\n            </div>\n            <button type=\"button\" class=\"btn button-plain pull-right\"  ng-class=\"{ 'data-changed-nest': $ctrl.isDataChanged()}\" ng-click=\"$ctrl.sendModel()\">Apply</button>\n          </div>\n\n        </div>\n        <div class=\"footer-wrapper\">\n          <div class=\"info-widget\">\n            <div>Part <strong>{{ $ctrl.model.fileName  }}</strong></div>\n            <div>Material <strong>{{ $ctrl.model.getHumanReadableName('material') }}</strong></div>\n            <div>Thickness <strong>{{ ($ctrl.model.thickness | number : 2) * 1 }} {{ $ctrl.model.systemsOfMeasurementUnit }}</strong></div>\n          </div>\n          <div class=\"help-button-left\">\n            <info-widget\n              topic=\"nest\"\n              label=\"true\">\n            </info-widget>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"right\">\n      <div>\n        <snapshot-widget\n          type=\"$ctrl.viewKey\">\n        </snapshot-widget>\n        <model-view>\n        </model-view>\n        <page-navigation\n          highlight=\"$ctrl.model.dataChanged\"\n          next=\"report\"\n          prev=\"blank\"\n        </page-navigation>\n      </div>\n    </div>\n  </div>\n  <session-notification>\n  </session-notification>\n  <solver-progress>\n  </solver-progress>\n  <error-notification>\n  </error-notification>\n</div>\n"

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(587);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(459);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseViewController = __webpack_require__(643);
	
	var _baseViewController2 = _interopRequireDefault(_baseViewController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestController = function (_BaseViewController) {
	    (0, _inherits3.default)(NestController, _BaseViewController);
	
	    function NestController($scope, $state, $rootScope, LoadedModel) {
	        (0, _classCallCheck3.default)(this, NestController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (NestController.__proto__ || (0, _getPrototypeOf2.default)(NestController)).call(this, $scope, $state, LoadedModel));
	
	        _this._$rootScope = $rootScope;
	        _this.viewKey = _this.nestViewKey;
	        var blankView = _this.model.getView(_this.blankViewKey);
	        var fisibilityView = _this.model.getView(_this.feasibilityViewKey);
	
	        if (_this.getCurrentView()) {
	            _this.loadCurrentView();
	        } else if (blankView) {
	            _this.loadView(blankView, _this.meshViewKey);
	        } else if (fisibilityView) {
	            _this.loadView(fisibilityView, _this.feasibilityViewKey);
	        } else if (_this.model.isStepPassed('nest')) {
	            _this.updateCurrentView(_this.model.getViewData('nest'));
	        } else if (_this.model.isStepPassed('feasibility')) {
	            _this.updateCurrentView(_this.model.getViewData('blank'), 'blank');
	        } else if (_this.model.isStepPassed('part')) {
	            _this._$state.go('feasibility');
	        } else {
	            _this._$state.go('home');
	        }
	        _this.updateCurrentView();
	        _this._masterNestValues = _this.model.getCurrNestValues();
	        _this.model.calculateUtilizationInfo();
	        return _this;
	    }
	
	    (0, _createClass3.default)(NestController, [{
	        key: 'isDataChanged',
	        value: function isDataChanged() {
	            this.model.dataChanged = (0, _stringify2.default)(this._masterNestValues) !== (0, _stringify2.default)(this.model.getCurrNestValues());
	            return !this.model.isStepPassed('nest') || this.model.dataChanged;
	        }
	    }, {
	        key: 'sendModel',
	        value: function sendModel() {
	            var _this2 = this;
	
	            this.requestInProgress = this.model.requestInProgress = true;
	            var uniqParam = this.model.uuid();
	            this.model.getProgress(uniqParam, 'nest', true);
	            this.model.sendData(this.viewKey, false, uniqParam).then(function (results) {
	                _this2.model.generateExpTime();
	                _this2.requestInProgress = _this2.model.requestInProgress = false;
	                var res = results.toJSON();
	                _this2.model.invalidateSnapshots('nest');
	                _lodash2.default.extend(_this2.model, res);
	                if (!res.nestN3) {
	                    delete _this2.model.nestN3;
	                }
	                _this2.updateCurrentView(_this2.model.getViewData('nest'));
	                _this2.model.calculateUtilizationInfo();
	                _this2._$scope.$broadcast('solverFinished', { step: 'nest' });
	                _this2._masterNestValues = _this2.model.getCurrNestValues();
	            }, function (error) {
	                _this2._$rootScope.$broadcast('showErrorDialog', { type: 'nest' });
	                _this2.model.generateExpTime();
	                _this2.requestInProgress = _this2.model.requestInProgress = false;
	            });
	        }
	    }]);
	    return NestController;
	}(_baseViewController2.default);
	
	NestController.$inject = ['$scope', '$state', '$rootScope', 'LoadedModel'];
	
	exports.default = NestController;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(332);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(334);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _report = __webpack_require__(667);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportModule = _angular2.default.module('report', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('report', {
	    url: '/report',
	    resolve: {
	      currentData: ["LoadedModel", function currentData(LoadedModel) {
	        return LoadedModel.getCurrentSession();
	      }]
	    },
	    component: 'report'
	  });
	}]).component('report', _report2.default).name;
	
	exports.default = reportModule;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _report = __webpack_require__(668);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _report3 = __webpack_require__(669);
	
	var _report4 = _interopRequireDefault(_report3);
	
	__webpack_require__(672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _report2.default,
	  controller: _report4.default
	};
	
	exports.default = reportComponent;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main-container\">\n  <navbar>\n  </navbar>\n  <div class=\"main-content\">\n    <div class=\"left\">\n      <div class=\"control-container\">\n        <div class=\"form-wrapper\">\n          <div class=\"row\">\n            <div class=\"form-group\">\n              <label class=\"control-label\">\n                Number of Parts\n              </label>\n              <input  awnum=\"\" num-sep=\".\" num-int=\"8\" num-fract=\"2\" type=\"text\" ng-model=\"$ctrl.model.partsNumber\" class=\"form-control default-element long-input\">\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label\">\n                Material price\n              </label>\n              <input  awnum=\"\" num-sep=\".\" num-int=\"4\" num-fract=\"2\" type=\"text\" ng-model=\"$ctrl.model.materialCost\" class=\"form-control default-element labeled-input\">\n              <span class=\"bold-text\">{{ $ctrl.priceUnit }}</span>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label\">\n                Scrap value\n              </label>\n              <input  awnum=\"\" num-sep=\".\" num-int=\"4\" num-fract=\"2\" type=\"text\" ng-model=\"$ctrl.model.scrapVal\" class=\"form-control default-element labeled-input\">\n              <span class=\"bold-text\">{{ $ctrl.priceUnit }}/ton</span>\n            </div>\n          </div>\n          <div class=\"row nest-info\">\n            <uib-tabset active=\"activeJustified\" justified=\"true\">\n              <uib-tab index=\"0\" heading=\"Costs\">\n                <uib-tab-heading>\n                  <div class=\"report-tab-header\">\n                    <span class=\"tab\">\n                      <span class=\"text\">Cost</span>\n                    </span>\n                    <span class=\"border-l\"></span>\n                  </div>\n                </uib-tab-heading>\n                <fieldset class=\"form-group report-table\">\n                  <div class=\"report-row\">\n                      <div class=\"report-cell-label\">Coil segment:</div>\n                      <div class=\"report-cell-value\">{{$ctrl.model.coilSegmentWeight / $ctrl.model.getWeightFactor() * $ctrl.model.materialCost | number : 2}}</div>\n                      <div class=\"report-cell-unit\">{{ $ctrl.priceUnit }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                      <div class=\"report-cell-label\">Scrap/part:</div>\n                      <div class=\"report-cell-value\">{{ ($ctrl.model.scrapVal * ($ctrl.model.coilSegmentWeight - $ctrl.model.partWeight))/1000 | number : 2 }}</div>\n                      <div class=\"report-cell-unit\">{{ $ctrl.priceUnit }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                      <div class=\"report-cell-label\">Total raw:</div>\n                      <div class=\"report-cell-value\">{{ $ctrl.model.materialCost * $ctrl.model.getTotalRaw() | number : 2}}</div>\n                      <div class=\"report-cell-unit\">{{ $ctrl.priceUnit }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Total scrap:</div>\n                    <div class=\"report-cell-value\">{{ ($ctrl.model.scrapVal * ($ctrl.model.coilSegmentWeight - $ctrl.model.partWeight))/1000 * $ctrl.model.partsNumber  | number : 2}}</div>\n                    <div class=\"report-cell-unit\">{{ $ctrl.priceUnit }}</div>\n                  </div>\n                </fieldset>\n              </uib-tab>\n              <uib-tab index=\"1\" heading=\"Weight\">\n                <uib-tab-heading>\n                  <div class=\"report-tab-header\">\n                    <span class=\"tab right\">\n                      <span class=\"text\">Weight</span>\n                    </span>\n                    <span class=\"border-r\"></span>\n                  </div>\n                </uib-tab-heading>\n                <fieldset class=\"form-group report-table\">\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Part:</div>\n                    <div class=\"report-cell-value\">{{ ($ctrl.model.partWeight  | number:  2) * 1  }}</div>\n                    <div class=\"report-cell-unit\">{{ $ctrl.model.partWeightUnits }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Blank:</div>\n                    <div class=\"report-cell-value\">{{ ($ctrl.model.blankWeight  | number:  2) * 1  }}</div>\n                    <div class=\"report-cell-unit\">{{ $ctrl.model.blankWeightUnits }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Coil segment:</div>\n                    <div class=\"report-cell-value\">{{ ($ctrl.model.coilSegmentWeight | number:  2) * 1  }}</div>\n                    <div class=\"report-cell-unit\">{{ $ctrl.model.coilSegmentWeightUnits }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Scrap/part:</div>\n                    <div class=\"report-cell-value\">{{ ($ctrl.model.coilSegmentWeight - $ctrl.model.partWeight  | number : 2 ) * 1}}</div>\n                    <div class=\"report-cell-unit\">{{ $ctrl.model.coilSegmentWeightUnits }}</div>\n                  </div>\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Total raw:</div>\n                    <div class=\"report-cell-value\">{{ ( $ctrl.model.getTotalRaw() | number : 2 ) * 1 }}</div>\n                    <div class=\"report-cell-unit\">tons</div>\n                  </div>\n                  <div class=\"report-row\">\n                    <div class=\"report-cell-label\">Total scrap:</div>\n                    <div class=\"report-cell-value\">{{ ( $ctrl.model.getTotalScrap() | number : 2) * 1}}</div>\n                    <div class=\"report-cell-unit\">tons</div>\n                  </div>\n                </fieldset>\n              </uib-tab>\n            </uib-tabset>\n          </div>\n        </div>\n        <div class=\"footer-wrapper\">\n          <div class=\"info-widget\">\n            <div>Part <strong>{{ $ctrl.model.fileName  }}</strong></div>\n            <div>Material <strong>{{ $ctrl.model.getHumanReadableName('material') }}</strong></div>\n            <div>Thickness <strong>{{ ($ctrl.model.thickness | number : 2) * 1 }} {{ $ctrl.model.systemsOfMeasurementUnit }}</strong></div>\n          </div>\n          <div class=\"help-button-left\">\n            <info-widget\n              topic=\"report\"\n              label=\"true\">\n            </info-widget>\n          </div>\n        </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"right\">\n      <div class=\"report-widget no-animate\">\n        <div class=\"report-image\" ng-repeat=\"snapshot in $ctrl.model.snapshots track by $index\">\n          <md-checkbox  ng-show=\"$ctrl.model.getSnapshotsLength() < 4 || $ctrl.model.getSnapshotsLength() === 4 && snapshot.selected\"  class=\"md-primary select-image\" ng-model=\"snapshot.selected\"></md-checkbox>\n          <div class=\"max-reached\" ng-show=\"$ctrl.model.getSnapshotsLength() === 4 && !snapshot.selected\">\n            <div>max. reached</div>\n          </div>\n          <img ng-class=\"{'selected': snapshot.selected && $ctrl.model.getSnapshotsLength() < 4}\" ng-src=\"{{ snapshot.image }}\">\n        </div>\n      <page-navigation\n        prev=\"nest\">\n      </page-navigation>\n      <button type=\"button\" ng-disabled=\"!$ctrl.model.getSnapshotsLength()\" class=\"btn button-plain order-report-button\" ng-click=\"$ctrl.openModal()\">\n        Request your Report\n        <span class=\"icon easyblank-icon\">R</span>\n      </button>\n    </div>\n  </div>\n  <session-notification>\n  </session-notification>\n  <solver-progress>\n  </solver-progress>\n  <error-notification>\n  </error-notification>\n  </div>\n</div>\n"

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(519);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(528);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(546);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _sendReportModal = __webpack_require__(670);
	
	var _sendReportModal2 = _interopRequireDefault(_sendReportModal);
	
	var _sendReportModal3 = __webpack_require__(671);
	
	var _sendReportModal4 = _interopRequireDefault(_sendReportModal3);
	
	var _baseViewController = __webpack_require__(643);
	
	var _baseViewController2 = _interopRequireDefault(_baseViewController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportController = function (_BaseViewController) {
	    (0, _inherits3.default)(ReportController, _BaseViewController);
	
	    function ReportController($scope, $state, LoadedModel, $uibModal) {
	        (0, _classCallCheck3.default)(this, ReportController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ReportController.__proto__ || (0, _getPrototypeOf2.default)(ReportController)).call(this, $scope, $state, LoadedModel));
	
	        _this._$uibModal = $uibModal;
	        var viewKey = _this.model.selectedReportView.value || _this.feasibilityViewKey;
	        _this.loadViewOrUpdate(viewKey);
	        _this.priceUnit = _this.model.priceUnit.value;
	        _this.takeAllSnapshots();
	        _this.model.restoreUserDetails();
	        return _this;
	    }
	
	    (0, _createClass3.default)(ReportController, [{
	        key: 'deleteSnapshot',
	        value: function deleteSnapshot(imageToDelete) {
	            this.model.snapshots = this.model.snapshots.filter(function (snapshot) {
	                return snapshot.index !== imageToDelete.index;
	            });
	        }
	    }, {
	        key: 'takeAllSnapshots',
	        value: function takeAllSnapshots() {
	            var _this2 = this;
	
	            var mapper = ['thinningView', 'formabilityView', 'blankView', 'nestView'];
	            if (!this.model.snapshots.length) {
	                mapper.forEach(function (type) {
	                    _this2.model.takeSnapshot(type, true);
	                });
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this._$uibModal.open({
	                size: 'sm',
	                animation: false,
	                template: _sendReportModal2.default,
	                controllerAs: '$ctrl',
	                controller: _sendReportModal4.default
	            });
	        }
	    }]);
	    return ReportController;
	}(_baseViewController2.default);
	
	ReportController.$inject = ['$scope', '$state', 'LoadedModel', '$uibModal'];
	
	exports.default = ReportController;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content report-modal\">\n  <form name=\"form\" novalidate ng-submit=\"$ctrl.ok(form)\" class=\"css-form\">\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div class=\"form-check\">\n        <label class=\"form-check-label inline-input\">\n          First Name\n          <input type=\"text\" ng-model=\"$ctrl.model.name\" required name=\"name\" class=\"form-control default-element input-s\">\n        </label>\n        <label class=\"form-check-label inline-input\">\n          Last Name\n          <input type=\"text\" ng-model=\"$ctrl.model.userLastName\" required name=\"userLastName\" class=\"form-control default-element input-s\">\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <label class=\"form-check-label inline-input\">\n          <div class=\"form-error-label\" ng-show=\"(form.$submitted || form.name.$touched) && form.name.$invalid\">\n            <span>First name is required</span>\n          </div>\n        </label>\n        <label class=\"form-check-label inline-input\">\n          <div class=\"form-error-label\" ng-show=\"(form.$submitted || form.userLastName.$touched) && form.userLastName.$invalid\">\n            <span>Last Name is required</span>\n          </div>\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <label class=\"form-check-label\">\n          Organization Name:\n          <div  class=\"input-container\">\n            <input type=\"text\" ng-model=\"$ctrl.model.organization\" name=\"organization\"  class=\"form-control default-element input-l\">\n          </div>\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <label class=\"form-check-label\">\n          Email:\n          <div  class=\"input-container\">\n            <input type=\"email\" ng-model=\"$ctrl.model.email\" required name=\"email\"  ng-class=\"{'data-checked': form.email.$valid}\" class=\"form-control default-element input-l\">\n            <span ng-show=\"form.email.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>\n          </div>\n          <div class=\"form-error-label\" ng-show=\"(form.$submitted || form.email.$touched) && form.email.$invalid\">\n            <span ng-show=\"form.email.$error.required\">Email is required</span>\n            <span ng-show=\"form.email.$error.email\">Email is not valid</span>\n          </div>\n        </label>\n      </div>\n      <div class=\"form-checked\">\n        <md-checkbox class=\"md-primary\" ng-model=\"$ctrl.model.addNumber\">\n          Contact me via phone\n        </md-checkbox>\n      </div>\n      <div ng-if=\"$ctrl.model.addNumber\" class=\"form-check\">\n        <label class=\"phone-label\">\n          Phone number\n        </label>\n        <div>\n          <label class=\"form-check-label inline-input\">\n            <label>+</label>\n            <input awnum=\"\" num-int=\"5\" num-fract=\"0\" type=\"text\" ng-model=\"$ctrl.model.phoneCode\" ng-class=\"{'checked': form.phoneCode.$valid}\" required name=\"phoneCode\" class=\"form-control phone-code default-element input-s\">\n            <span ng-show=\"form.phoneCode.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>\n          </label>\n          <label class=\"form-check-label inline-input\">\n            <input awnum=\"\" num-int=\"11\" num-fract=\"0\" type=\"text\" ng-model=\"$ctrl.model.phone\" required name=\"phone\"  ng-class=\"{'checked': form.phone.$valid}\" class=\"form-control phone default-element input-s\">\n            <span ng-show=\"form.phone.$valid\" file-upload class=\"input-checked-button\"><span class=\"icon easyblank-icon\">D</span></span>\n          </label>\n        </div>\n      </div>\n    </div>\n    <div clas=\"form-check\">\n      <div class=\"capcha-container\">\n        <captcha-with-fallback on-init=\"$ctrl.onCaptchaInit(validate)\"></captcha-with-fallback>\n        <div class=\"form-error-label\" ng-show=\"$ctrl.catpchaIsInvalid\"><span>Invalid captcha code</span></div>\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn button-cancel\" ng-disabled=\"$ctrl.model.requestInProgress\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n        <button class=\"btn button-plain\" ng-disabled=\"$ctrl.model.requestInProgress || form.$invalid\">\n          </span>Send Report</span>\n          <span class=\"icon-button-container\">\n            <span class=\"icon easyblank-icon button-icon\">S</span>\n          </span>\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(567);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _notificationModal = __webpack_require__(644);
	
	var _notificationModal2 = _interopRequireDefault(_notificationModal);
	
	var _notificationModal3 = __webpack_require__(645);
	
	var _notificationModal4 = _interopRequireDefault(_notificationModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SendReportController = function () {
	  function SendReportController($uibModalInstance, $rootScope, $scope, LoadedModel, $uibModal) {
	    (0, _classCallCheck3.default)(this, SendReportController);
	
	    this._$rootScope = $rootScope;
	    this._$uibModal = $uibModal;
	    this._$scope = $scope;
	    this.model = LoadedModel;
	    // this.model.email = '';
	    // this.model.name = '';
	    // this.model.company = '';
	    // this.model.phone = '';
	    // this.model.userLastName = '';
	    // this.model.phoneCode = '';
	    // this.model.addNumber = false;
	    this._$uibModalInstance = $uibModalInstance;
	    this._captchaValidate = function () {
	      return _promise2.default.reject();
	    };
	  }
	
	  (0, _createClass3.default)(SendReportController, [{
	    key: 'onCaptchaInit',
	    value: function onCaptchaInit(validate) {
	      this._captchaValidate = validate;
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(_message) {
	      this._$uibModal.open({
	        animation: false,
	        template: _notificationModal4.default,
	        controllerAs: '$ctrl',
	        size: 'sm',
	        resolve: {
	          message: function message() {
	            return _message;
	          }
	        },
	        controller: _notificationModal2.default
	      });
	    }
	  }, {
	    key: 'ok',
	    value: function ok(form) {
	      var _this = this;
	
	      if (form.$valid) {
	        this._captchaValidate().then(function () {
	          _this.requestInProgress = _this.model.requestInProgress = true;
	          _this._$rootScope.$broadcast('solverStarted', 'report');
	          _this._$uibModalInstance.close();
	          var timeStamp = _this.model.uuid();
	          _this.model.saveUserDetails();
	          _this.model.getProgress(timeStamp, 'report', true);
	          _this.model.sendReport(timeStamp);
	          _this._$rootScope.$$listeners['sendReportData'] = [];
	          _this._$rootScope.$on('sendReportData', function (event, result) {
	            if (result.notification === 'yes') {
	              _this.openModal('Report was sent. We will contact you soon.');
	            } else {
	              _this.openModal('Report was sent.');
	            }
	          });
	        }, function () {
	          return _this.catpchaIsInvalid = true;
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this._$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	  return SendReportController;
	}();
	
	SendReportController.$inject = ['$uibModalInstance', '$rootScope', '$scope', 'LoadedModel', '$uibModal'];
	
	exports.default = SendReportController;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(673);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./report-widget.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./report-widget.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, ".base-gradient,.main-container,.modal-content,.report-widget .report-image{background:linear-gradient(0deg,#cdcdcd,#fefefe,#cdcdcd)}body{height:100%;font:62.5% helvetica,arial,verdana,sans-serif}.css-form input.ng-invalid.ng-touched{background-color:#fa787e}.button-general,.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev{border-radius:0;color:#fff}.button-general:focus,.button-general:hover,.button-navigation:focus,.button-navigation:hover,button.button-cancel:focus,button.button-cancel:hover,button.button-next:focus,button.button-next:hover,button.button-plain:focus,button.button-plain:hover,button.button-prev:focus,button.button-prev:hover{color:#fff}.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev{padding:10px 20px;border-width:1px;border-color:#fff;background-color:#406494}button.button-cancel{background-color:#999}.button-icon,button.button-next .button-arrow{margin-left:5px}button.button-prev .button-arrow{margin-right:5px}.capcha-container{padding:0 17px}.form-error-label{color:red;font-style:italic}select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\"}.utilization-info{margin-top:20px}.utilization-info,.utilization-info .table-row{margin-bottom:10px}.input-error{background-color:#fa787e!important}html{height:100%}body,html{min-width:1500px}body{min-height:100%}.app,.main-container{height:100%;min-width:1500px}.main-container{overflow:hidden}.main-container .main-content{height:100%}.main-container .main-content .right{float:none;width:auto;overflow:auto;height:100%;padding:10px}.main-container .main-content .left{padding:10px;height:100%;width:350px;float:left}.main-container .main-content .left .control-container{position:absolute;width:350px;bottom:10px;top:62px;background:linear-gradient(0deg,#e8e7e7,#fff,#e8e7e7)}form .form-group{margin-bottom:10px}form .text-labels{margin-bottom:22px}.form-group .default-element,form .default-element,form .file-input,form .file-input-button,form .select{border-radius:0}.form-group .labeled-input,form .labeled-input{width:260px;display:inline}.form-group .long-input,form .long-input{width:300px;display:inline}.form-group .bold-text,form .bold-text{font-weight:700}form .file-input,form .file-input-button{color:#020202;border-color:#406494;background-color:#406494}form .file-input-button{color:#fff;padding:6px 8px}form .file-input-button:hover{color:#fff}.info-widget{position:absolute;bottom:30px}.modal-md{width:550px}.modal-sm{width:400px}.form-wrapper{position:absolute;padding:30px;bottom:95px;top:0;overflow:auto;width:100%}.footer-wrapper{padding-left:30px;padding-right:30px}.apply-container{width:305px}button.button-next.data-changed-nest,button.button-plain.data-changed-nest{background-color:#a21502}.report-widget .report-image{width:48%;margin:3px;display:inline-block;position:relative}.report-widget .report-image img{width:100%;padding:2px;border:1px solid gray}.report-widget .report-image img.selected{border:1px solid #3f6493!important}.report-widget .report-image .select-image{position:absolute;right:-2px;top:8px}.modal-sm{width:345px!important}.modal-content .input-l{width:300px}.inline-input input{width:150px}.inline-input input.phone-code{display:inline;width:92px}.inline-input input.phone-code.checked{width:57px;display:inline}.inline-input input.phone{width:200px;display:inline}.inline-input input.phone.checked{width:165px;display:inline}.inline-input .phone-label{display:block}.order-report-button{position:absolute;right:20px;bottom:20px}.max-reached{position:absolute;right:0;background-color:silver;color:#eee}.max-reached div{margin:5px}.report-table{display:table;border:1px solid #406494;padding:12px}.report-row{display:table-row;height:25px}.report-cell-label{display:table-cell;width:220px}.report-cell-value{display:table-cell;width:75px;text-align:right}.report-cell-unit{display:table-cell;width:40px;text-align:right}input.data-checked{width:calc(100% - 41px)!important;border-color:#28cc39;display:inline}.input-container{width:306px}.input-checked-button{color:#fff;border-color:#28cc39;background-color:#28cc39;margin-left:-5px;border-radius:0;padding:7px;display:inline-block}.nest-info .report-tab-header{text-align:left}.nest-info a{background-color:inherit!important;border:inherit!important;padding:0!important}.nest-info li.active .tab{color:#fff;background-color:#406494;display:inline-block;text-align:center;width:135px;height:30px;margin-bottom:-6px;margin-left:2px;font-weight:700}.nest-info li.active .tab.right{margin-bottom:-6px;margin-right:-117px}.nest-info{width:302px}.nest-info li .tab.right .text{position:absolute;top:-4px;left:-47px}.nest-info li.active .tab .text{position:absolute;top:6px;left:13px}.nest-info li .tab .text{margin-left:17px}.active .border-l{left:137px;border-width:30px 0 0 17px;border-color:transparent transparent transparent #406494}.active .border-l,.active .border-r{position:absolute;border-style:solid;display:inline-block}.active .border-r{border-width:0 0 30px 17px;border-color:transparent transparent #406494;left:-14px}.icon-button-container{display:inline-block;width:15px}.icon-button-container .button-icon{position:absolute;font-size:22px;bottom:25px;right:22px}.report-image md-checkbox .md-icon{margin:8px;cursor:pointer;padding-left:18px;padding-right:0;line-height:26px;min-width:25px;min-height:25px;margin-top:-8px;margin-left:3px}.report-image md-checkbox .md-icon:after{padding-left:10px}", ""]);
	
	// exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(675);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/stylus-loader/index.js!./components.styl", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/stylus-loader/index.js!./components.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, ".base-gradient,.main-container{background:linear-gradient(0deg,#cdcdcd,#fefefe,#cdcdcd)}body{height:100%;font:62.5% helvetica,arial,verdana,sans-serif}.css-form input.ng-invalid.ng-touched{background-color:#fa787e}.button-general,.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev{border-radius:0;color:#fff}.button-general:focus,.button-general:hover,.button-navigation:focus,.button-navigation:hover,button.button-cancel:focus,button.button-cancel:hover,button.button-next:focus,button.button-next:hover,button.button-plain:focus,button.button-plain:hover,button.button-prev:focus,button.button-prev:hover{color:#fff}.button-navigation,button.button-cancel,button.button-next,button.button-plain,button.button-prev{padding:10px 20px;border-width:1px;border-color:#fff;background-color:#406494}button.button-cancel{background-color:#999}.button-icon,button.button-next .button-arrow{margin-left:5px}button.button-prev .button-arrow{margin-right:5px}.capcha-container{padding:0 17px}.form-error-label{color:red;font-style:italic}select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\"}.utilization-info{margin-top:20px}.utilization-info,.utilization-info .table-row{margin-bottom:10px}.input-error{background-color:#fa787e!important}html{height:100%}body,html{min-width:1500px}body{min-height:100%}.app,.main-container{height:100%;min-width:1500px}.main-container{overflow:hidden}.main-container .main-content{height:100%}.main-container .main-content .right{float:none;width:auto;overflow:auto;height:100%;padding:10px}.main-container .main-content .left{padding:10px;height:100%;width:350px;float:left}.main-container .main-content .left .control-container{position:absolute;width:350px;bottom:10px;top:62px;background:linear-gradient(0deg,#e8e7e7,#fff,#e8e7e7)}form .form-group{margin-bottom:10px}form .text-labels{margin-bottom:22px}.form-group .default-element,form .default-element,form .file-input,form .file-input-button,form .select{border-radius:0}.form-group .labeled-input,form .labeled-input{width:260px;display:inline}.form-group .long-input,form .long-input{width:300px;display:inline}.form-group .bold-text,form .bold-text{font-weight:700}form .file-input,form .file-input-button{color:#020202;border-color:#406494;background-color:#406494}form .file-input-button{color:#fff;padding:6px 8px}form .file-input-button:hover{color:#fff}.info-widget{position:absolute;bottom:30px}.modal-md{width:550px}.modal-sm{width:400px}.form-wrapper{position:absolute;padding:30px;bottom:95px;top:0;overflow:auto;width:100%}.footer-wrapper{padding-left:30px;padding-right:30px}.apply-container{width:305px}button.button-next.data-changed-nest,button.button-plain.data-changed-nest{background-color:#a21502}", ""]);
	
	// exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(677);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(678);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E',
	  controller: _app4.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"app\" ui-view>\n</div>\n"

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _warnModal = __webpack_require__(679);
	
	var _warnModal2 = _interopRequireDefault(_warnModal);
	
	var _warnModal3 = __webpack_require__(680);
	
	var _warnModal4 = _interopRequireDefault(_warnModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppController = function () {
	  function AppController($scope, $state, $uibModal) {
	    (0, _classCallCheck3.default)(this, AppController);
	
	
	    this._$uibModal = $uibModal;
	
	    var countTabs = localStorage.getItem('openpages') || 0;
	
	    if (localStorage.getItem('openpages') > 0) {
	      // this.openHelpWindow();
	      // localStorage.setItem('openpages', ++countTabs);
	    } else {
	        // localStorage.setItem('openpages', ++countTabs);
	      }
	
	    window.onbeforeunload = function () {
	      countTabs = localStorage.getItem('openpages') || 0;
	      if (countTabs > 0) {
	        // localStorage.setItem('openpages', --countTabs);
	      }
	    };
	  }
	
	  (0, _createClass3.default)(AppController, [{
	    key: 'openHelpWindow',
	    value: function openHelpWindow() {
	      var _this = this;
	
	      this._$uibModal.open({
	        animation: false,
	        template: _warnModal4.default,
	        controllerAs: '$ctrl',
	        size: 'sm',
	        resolve: {
	          type: function type() {
	            return _this.topic;
	          }
	        },
	        controller: _warnModal2.default
	      });
	    }
	  }]);
	  return AppController;
	}();
	
	;
	
	AppController.$inject = ['$scope', '$state', '$uibModal'];
	
	exports.default = AppController;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(420);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(421);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WarnModalController = function () {
	    function WarnModalController($uibModalInstance, type) {
	        (0, _classCallCheck3.default)(this, WarnModalController);
	
	        this.type = type;
	        this._$uibModalInstance = $uibModalInstance;
	    }
	
	    (0, _createClass3.default)(WarnModalController, [{
	        key: 'cancel',
	        value: function cancel() {
	            this._$uibModalInstance.close();
	        }
	    }, {
	        key: 'next',
	        value: function next() {}
	    }]);
	    return WarnModalController;
	}();
	
	WarnModalController.$inject = ['$uibModalInstance', 'type'];
	
	exports.default = WarnModalController;

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-content help-modal\">\n  <form name=\"form\" novalidate class=\"css-form\">\n  </form>\n</div>\n\n<div class=\"modal-content help-modal\">\n<div class=\"css-form\">\n<div class=\"modal-body\" id=\"modal-body\">\n  <p>\n    <strong>Warning</strong>\n  </p>\n  <p>\n    It seems you opened more then one tab. It can distort report results. Please use only one tab simultaneously.\n  </p>\n  <div class=\"modal-footer\">\n    <button class=\"btn button-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n  </div>\n</div>\n</div>\n</div>\n"

/***/ }),
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(696);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(444)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./icons.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./icons.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(443)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:easyblank;src:url(" + __webpack_require__(697) + ") format(\"woff\");font-weight:400;font-style:normal}.easyblank-icon{font-family:easyblank;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);
	
	// exports


/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js